export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    /** Custom Date scalar type */
    DateTime: { input: string; output: string };
    Long: { input: number; output: number };
    /** The `Upload` scalar type represents a file upload. */
    Upload: { input: File; output: File };
    Void: { input: void; output: void };
    _Any: { input: any; output: any };
    _FieldSet: { input: any; output: any };
};

export type AbLogExposureRequest = {
    readonly studyTreatmentInfo?: InputMaybe<ReadonlyArray<StudyTreatmentInfo>>;
};

export type AppAuthorizedOperation = {
    readonly __typename?: "AppAuthorizedOperation";
    readonly authOperation?: Maybe<MyLensesAuthOperation>;
    readonly authOperationTypes?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
};

export type AppInfo = {
    readonly __typename?: "AppInfo";
    readonly apiTokens?: Maybe<ReadonlyArray<Maybe<MyLensesApiToken>>>;
    readonly appAuthorizedOperations?: Maybe<ReadonlyArray<AppAuthorizedOperation>>;
    readonly appIconUrl?: Maybe<Scalars["String"]["output"]>;
    readonly appId?: Maybe<Scalars["String"]["output"]>;
    readonly appVendorUuidOptinFlag?: Maybe<Scalars["Boolean"]["output"]>;
    readonly internalAppName?: Maybe<Scalars["String"]["output"]>;
    readonly orgId?: Maybe<Scalars["String"]["output"]>;
    readonly platformType?: Maybe<MyLensesPlatformType>;
    readonly prodLiveVersion?: Maybe<Scalars["Int"]["output"]>;
    readonly stagingLiveVersion?: Maybe<Scalars["Int"]["output"]>;
    readonly versions?: Maybe<ReadonlyArray<MyLensesAppVersion>>;
};

export type ApplicationAuthorizedOperationsRequest = {
    readonly __typename?: "ApplicationAuthorizedOperationsRequest";
    readonly appId?: Maybe<Scalars["String"]["output"]>;
};

export type ApplicationAuthorizedOperationsResponse = {
    readonly __typename?: "ApplicationAuthorizedOperationsResponse";
    readonly appAuthorizedOperations?: Maybe<ReadonlyArray<Maybe<AppAuthorizedOperation>>>;
};

export enum AspectRatioType {
    NineBySixteen = "NINE_BY_SIXTEEN",
    ThreeByFour = "THREE_BY_FOUR",
}

export enum AssetLibraryFileExtensions {
    Dnn = "dnn",
    Fbx = "fbx",
    Gif = "gif",
    Glb = "glb",
    Gltf = "gltf",
    Jpeg = "jpeg",
    Jpg = "jpg",
    Lensanim = "lensanim",
    Lsc = "lsc",
    Lsmat = "lsmat",
    Lso = "lso",
    Lspkg = "lspkg",
    Lsscript = "lsscript",
    Mp3 = "mp3",
    Mp4 = "mp4",
    Obj = "obj",
    Ogg = "ogg",
    Onnx = "onnx",
    Oprfb = "oprfb",
    Png = "png",
    T3d = "t3d",
    Tflite = "tflite",
    Ts = "ts",
    Wav = "wav",
    Zip = "zip",
}

export type AssetOrganization = {
    readonly __typename?: "AssetOrganization";
    readonly id: Scalars["ID"]["output"];
    readonly name: Scalars["String"]["output"];
};

export type AssetRejection = {
    readonly __typename?: "AssetRejection";
    readonly message: Scalars["String"]["output"];
    readonly reason: Scalars["String"]["output"];
};

export enum AssetType {
    AssetPackage = "ASSET_PACKAGE",
    CustomComponent = "CUSTOM_COMPONENT",
    Default = "DEFAULT",
    Plugin = "PLUGIN",
    Template = "TEMPLATE",
}

export type AssignOrgToAssetRequest = {
    readonly assetId: Scalars["ID"]["input"];
    readonly organizationId: Scalars["ID"]["input"];
    readonly organizationName: Scalars["String"]["input"];
};

export type AssignOrgToAssetResponse = {
    readonly __typename?: "AssignOrgToAssetResponse";
    readonly assetId: Scalars["String"]["output"];
};

export type AssistantChatInput = {
    readonly history: ReadonlyArray<AssistantChatTurnInput>;
    readonly question: Scalars["String"]["input"];
};

export type AssistantChatResponse = {
    readonly __typename?: "AssistantChatResponse";
    readonly answer: Scalars["String"]["output"];
    readonly sources: ReadonlyArray<AssistantSource>;
};

export type AssistantChatTurnInput = {
    readonly prompt: Scalars["String"]["input"];
    readonly response: Scalars["String"]["input"];
};

export type AssistantSource = {
    readonly __typename?: "AssistantSource";
    readonly content: Scalars["String"]["output"];
    readonly id: Scalars["String"]["output"];
    readonly link: Scalars["String"]["output"];
    readonly relevanceScore: Scalars["Float"]["output"];
};

export type BulkPatchRemoteAssetResult = {
    readonly __typename?: "BulkPatchRemoteAssetResult";
    readonly asset?: Maybe<RemoteAsset>;
    readonly assetId: Scalars["ID"]["output"];
    readonly error?: Maybe<RemoteAssetError>;
};

export type BulkPatchRemoteAssetsInput = {
    readonly assetIds: ReadonlyArray<Scalars["ID"]["input"]>;
    readonly forkingAllowed: Scalars["Boolean"]["input"];
    readonly organizationId: Scalars["ID"]["input"];
};

export type BulkPatchRemoteAssetsResponse = {
    readonly __typename?: "BulkPatchRemoteAssetsResponse";
    readonly results: ReadonlyArray<BulkPatchRemoteAssetResult>;
};

export type BusinessProfile = {
    readonly __typename?: "BusinessProfile";
    readonly id?: Maybe<Scalars["ID"]["output"]>;
    readonly name?: Maybe<Scalars["String"]["output"]>;
};

export type CameraKitLens = {
    readonly __typename?: "CameraKitLens";
    readonly compoundId?: Maybe<LensCompoundId>;
    readonly createdAt?: Maybe<GoogleProtobufTimestamp>;
    readonly creatorName?: Maybe<Scalars["String"]["output"]>;
    readonly hasMusic?: Maybe<Scalars["Boolean"]["output"]>;
    readonly iconUrl?: Maybe<Scalars["String"]["output"]>;
    readonly labels?: Maybe<ReadonlyArray<Maybe<Label>>>;
    readonly lensSourceInfo?: Maybe<LenssourceModelLensSourceInfo>;
    readonly lensStatus?: Maybe<MyLensesLensStatus>;
    readonly minSdkVersion?: Maybe<Scalars["String"]["output"]>;
    readonly minWebSdkVersion?: Maybe<Scalars["String"]["output"]>;
    readonly name?: Maybe<Scalars["String"]["output"]>;
    readonly previewUrl?: Maybe<Scalars["String"]["output"]>;
    readonly previewWebpUrl?: Maybe<Scalars["String"]["output"]>;
    readonly removed?: Maybe<Scalars["Boolean"]["output"]>;
    /** @deprecated deprecated in proto */
    readonly reviewStatus?: Maybe<Scalars["String"]["output"]>;
    readonly snapcode?: Maybe<Snapcode>;
    readonly thumbnailWebpUrl?: Maybe<Scalars["String"]["output"]>;
    readonly updatedAt?: Maybe<GoogleProtobufTimestamp>;
    readonly vendorData?: Maybe<ReadonlyArray<Maybe<VendorDataItem>>>;
    readonly videoUrl?: Maybe<Scalars["String"]["output"]>;
};

export type CameraKitOrganization = {
    readonly __typename?: "CameraKitOrganization";
    readonly accountIds?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    readonly apps?: Maybe<ReadonlyArray<AppInfo>>;
    readonly appsManagementEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    readonly id?: Maybe<Scalars["String"]["output"]>;
    readonly internalLabels?: Maybe<InternalLabels>;
    readonly name?: Maybe<Scalars["String"]["output"]>;
    readonly orgAuthorizedOperations?: Maybe<ReadonlyArray<AppAuthorizedOperation>>;
    readonly permissions?: Maybe<UserPermissions>;
    readonly platformType?: Maybe<OrganizationPlatformType>;
    readonly role?: Maybe<OrganizationUserRole>;
};

export type CameraKitPermissions = {
    readonly __typename?: "CameraKitPermissions";
    readonly permissions?: Maybe<UserPermissions>;
};

export type CameraKitPermissionsRequest = {
    readonly entityName: Scalars["String"]["input"];
};

export type CameraKitPortalMeResponse = {
    readonly __typename?: "CameraKitPortalMeResponse";
    readonly me?: Maybe<MyLensesPortalMe>;
};

export type ChildResources = {
    readonly __typename?: "ChildResources";
    readonly cursor: Scalars["String"]["output"];
    readonly resourceList: ReadonlyArray<ResourceContainer>;
};

export type ChildResourcesRequest = {
    readonly cursor: Scalars["String"]["input"];
    readonly kind: ResourceKind;
    readonly limit: Scalars["Int"]["input"];
    readonly parentId: Scalars["String"]["input"];
};

export enum CofConfigId {
    MyLensesBanner = "MY_LENSES_BANNER",
    MyLensesChat = "MY_LENSES_CHAT",
    MyLensesCreatorPayout = "MY_LENSES_CREATOR_PAYOUT",
    MyLensesCreatorPayoutNoApplication = "MY_LENSES_CREATOR_PAYOUT_NO_APPLICATION",
    MyLensesCreatorRewardRecord = "MY_LENSES_CREATOR_REWARD_RECORD",
    MyLensesCta = "MY_LENSES_CTA",
    MyLensesDeprecateBusinessFlow = "MY_LENSES_DEPRECATE_BUSINESS_FLOW",
    MyLensesDisableInDiscover = "MY_LENSES_DISABLE_IN_DISCOVER",
    MyLensesDiscoverabilityTagsV1 = "MY_LENSES_DISCOVERABILITY_TAGS_V1",
    MyLensesFeedbackRating = "MY_LENSES_FEEDBACK_RATING",
    MyLensesGameToggle = "MY_LENSES_GAME_TOGGLE",
    MyLensesGlobalNav = "MY_LENSES_GLOBAL_NAV",
    MyLensesGraphqlFederation = "MY_LENSES_GRAPHQL_FEDERATION",
    MyLensesHomeTab = "MY_LENSES_HOME_TAB",
    MyLensesHostedLenses = "MY_LENSES_HOSTED_LENSES",
    MyLensesIldgFtue = "MY_LENSES_ILDG_FTUE",
    MyLensesIldgFtueBanner = "MY_LENSES_ILDG_FTUE_BANNER",
    MyLensesIlp = "MY_LENSES_ILP",
    MyLensesLensChallengeTags = "MY_LENSES_LENS_CHALLENGE_TAGS",
    MyLensesLensCloudProvisioning = "MY_LENSES_LENS_CLOUD_PROVISIONING",
    MyLensesLensCreatorRewardsDetails = "MY_LENSES_LENS_CREATOR_REWARDS_DETAILS",
    MyLensesLensCreatorRewardsInsights = "MY_LENSES_LENS_CREATOR_REWARDS_INSIGHTS",
    MyLensesLensDescription = "MY_LENSES_LENS_DESCRIPTION",
    MyLensesLensMakerDebug = "MY_LENSES_LENS_MAKER_DEBUG",
    MyLensesLensPlusPhoneVerification = "MY_LENSES_LENS_PLUS_PHONE_VERIFICATION",
    MyLensesLensTaxonomy = "MY_LENSES_LENS_TAXONOMY",
    MyLensesMaintenanceMode = "MY_LENSES_MAINTENANCE_MODE",
    MyLensesManageMembersButton = "MY_LENSES_MANAGE_MEMBERS_BUTTON",
    MyLensesMonetizationInsights = "MY_LENSES_MONETIZATION_INSIGHTS",
    MyLensesOrgsV2 = "MY_LENSES_ORGS_V2",
    MyLensesOrgLevelScope = "MY_LENSES_ORG_LEVEL_SCOPE",
    MyLensesPortalUnification = "MY_LENSES_PORTAL_UNIFICATION",
    MyLensesQara = "MY_LENSES_QARA",
    MyLensesRemoteApiBuiltInProcessor = "MY_LENSES_REMOTE_API_BUILT_IN_PROCESSOR",
    MyLensesRemoteApiHttp = "MY_LENSES_REMOTE_API_HTTP",
    MyLensesRemoteAssets = "MY_LENSES_REMOTE_ASSETS",
    MyLensesSpecsCommerce = "MY_LENSES_SPECS_COMMERCE",
    MyLensesSpectaclesRnTagsMultiPreviews = "MY_LENSES_SPECTACLES_RN_TAGS_MULTI_PREVIEWS",
    MyLensesSpectaclesSubmission = "MY_LENSES_SPECTACLES_SUBMISSION",
    MyLensesSpectaclesVideoPreview = "MY_LENSES_SPECTACLES_VIDEO_PREVIEW",
    MyLensesStandardEventReporting = "MY_LENSES_STANDARD_EVENT_REPORTING",
    MyLensesSubmissionErrorReporting = "MY_LENSES_SUBMISSION_ERROR_REPORTING",
    MyLensesSubmissionQuotas = "MY_LENSES_SUBMISSION_QUOTAS",
    MyLensesTrendingTags = "MY_LENSES_TRENDING_TAGS",
    MyLensesUiAssetLibrary = "MY_LENSES_UI_ASSET_LIBRARY",
    MyLensesUiCommunityAudience = "MY_LENSES_UI_COMMUNITY_AUDIENCE",
    MyLensesUiCommunityAudienceMetricsHidden = "MY_LENSES_UI_COMMUNITY_AUDIENCE_METRICS_HIDDEN",
    MyLensesUiFgTest = "MY_LENSES_UI_FG_TEST",
    MyLensesUiWebApis = "MY_LENSES_UI_WEB_APIS",
    MyLensesUxImprovements = "MY_LENSES_UX_IMPROVEMENTS",
    MyLensesWebLensPublication = "MY_LENSES_WEB_LENS_PUBLICATION",
}

export enum CofNamespace {
    AbConsole = "AB_CONSOLE",
    AbSegment = "AB_SEGMENT",
    AbStudyVersion = "AB_STUDY_VERSION",
    ActivationCore = "ACTIVATION_CORE",
    ActivityCenter = "ACTIVITY_CENTER",
    Addlive = "ADDLIVE",
    AddliveCore = "ADDLIVE_CORE",
    AddliveRanking = "ADDLIVE_RANKING",
    AddliveUi = "ADDLIVE_UI",
    AdsGatewayCore = "ADS_GATEWAY_CORE",
    AdsGeneral = "ADS_GENERAL",
    AdsInterfacesUi = "ADS_INTERFACES_UI",
    AdsLift = "ADS_LIFT",
    AdsManagerUi = "ADS_MANAGER_UI",
    AdsMarketplaceDynamics = "ADS_MARKETPLACE_DYNAMICS",
    AdsRankingApp = "ADS_RANKING_APP",
    AdsRankingDpa = "ADS_RANKING_DPA",
    AdsRankingInApp = "ADS_RANKING_IN_APP",
    AdsRankingPixel = "ADS_RANKING_PIXEL",
    AdClient = "AD_CLIENT",
    AdKitCore = "AD_KIT_CORE",
    AdModeration = "AD_MODERATION",
    AllMixerInfra = "ALL_MIXER_INFRA",
    Ares = "ARES",
    Atlas = "ATLAS",
    Billboard = "BILLBOARD",
    BitmojiContent = "BITMOJI_CONTENT",
    BitmojiCore = "BITMOJI_CORE",
    BitmojiUi = "BITMOJI_UI",
    BlizzardBackend = "BLIZZARD_BACKEND",
    BlizzardClient = "BLIZZARD_CLIENT",
    BoostCore = "BOOST_CORE",
    BudgetAbConfigmentIntegration = "BUDGET_AB_CONFIGMENT_INTEGRATION",
    BusinessManagerUi = "BUSINESS_MANAGER_UI",
    CameosCore = "CAMEOS_CORE",
    CameosRanking = "CAMEOS_RANKING",
    CameosUi = "CAMEOS_UI",
    Camera = "CAMERA",
    CameraBusiness = "CAMERA_BUSINESS",
    CameraKitCore = "CAMERA_KIT_CORE",
    CameraKitWebCore = "CAMERA_KIT_WEB_CORE",
    CameraPlatform = "CAMERA_PLATFORM",
    CameraPlatformRanking = "CAMERA_PLATFORM_RANKING",
    CameraPlatformUi = "CAMERA_PLATFORM_UI",
    CameraUi = "CAMERA_UI",
    CdnRouting = "CDN_ROUTING",
    ClientHealthInsights = "CLIENT_HEALTH_INSIGHTS",
    ClientHealthInsightsHoldout = "CLIENT_HEALTH_INSIGHTS_HOLDOUT",
    ClientSwitchboard = "CLIENT_SWITCHBOARD",
    CodelabsSandbox = "CODELABS_SANDBOX",
    Cof = "COF",
    CognacCore = "COGNAC_CORE",
    CognacUi = "COGNAC_UI",
    CommerceBackend = "COMMERCE_BACKEND",
    CommerceCore = "COMMERCE_CORE",
    CommerceRanking = "COMMERCE_RANKING",
    CommerceUi = "COMMERCE_UI",
    CommunityCore = "COMMUNITY_CORE",
    CommunityRanking = "COMMUNITY_RANKING",
    CommunityUi = "COMMUNITY_UI",
    ConfigRollout = "CONFIG_ROLLOUT",
    ContentHoldout = "CONTENT_HOLDOUT",
    ContentLiftMeasurement = "CONTENT_LIFT_MEASUREMENT",
    ContentNuxHoldout = "CONTENT_NUX_HOLDOUT",
    ContentSearchL3 = "CONTENT_SEARCH_L3",
    ContentSearchRanking = "CONTENT_SEARCH_RANKING",
    ContentSearchRetrieval = "CONTENT_SEARCH_RETRIEVAL",
    ContentTrends = "CONTENT_TRENDS",
    ContextBackend = "CONTEXT_BACKEND",
    ContextCore = "CONTEXT_CORE",
    ContextUi = "CONTEXT_UI",
    CoreClientFrameworks = "CORE_CLIENT_FRAMEWORKS",
    CreativeToolsCore = "CREATIVE_TOOLS_CORE",
    CreativeToolsUi = "CREATIVE_TOOLS_UI",
    CreatorNotificationHoldout = "CREATOR_NOTIFICATION_HOLDOUT",
    Default = "DEFAULT",
    DfRqms = "DF_RQMS",
    DiscoverCore = "DISCOVER_CORE",
    DiscoverExploration = "DISCOVER_EXPLORATION",
    DiscoverNotifRetrievalL1 = "DISCOVER_NOTIF_RETRIEVAL_L1",
    DiscoverRanking = "DISCOVER_RANKING",
    DiscoverRankingL2 = "DISCOVER_RANKING_L2",
    DiscoverRetrievalL0 = "DISCOVER_RETRIEVAL_L0",
    DiscoverRetrievalL1 = "DISCOVER_RETRIEVAL_L1",
    DiscoverUi = "DISCOVER_UI",
    DynamicDeeplinking = "DYNAMIC_DEEPLINKING",
    Easylens = "EASYLENS",
    FeaturedStoryCarouselRanking = "FEATURED_STORY_CAROUSEL_RANKING",
    FirstAppInstall = "FIRST_APP_INSTALL",
    Friending = "FRIENDING",
    FriendingQaRanking = "FRIENDING_QA_RANKING",
    FriendingQaRankingCandidate = "FRIENDING_QA_RANKING_CANDIDATE",
    FriendingRankingAutotune_1 = "FRIENDING_RANKING_AUTOTUNE_1",
    FriendingRankingAutotune_2 = "FRIENDING_RANKING_AUTOTUNE_2",
    FriendingRankingAutotune_3 = "FRIENDING_RANKING_AUTOTUNE_3",
    FriendingRankingAutotune_4 = "FRIENDING_RANKING_AUTOTUNE_4",
    FriendingRankingAutotune_5 = "FRIENDING_RANKING_AUTOTUNE_5",
    FriendingReg = "FRIENDING_REG",
    FriendingRegRanking = "FRIENDING_REG_RANKING",
    GamesFeedCore = "GAMES_FEED_CORE",
    Genai = "GENAI",
    GrapheneSampling = "GRAPHENE_SAMPLING",
    GrowthNotification = "GROWTH_NOTIFICATION",
    GrowthNotificationHoldout = "GROWTH_NOTIFICATION_HOLDOUT",
    LegacyAb = "LEGACY_AB",
    LensApplier = "LENS_APPLIER",
    LensCore = "LENS_CORE",
    LensCoreConfig = "LENS_CORE_CONFIG",
    LensCreatorBackend = "LENS_CREATOR_BACKEND",
    LensDeliveryCore = "LENS_DELIVERY_CORE",
    LensExperience = "LENS_EXPERIENCE",
    LensStudioBackend = "LENS_STUDIO_BACKEND",
    LensTargeting = "LENS_TARGETING",
    Login = "LOGIN",
    Machamp = "MACHAMP",
    MapCore = "MAP_CORE",
    MapUi = "MAP_UI",
    MauGrowth = "MAU_GROWTH",
    Mcs = "MCS",
    Mdp = "MDP",
    MdpBackend = "MDP_BACKEND",
    MdpContentManager = "MDP_CONTENT_MANAGER",
    MdpMediaEngine = "MDP_MEDIA_ENGINE",
    MdpOperaCore = "MDP_OPERA_CORE",
    MdpPlayback = "MDP_PLAYBACK",
    MdpUpload = "MDP_UPLOAD",
    MediaUi = "MEDIA_UI",
    MemoriesCore = "MEMORIES_CORE",
    MemoriesUi = "MEMORIES_UI",
    MeshManagedDeployment = "MESH_MANAGED_DEPLOYMENT",
    MessagingCore = "MESSAGING_CORE",
    MessagingUi = "MESSAGING_UI",
    MfRqms = "MF_RQMS",
    MixerGeneral = "MIXER_GENERAL",
    Monetization = "MONETIZATION",
    MonetizationRanking = "MONETIZATION_RANKING",
    MonetizationUi = "MONETIZATION_UI",
    Music = "MUSIC",
    MylensesWebCore = "MYLENSES_WEB_CORE",
    MyAi = "MY_AI",
    NgsUi = "NGS_UI",
    Notification = "NOTIFICATION",
    NotificationRanking = "NOTIFICATION_RANKING",
    NotificationTentpople = "NOTIFICATION_TENTPOPLE",
    PerceptionCore = "PERCEPTION_CORE",
    PerceptionRanking = "PERCEPTION_RANKING",
    PerceptionUi = "PERCEPTION_UI",
    PieAutobot = "PIE_AUTOBOT",
    PieAutobotReactive = "PIE_AUTOBOT_REACTIVE",
    PieCup = "PIE_CUP",
    PlatformCore = "PLATFORM_CORE",
    PlatformServices = "PLATFORM_SERVICES",
    PlatformUi = "PLATFORM_UI",
    PlusCore = "PLUS_CORE",
    PlusOffers = "PLUS_OFFERS",
    PlusUi = "PLUS_UI",
    PremiumContentCore = "PREMIUM_CONTENT_CORE",
    PremiumContentRanking = "PREMIUM_CONTENT_RANKING",
    PremiumContentUi = "PREMIUM_CONTENT_UI",
    ProfileAndIdentity = "PROFILE_AND_IDENTITY",
    ProfileManagerUi = "PROFILE_MANAGER_UI",
    RecipientDeviceCapabilities = "RECIPIENT_DEVICE_CAPABILITIES",
    RequestDomainRouting = "REQUEST_DOMAIN_ROUTING",
    Safety = "SAFETY",
    Saturn = "SATURN",
    SearchCore = "SEARCH_CORE",
    SearchCsl = "SEARCH_CSL",
    SearchRanking = "SEARCH_RANKING",
    SearchUi = "SEARCH_UI",
    Security = "SECURITY",
    SecurityAuthentication = "SECURITY_AUTHENTICATION",
    SecurityPlatformIntegrity = "SECURITY_PLATFORM_INTEGRITY",
    SecuritySpamAndAbuse = "SECURITY_SPAM_AND_ABUSE",
    Semc = "SEMC",
    SharedWebUi = "SHARED_WEB_UI",
    SharingCore = "SHARING_CORE",
    SharingRanking = "SHARING_RANKING",
    SharingUi = "SHARING_UI",
    ShopkitWeb = "SHOPKIT_WEB",
    SnapchatCameraExtension = "SNAPCHAT_CAMERA_EXTENSION",
    SnapchatLite = "SNAPCHAT_LITE",
    SnapchatWebUi = "SNAPCHAT_WEB_UI",
    SnapfeedRanking = "SNAPFEED_RANKING",
    SnapgraphModserver = "SNAPGRAPH_MODSERVER",
    SnapKitCore = "SNAP_KIT_CORE",
    SnapKitUi = "SNAP_KIT_UI",
    SnapMlKitUi = "SNAP_ML_KIT_UI",
    SnapProCore = "SNAP_PRO_CORE",
    SnapProUi = "SNAP_PRO_UI",
    Sounds = "SOUNDS",
    SpectaclesCore = "SPECTACLES_CORE",
    SpectaclesUi = "SPECTACLES_UI",
    SpotlightCore = "SPOTLIGHT_CORE",
    SpotlightExploration = "SPOTLIGHT_EXPLORATION",
    SpotlightExplorationL1 = "SPOTLIGHT_EXPLORATION_L1",
    SpotlightRanking = "SPOTLIGHT_RANKING",
    SpotlightRankingEber = "SPOTLIGHT_RANKING_EBER",
    SpotlightRankingEbr = "SPOTLIGHT_RANKING_EBR",
    SpotlightRankingL0 = "SPOTLIGHT_RANKING_L0",
    SpotlightRankingL1 = "SPOTLIGHT_RANKING_L1",
    SpotlightRankingL2 = "SPOTLIGHT_RANKING_L2",
    SpotlightRankingL3 = "SPOTLIGHT_RANKING_L3",
    SpotlightRetrievalSystem = "SPOTLIGHT_RETRIEVAL_SYSTEM",
    SpotlightUi = "SPOTLIGHT_UI",
    StartupAutogen = "STARTUP_AUTOGEN",
    StoriesCore = "STORIES_CORE",
    StoriesRanking = "STORIES_RANKING",
    StoriesUi = "STORIES_UI",
    StoriesUx = "STORIES_UX",
    StoryStudioLiteCore = "STORY_STUDIO_LITE_CORE",
    StoryStudioLiteUi = "STORY_STUDIO_LITE_UI",
    Tier_0Launch = "TIER_0_LAUNCH",
    UsersAndFriendsCore = "USERS_AND_FRIENDS_CORE",
    UsersAndFriendsRanking = "USERS_AND_FRIENDS_RANKING",
    UsersAndFriendsUi = "USERS_AND_FRIENDS_UI",
    Valdi = "VALDI",
    VisibilityFilteringRuleset = "VISIBILITY_FILTERING_RULESET",
    Web3 = "WEB3",
    WebAccounts = "WEB_ACCOUNTS",
    WebStorytellerUi = "WEB_STORYTELLER_UI",
    WebStoryCore = "WEB_STORY_CORE",
    WebStoryUi = "WEB_STORY_UI",
}

export enum CofServerPlatform {
    AndroidPlatform = "ANDROID_PLATFORM",
    IosPlatform = "IOS_PLATFORM",
    ServerPlatform = "SERVER_PLATFORM",
    UnknownContextPlatform = "UNKNOWN_CONTEXT_PLATFORM",
}

export enum ComSnapCamerakitInternalAdminV1ApplicationType {
    ApplicationTypeBoth = "APPLICATION_TYPE_BOTH",
    ApplicationTypeMobile = "APPLICATION_TYPE_MOBILE",
    ApplicationTypeUnset = "APPLICATION_TYPE_UNSET",
    ApplicationTypeWeb = "APPLICATION_TYPE_WEB",
}

export enum ComSnapCamerakitInternalAdminV1BusinessVertical {
    BusinessVerticalAgency = "BUSINESS_VERTICAL_AGENCY",
    BusinessVerticalCarrier = "BUSINESS_VERTICAL_CARRIER",
    BusinessVerticalCommunityVideo = "BUSINESS_VERTICAL_COMMUNITY_VIDEO",
    BusinessVerticalDating = "BUSINESS_VERTICAL_DATING",
    BusinessVerticalFastFood = "BUSINESS_VERTICAL_FAST_FOOD",
    BusinessVerticalFinance = "BUSINESS_VERTICAL_FINANCE",
    BusinessVerticalFoodAndBeverage = "BUSINESS_VERTICAL_FOOD_AND_BEVERAGE",
    BusinessVerticalFoodDelivery = "BUSINESS_VERTICAL_FOOD_DELIVERY",
    BusinessVerticalGaming = "BUSINESS_VERTICAL_GAMING",
    BusinessVerticalHealthAndFitness = "BUSINESS_VERTICAL_HEALTH_AND_FITNESS",
    BusinessVerticalHome = "BUSINESS_VERTICAL_HOME",
    BusinessVerticalLearningAndEducation = "BUSINESS_VERTICAL_LEARNING_AND_EDUCATION",
    BusinessVerticalLocationAndTravel = "BUSINESS_VERTICAL_LOCATION_AND_TRAVEL",
    BusinessVerticalMessaging = "BUSINESS_VERTICAL_MESSAGING",
    BusinessVerticalMusic = "BUSINESS_VERTICAL_MUSIC",
    BusinessVerticalOem = "BUSINESS_VERTICAL_OEM",
    BusinessVerticalOther = "BUSINESS_VERTICAL_OTHER",
    BusinessVerticalPhotoAndVideoEditing = "BUSINESS_VERTICAL_PHOTO_AND_VIDEO_EDITING",
    BusinessVerticalShopping = "BUSINESS_VERTICAL_SHOPPING",
    BusinessVerticalSocial = "BUSINESS_VERTICAL_SOCIAL",
    BusinessVerticalSports = "BUSINESS_VERTICAL_SPORTS",
    BusinessVerticalStreaming = "BUSINESS_VERTICAL_STREAMING",
    BusinessVerticalTransportation = "BUSINESS_VERTICAL_TRANSPORTATION",
    BusinessVerticalUnset = "BUSINESS_VERTICAL_UNSET",
    BusinessVerticalVideoConferencing = "BUSINESS_VERTICAL_VIDEO_CONFERENCING",
}

export enum ComSnapCamerakitInternalAdminV1CameraKitApprovalStatus {
    CameraKitApprovalStatusApproved = "CAMERA_KIT_APPROVAL_STATUS_APPROVED",
    CameraKitApprovalStatusPendingReview = "CAMERA_KIT_APPROVAL_STATUS_PENDING_REVIEW",
    CameraKitApprovalStatusUnset = "CAMERA_KIT_APPROVAL_STATUS_UNSET",
}

export type ComSnapCamerakitInternalAdminV1CollectOnboardingIntakeFormRequest = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1CollectOnboardingIntakeFormRequest";
    readonly agency?: Maybe<Scalars["Boolean"]["output"]>;
    readonly appStoreUrl?: Maybe<Scalars["String"]["output"]>;
    readonly arShoppingUseCase?: Maybe<Scalars["Boolean"]["output"]>;
    readonly betaFeedbackOptIn?: Maybe<Scalars["Boolean"]["output"]>;
    readonly businessVertical?: Maybe<ComSnapCamerakitInternalAdminV1BusinessVertical>;
    readonly cameraKitG?: Maybe<Scalars["Boolean"]["output"]>;
    readonly companyName?: Maybe<Scalars["String"]["output"]>;
    readonly desiredOutcomes?: Maybe<Scalars["String"]["output"]>;
    readonly developmentExpertiseAvailable?: Maybe<ComSnapCamerakitInternalAdminV1DevelopmentExpertise>;
    readonly emailAddress?: Maybe<Scalars["String"]["output"]>;
    readonly existingSnapKitDeveloper?: Maybe<Scalars["Boolean"]["output"]>;
    readonly existingSnapchatAdvertiser?: Maybe<Scalars["Boolean"]["output"]>;
    readonly fullName?: Maybe<Scalars["String"]["output"]>;
    readonly googlePlayUrl?: Maybe<Scalars["String"]["output"]>;
    readonly hardwareOrPhysical?: Maybe<Scalars["Boolean"]["output"]>;
    readonly intendedApplicationType?: Maybe<ComSnapCamerakitInternalAdminV1ApplicationType>;
    readonly lensCreationMethod?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    readonly useCaseDescription?: Maybe<Scalars["String"]["output"]>;
    readonly websiteUrl?: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1CollectOnboardingIntakeFormResponse = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1CollectOnboardingIntakeFormResponse";
    readonly approvalStatus?: Maybe<ComSnapCamerakitInternalAdminV1CameraKitApprovalStatus>;
};

export type ComSnapCamerakitInternalAdminV1ConsumeOnboardingTokenRequest = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1ConsumeOnboardingTokenRequest";
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
    readonly token?: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1ConsumeOnboardingTokenResponse = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1ConsumeOnboardingTokenResponse";
    readonly cameraKitMobileAppAccess?: Maybe<Scalars["Boolean"]["output"]>;
    readonly cameraKitWebAppAccess?: Maybe<Scalars["Boolean"]["output"]>;
    readonly consumeTokenStatus?: Maybe<ComSnapCamerakitInternalAdminV1ConsumeTokenStatus>;
};

export enum ComSnapCamerakitInternalAdminV1ConsumeTokenStatus {
    ConsumeTokenStatusAlreadyConsumed = "CONSUME_TOKEN_STATUS_ALREADY_CONSUMED",
    ConsumeTokenStatusConsumed = "CONSUME_TOKEN_STATUS_CONSUMED",
    ConsumeTokenStatusRevoked = "CONSUME_TOKEN_STATUS_REVOKED",
    ConsumeTokenStatusUnconsumed = "CONSUME_TOKEN_STATUS_UNCONSUMED",
    ConsumeTokenStatusUnset = "CONSUME_TOKEN_STATUS_UNSET",
}

export enum ComSnapCamerakitInternalAdminV1DevelopmentExpertise {
    DevelopmentExpertiseInternal = "DEVELOPMENT_EXPERTISE_INTERNAL",
    DevelopmentExpertiseOutsource = "DEVELOPMENT_EXPERTISE_OUTSOURCE",
    DevelopmentExpertiseRequired = "DEVELOPMENT_EXPERTISE_REQUIRED",
    DevelopmentExpertiseUnset = "DEVELOPMENT_EXPERTISE_UNSET",
}

export type ComSnapCamerakitInternalAdminV1InternalLabels = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1InternalLabels";
    readonly firstParty?: Maybe<Scalars["Boolean"]["output"]>;
    readonly live?: Maybe<Scalars["Boolean"]["output"]>;
    readonly managed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1ListTokenRequest = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1ListTokenRequest";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly endDateMillis?: Maybe<Scalars["Long"]["output"]>;
    readonly limit?: Maybe<Scalars["Int"]["output"]>;
    readonly startDateMillis?: Maybe<Scalars["Long"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1ListTokenResponse = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1ListTokenResponse";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly tokens?: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitInternalAdminV1OnboardingToken>>>;
};

export type ComSnapCamerakitInternalAdminV1NotifyEmailRequest = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1NotifyEmailRequest";
    readonly formIds?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    /** @deprecated deprecated in proto */
    readonly notifyEmails?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    /** @deprecated deprecated in proto */
    readonly platformType?: Maybe<ComSnapCamerakitInternalAdminV1ApplicationType>;
    readonly templateId?: Maybe<Scalars["Int"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1NotifyEmailResponse = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1NotifyEmailResponse";
    readonly successes?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]["output"]>>>;
};

export type ComSnapCamerakitInternalAdminV1OnboardingToken = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1OnboardingToken";
    readonly cameraKitMobileAppAccess?: Maybe<Scalars["Boolean"]["output"]>;
    readonly cameraKitWebAppAccess?: Maybe<Scalars["Boolean"]["output"]>;
    readonly consumedTimeMillis?: Maybe<Scalars["Long"]["output"]>;
    readonly consumingOrganization?: Maybe<Scalars["String"]["output"]>;
    readonly createdTimeMillis?: Maybe<Scalars["Long"]["output"]>;
    readonly firstVerifiedTimeMillis?: Maybe<Scalars["Long"]["output"]>;
    readonly isRevoked?: Maybe<Scalars["Boolean"]["output"]>;
    readonly requestingEmail?: Maybe<Scalars["String"]["output"]>;
    readonly tokenValue?: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1Organization = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1Organization";
    readonly id?: Maybe<Scalars["String"]["output"]>;
    readonly internalLabels?: Maybe<ComSnapCamerakitInternalAdminV1InternalLabels>;
    readonly name?: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1RevokeTokenRequest = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1RevokeTokenRequest";
    readonly token?: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1RevokeTokenResponse = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1RevokeTokenResponse";
    readonly tokenRevoked?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1SearchOrganizationRequest = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1SearchOrganizationRequest";
    readonly query?: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1SearchOrganizationResponse = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1SearchOrganizationResponse";
    readonly organizations?: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitInternalAdminV1Organization>>>;
};

export type ComSnapCamerakitInternalAdminV1SearchTokenRequest = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1SearchTokenRequest";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly limit?: Maybe<Scalars["Int"]["output"]>;
    readonly requestingEmail?: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1SearchTokenResponse = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1SearchTokenResponse";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly tokens?: Maybe<ReadonlyArray<Maybe<ComSnapCamerakitInternalAdminV1OnboardingToken>>>;
};

export type ComSnapCamerakitInternalAdminV1UpdateOrganizationInternalLabelsRequest = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1UpdateOrganizationInternalLabelsRequest";
    readonly internalLabels?: Maybe<ComSnapCamerakitInternalAdminV1InternalLabels>;
    readonly orgId?: Maybe<Scalars["String"]["output"]>;
};

export type ComSnapCamerakitInternalAdminV1UpdateOrganizationInternalLabelsResponse = {
    readonly __typename?: "ComSnapCamerakitInternalAdminV1UpdateOrganizationInternalLabelsResponse";
    readonly internalLabels?: Maybe<ComSnapCamerakitInternalAdminV1InternalLabels>;
};

export type ConfigResult = {
    readonly __typename?: "ConfigResult";
    readonly configId: Scalars["String"]["output"];
    readonly experimentId: Scalars["Int"]["output"];
    readonly namespace: CofNamespace;
    readonly pb_delete: Scalars["Boolean"]["output"];
    readonly priority: Scalars["Int"]["output"];
    readonly sequenceId: Scalars["Int"]["output"];
    readonly servePlatformsList: ReadonlyArray<CofServerPlatform>;
    readonly studyName: Scalars["String"]["output"];
    readonly ttlSeconds?: Maybe<Scalars["Float"]["output"]>;
    readonly value?: Maybe<Value>;
};

export enum ContainerKind {
    ContainerKindLensFolder = "CONTAINER_KIND_LENS_FOLDER",
    ContainerKindOrganization = "CONTAINER_KIND_ORGANIZATION",
    ContainerKindUnset = "CONTAINER_KIND_UNSET",
}

export type ContentfulOrganization = {
    readonly __typename?: "ContentfulOrganization";
    /** @deprecated Renamed to AssetOrganization.id */
    readonly id: Scalars["String"]["output"];
    /** @deprecated Renamed to AssetOrganization.name */
    readonly name: Scalars["String"]["output"];
};

export type CreateAppVersionResponse = {
    readonly __typename?: "CreateAppVersionResponse";
    readonly appVersion?: Maybe<MyLensesAppVersion>;
};

export type CreateApplicationResponse = {
    readonly __typename?: "CreateApplicationResponse";
    readonly appInfo?: Maybe<AppInfo>;
};

export type CreateConnectionBulkRequest = {
    readonly __typename?: "CreateConnectionBulkRequest";
    readonly createRequests?: Maybe<ReadonlyArray<Maybe<CreateConnectionRequest>>>;
};

export type CreateConnectionBulkResponse = {
    readonly __typename?: "CreateConnectionBulkResponse";
    readonly connections?: Maybe<ReadonlyArray<Maybe<GroupLensConnection>>>;
};

export type CreateConnectionRequest = {
    readonly __typename?: "CreateConnectionRequest";
    readonly groupId?: Maybe<Scalars["String"]["output"]>;
    readonly lensCompoundId?: Maybe<LensCompoundId>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
    readonly priority?: Maybe<Scalars["Int"]["output"]>;
    readonly schedule?: Maybe<Schedule>;
    readonly vendorData?: Maybe<ReadonlyArray<Maybe<VendorDataItem>>>;
};

export type CreateLensSpaceRequest = {
    readonly lensSpaceName: Scalars["String"]["input"];
    readonly organizationId: Scalars["ID"]["input"];
};

export type CreateLensSpaceResponse = {
    readonly __typename?: "CreateLensSpaceResponse";
    readonly lensSpace?: Maybe<LensSpace>;
};

export type CreateOrganizationAndLensSpaceRequest = {
    readonly lensSpaceName: Scalars["String"]["input"];
    readonly organizationName: Scalars["String"]["input"];
};

export type CreateVersionRequest = {
    readonly __typename?: "CreateVersionRequest";
    readonly appId: Scalars["String"]["output"];
    readonly appVersionName: Scalars["String"]["output"];
    readonly sourceVersion: Scalars["Int"]["output"];
};

export type CreateWebLensUploadResponse = {
    readonly __typename?: "CreateWebLensUploadResponse";
    /** Byte cap bound into logoUploadUrl's signature. */
    readonly logoMaxBytes: Scalars["Int"]["output"];
    /** 15-minute signed PUT URL for the optional logo. Send Content-Type: application/octet-stream and X-Goog-Content-Length-Range: 0,{logoMaxBytes}. */
    readonly logoUploadUrl: Scalars["String"]["output"];
    /** Byte cap bound into packageUploadUrl's signature — use this value in the X-Goog-Content-Length-Range header rather than a hardcoded copy. */
    readonly packageMaxBytes: Scalars["Int"]["output"];
    /** 15-minute signed PUT URL for the zip package. Send Content-Type: application/octet-stream and X-Goog-Content-Length-Range: 0,{packageMaxBytes} — both are bound into the signature, so GCS itself refuses an oversized upload. */
    readonly packageUploadUrl: Scalars["String"]["output"];
    /** Echo back in SubmitWebLensRequest.packageRef */
    readonly uploadRef: Scalars["String"]["output"];
};

export type CreatorRewardRecord = {
    readonly __typename?: "CreatorRewardRecord";
    readonly postUU: Scalars["Int"]["output"];
    readonly rewardEligibility: CreatorRewardRecordEligibility;
};

export enum CreatorRewardRecordEligibility {
    RewardEligibilityIneligible = "REWARD_ELIGIBILITY_INELIGIBLE",
    RewardEligibilityIssued = "REWARD_ELIGIBILITY_ISSUED",
    RewardEligibilityPending = "REWARD_ELIGIBILITY_PENDING",
    RewardEligibilityUnset = "REWARD_ELIGIBILITY_UNSET",
}

export type CreatorRewardRecordRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type CreatorVerificationStatus = {
    readonly __typename?: "CreatorVerificationStatus";
    readonly hasVerifiedPhone?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteHostedLensRequest = {
    readonly id: Scalars["ID"]["input"];
    readonly organizationId: Scalars["ID"]["input"];
};

export type DeleteLensRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type DeleteRemoteApiSpecRequest = {
    readonly id: Scalars["ID"]["input"];
};

export type DeleteRemoteApiSpecResponse = {
    readonly __typename?: "DeleteRemoteApiSpecResponse";
    readonly id: Scalars["ID"]["output"];
};

export type DeleteRemoteAssetRequest = {
    readonly id: Scalars["ID"]["input"];
};

export type DeleteRemoteAssetResult = {
    readonly __typename?: "DeleteRemoteAssetResult";
    readonly success: Scalars["Boolean"]["output"];
};

export type DeleteRemoteAssetsRequest = {
    readonly ids: ReadonlyArray<Scalars["ID"]["input"]>;
};

export type DeleteRemoteAssetsResult = {
    readonly __typename?: "DeleteRemoteAssetsResult";
    readonly failedIds: ReadonlyArray<Scalars["ID"]["output"]>;
    readonly successIds: ReadonlyArray<Scalars["ID"]["output"]>;
};

export enum DestinationType {
    DestinationTypeAdAccount = "DESTINATION_TYPE_AD_ACCOUNT",
    DestinationTypeCameraKit = "DESTINATION_TYPE_CAMERA_KIT",
    DestinationTypeCommunity = "DESTINATION_TYPE_COMMUNITY",
    DestinationTypeShoppingKit = "DESTINATION_TYPE_SHOPPING_KIT",
    DestinationTypeUnset = "DESTINATION_TYPE_UNSET",
}

export enum DestinationTypeBm {
    DestinationTypeAdAccount = "DESTINATION_TYPE_AD_ACCOUNT",
    DestinationTypePublicProfile = "DESTINATION_TYPE_PUBLIC_PROFILE",
    DestinationTypeUnset = "DESTINATION_TYPE_UNSET",
    DestinationTypeUser = "DESTINATION_TYPE_USER",
}

export type DigitalGood = {
    readonly __typename?: "DigitalGood";
    readonly consumableQuantity: Scalars["Int"]["output"];
    readonly description: Scalars["String"]["output"];
    readonly lensId: Scalars["ID"]["output"];
    readonly localizationsList: ReadonlyArray<DigitalGoodLocalization>;
    readonly priceTier: Scalars["Int"]["output"];
    readonly sku: Scalars["String"]["output"];
    readonly status: DigitalGoodStatus;
    readonly title: Scalars["String"]["output"];
    readonly type: DigitalGoodType;
};

export type DigitalGoodInput = {
    readonly consumableQuantity: Scalars["Int"]["input"];
    readonly description: Scalars["String"]["input"];
    readonly localizationsList: ReadonlyArray<DigitalGoodLocalizationInput>;
    readonly priceTier: Scalars["Int"]["input"];
    readonly sku: Scalars["String"]["input"];
    readonly title: Scalars["String"]["input"];
    readonly type: DigitalGoodType;
};

export enum DigitalGoodLocale {
    DigitalGoodLocaleArAa = "DIGITAL_GOOD_LOCALE_AR_AA",
    DigitalGoodLocaleBnBd = "DIGITAL_GOOD_LOCALE_BN_BD",
    DigitalGoodLocaleBnIn = "DIGITAL_GOOD_LOCALE_BN_IN",
    DigitalGoodLocaleDaDk = "DIGITAL_GOOD_LOCALE_DA_DK",
    DigitalGoodLocaleDeDe = "DIGITAL_GOOD_LOCALE_DE_DE",
    DigitalGoodLocaleElGr = "DIGITAL_GOOD_LOCALE_EL_GR",
    DigitalGoodLocaleEnGb = "DIGITAL_GOOD_LOCALE_EN_GB",
    DigitalGoodLocaleEnUs = "DIGITAL_GOOD_LOCALE_EN_US",
    DigitalGoodLocaleEs_001 = "DIGITAL_GOOD_LOCALE_ES_001",
    DigitalGoodLocaleEsAr = "DIGITAL_GOOD_LOCALE_ES_AR",
    DigitalGoodLocaleEsEs = "DIGITAL_GOOD_LOCALE_ES_ES",
    DigitalGoodLocaleEsMx = "DIGITAL_GOOD_LOCALE_ES_MX",
    DigitalGoodLocaleFilPh = "DIGITAL_GOOD_LOCALE_FIL_PH",
    DigitalGoodLocaleFiFi = "DIGITAL_GOOD_LOCALE_FI_FI",
    DigitalGoodLocaleFrFr = "DIGITAL_GOOD_LOCALE_FR_FR",
    DigitalGoodLocaleGuIn = "DIGITAL_GOOD_LOCALE_GU_IN",
    DigitalGoodLocaleHiIn = "DIGITAL_GOOD_LOCALE_HI_IN",
    DigitalGoodLocaleIdId = "DIGITAL_GOOD_LOCALE_ID_ID",
    DigitalGoodLocaleItIt = "DIGITAL_GOOD_LOCALE_IT_IT",
    DigitalGoodLocaleJaJp = "DIGITAL_GOOD_LOCALE_JA_JP",
    DigitalGoodLocaleKnIn = "DIGITAL_GOOD_LOCALE_KN_IN",
    DigitalGoodLocaleKoKr = "DIGITAL_GOOD_LOCALE_KO_KR",
    DigitalGoodLocaleMlIn = "DIGITAL_GOOD_LOCALE_ML_IN",
    DigitalGoodLocaleMrIn = "DIGITAL_GOOD_LOCALE_MR_IN",
    DigitalGoodLocaleMsMy = "DIGITAL_GOOD_LOCALE_MS_MY",
    DigitalGoodLocaleNbNo = "DIGITAL_GOOD_LOCALE_NB_NO",
    DigitalGoodLocaleNlNl = "DIGITAL_GOOD_LOCALE_NL_NL",
    DigitalGoodLocalePaIn = "DIGITAL_GOOD_LOCALE_PA_IN",
    DigitalGoodLocalePlPl = "DIGITAL_GOOD_LOCALE_PL_PL",
    DigitalGoodLocalePtBr = "DIGITAL_GOOD_LOCALE_PT_BR",
    DigitalGoodLocalePtPt = "DIGITAL_GOOD_LOCALE_PT_PT",
    DigitalGoodLocaleRoRo = "DIGITAL_GOOD_LOCALE_RO_RO",
    DigitalGoodLocaleRuRu = "DIGITAL_GOOD_LOCALE_RU_RU",
    DigitalGoodLocaleSvSe = "DIGITAL_GOOD_LOCALE_SV_SE",
    DigitalGoodLocaleTaIn = "DIGITAL_GOOD_LOCALE_TA_IN",
    DigitalGoodLocaleTeIn = "DIGITAL_GOOD_LOCALE_TE_IN",
    DigitalGoodLocaleThTh = "DIGITAL_GOOD_LOCALE_TH_TH",
    DigitalGoodLocaleTrTr = "DIGITAL_GOOD_LOCALE_TR_TR",
    DigitalGoodLocaleUnset = "DIGITAL_GOOD_LOCALE_UNSET",
    DigitalGoodLocaleUrPk = "DIGITAL_GOOD_LOCALE_UR_PK",
    DigitalGoodLocaleViVn = "DIGITAL_GOOD_LOCALE_VI_VN",
    DigitalGoodLocaleZhCn = "DIGITAL_GOOD_LOCALE_ZH_CN",
    DigitalGoodLocaleZhTw = "DIGITAL_GOOD_LOCALE_ZH_TW",
}

export type DigitalGoodLocalization = {
    readonly __typename?: "DigitalGoodLocalization";
    readonly description: Scalars["String"]["output"];
    readonly locale: DigitalGoodLocale;
    readonly title: Scalars["String"]["output"];
};

export type DigitalGoodLocalizationInput = {
    readonly description: Scalars["String"]["input"];
    readonly locale: DigitalGoodLocale;
    readonly title: Scalars["String"]["input"];
};

export enum DigitalGoodStatus {
    DigitalGoodStatusActive = "DIGITAL_GOOD_STATUS_ACTIVE",
    DigitalGoodStatusInactive = "DIGITAL_GOOD_STATUS_INACTIVE",
    DigitalGoodStatusUnset = "DIGITAL_GOOD_STATUS_UNSET",
}

export enum DigitalGoodType {
    DigitalGoodTypeConsumable = "DIGITAL_GOOD_TYPE_CONSUMABLE",
    DigitalGoodTypeDurable = "DIGITAL_GOOD_TYPE_DURABLE",
    DigitalGoodTypeUnset = "DIGITAL_GOOD_TYPE_UNSET",
}

export type Discoverability = {
    readonly __typename?: "Discoverability";
    readonly daysTimesHolidaysList?: Maybe<ReadonlyArray<Scalars["String"]["output"]>>;
    readonly description?: Maybe<Scalars["String"]["output"]>;
    readonly locationsList?: Maybe<ReadonlyArray<Scalars["String"]["output"]>>;
    readonly tagsList?: Maybe<ReadonlyArray<Scalars["String"]["output"]>>;
};

export type DiscoverabilityInput = {
    readonly daysTimesHolidaysList?: ReadonlyArray<Scalars["String"]["input"]>;
    readonly description?: Scalars["String"]["input"];
    readonly locationsList?: ReadonlyArray<Scalars["String"]["input"]>;
    readonly tagsList?: ReadonlyArray<Scalars["String"]["input"]>;
};

export type Distribution = {
    readonly __typename?: "Distribution";
    readonly destinationId: Scalars["String"]["output"];
    readonly destinationType: DestinationType;
    readonly status: MyLensesLensStatus;
};

export type DistributionRestriction = {
    readonly __typename?: "DistributionRestriction";
    readonly messagesList: ReadonlyArray<Scalars["String"]["output"]>;
    readonly restrictionType: RestrictionType;
};

export type EnableCameraKitFeatureRequest = {
    readonly __typename?: "EnableCameraKitFeatureRequest";
    readonly appId: Scalars["String"]["output"];
    readonly sourceVersion: Scalars["Int"]["output"];
};

export type EnableCameraKitFeatureResponse = {
    readonly __typename?: "EnableCameraKitFeatureResponse";
    readonly _?: Maybe<Scalars["String"]["output"]>;
};

export type EulaData = {
    readonly __typename?: "EulaData";
    readonly hasAgreedToLatestEula: Scalars["Boolean"]["output"];
    readonly latestEulaId: Scalars["String"]["output"];
    readonly latestEulaUrl: Scalars["String"]["output"];
    readonly verifiedEmail: Scalars["String"]["output"];
};

export enum ExclusiveLensProgramStatus {
    ExclusiveLensProgramStatusEligible = "EXCLUSIVE_LENS_PROGRAM_STATUS_ELIGIBLE",
    ExclusiveLensProgramStatusIneligible = "EXCLUSIVE_LENS_PROGRAM_STATUS_INELIGIBLE",
    ExclusiveLensProgramStatusRejected = "EXCLUSIVE_LENS_PROGRAM_STATUS_REJECTED",
    ExclusiveLensProgramStatusUnset = "EXCLUSIVE_LENS_PROGRAM_STATUS_UNSET",
}

export enum ExclusiveLensStatus {
    ExclusiveLensStatusEligible = "EXCLUSIVE_LENS_STATUS_ELIGIBLE",
    ExclusiveLensStatusExclusive = "EXCLUSIVE_LENS_STATUS_EXCLUSIVE",
    ExclusiveLensStatusIneligible = "EXCLUSIVE_LENS_STATUS_INELIGIBLE",
    ExclusiveLensStatusRemoved = "EXCLUSIVE_LENS_STATUS_REMOVED",
    ExclusiveLensStatusUnset = "EXCLUSIVE_LENS_STATUS_UNSET",
}

export enum ExperienceType {
    DoNotRemove = "DO_NOT_REMOVE",
    FeedbackRating = "FEEDBACK_RATING",
}

export enum FileMetadataFileType {
    FileTypeLensResource = "FILE_TYPE_LENS_RESOURCE",
    FileTypePreviewMedia = "FILE_TYPE_PREVIEW_MEDIA",
    FileTypeUnset = "FILE_TYPE_UNSET",
}

export type FileResource = {
    readonly __typename?: "FileResource";
    readonly fileName: Scalars["String"]["output"];
    readonly url: Scalars["String"]["output"];
};

export type FilterBy = {
    readonly lockedList: ReadonlyArray<Scalars["Boolean"]["input"]>;
    readonly nameList: ReadonlyArray<Scalars["String"]["input"]>;
    readonly statusList: ReadonlyArray<MyLensesLensStatus>;
    /** List of surface types to filter lenses by. If empty, no filtering is applied. If non-empty, returns lenses whose surface type is a subset of this list. */
    readonly surfaceTypeList: ReadonlyArray<SurfaceType>;
    readonly unlockableIdList: ReadonlyArray<Scalars["String"]["input"]>;
};

export type FinalizeBusinessLensRequest = {
    readonly description?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensId: Scalars["ID"]["input"];
    readonly lensPreview?: InputMaybe<Scalars["Upload"]["input"]>;
};

export type FinalizeBusinessLensResponse = {
    readonly __typename?: "FinalizeBusinessLensResponse";
    readonly lens: MyLensesLens;
};

export type ForkRemoteAssetItem = {
    readonly assetId: Scalars["ID"]["input"];
    readonly description: Scalars["String"]["input"];
    readonly name: Scalars["String"]["input"];
};

export type ForkRemoteAssetResult = {
    readonly __typename?: "ForkRemoteAssetResult";
    readonly asset?: Maybe<RemoteAsset>;
    readonly error?: Maybe<RemoteAssetError>;
    readonly sourceAssetId: Scalars["ID"]["output"];
};

export type ForkRemoteAssetsInput = {
    readonly items: ReadonlyArray<ForkRemoteAssetItem>;
    readonly targetOrganizationId: Scalars["ID"]["input"];
};

export type ForkRemoteAssetsResponse = {
    readonly __typename?: "ForkRemoteAssetsResponse";
    readonly results: ReadonlyArray<ForkRemoteAssetResult>;
};

export type GenerateApiTokenRequest = {
    readonly __typename?: "GenerateApiTokenRequest";
    readonly appId?: Maybe<Scalars["String"]["output"]>;
    readonly stage?: Maybe<MyLensesStage>;
};

export type GenerateApiTokenResponse = {
    readonly __typename?: "GenerateApiTokenResponse";
    readonly apiToken?: Maybe<MyLensesApiToken>;
};

export type GenerateHostedLensRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type GenerateHostedLensResponse = {
    readonly __typename?: "GenerateHostedLensResponse";
    readonly lens?: Maybe<HostedLens>;
};

export type GetAdAccountsRequest = {
    readonly limit: Scalars["Int"]["input"];
    readonly organizationId: Scalars["ID"]["input"];
};

export type GetAppVendorUuidOptinFlagRequest = {
    readonly __typename?: "GetAppVendorUuidOptinFlagRequest";
    readonly appId?: Maybe<Scalars["String"]["output"]>;
};

export type GetAppVendorUuidOptinFlagResponse = {
    readonly __typename?: "GetAppVendorUuidOptinFlagResponse";
    readonly appVendorOptInEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type GetApplicationInfoRequest = {
    readonly __typename?: "GetApplicationInfoRequest";
    readonly appId?: Maybe<Scalars["String"]["output"]>;
    readonly orgId?: Maybe<Scalars["String"]["output"]>;
};

export type GetApplicationInfoResponse = {
    readonly __typename?: "GetApplicationInfoResponse";
    readonly application?: Maybe<AppInfo>;
};

export type GetAssetRequest = {
    readonly assetId: Scalars["ID"]["input"];
};

/** NOT USED */
export type GetAssetResponse = {
    readonly __typename?: "GetAssetResponse";
    readonly asset: MyLensesContentTypeAssetV2;
};

export type GetCofConfigsRequest = {
    readonly configIds: ReadonlyArray<CofConfigId>;
};

export type GetCofConfigsResponse = {
    readonly __typename?: "GetCofConfigsResponse";
    readonly configs?: Maybe<ReadonlyArray<ConfigResult>>;
};

export type GetHostedLensRequest = {
    readonly lensId: Scalars["ID"]["input"];
    readonly organizationId: Scalars["ID"]["input"];
};

export type GetHostedLensResponse = {
    readonly __typename?: "GetHostedLensResponse";
    readonly lens?: Maybe<HostedLens>;
};

export type GetHostedLensesRequest = {
    readonly organizationId: Scalars["ID"]["input"];
};

export type GetHostedLensesResponse = {
    readonly __typename?: "GetHostedLensesResponse";
    readonly lensesList: ReadonlyArray<HostedLens>;
};

export type GetIldgEligibilityResponse = {
    readonly __typename?: "GetIldgEligibilityResponse";
    readonly ildgEligibilityBreakdownsList: ReadonlyArray<IldgEligibilityBreakdown>;
};

export type GetLensAutomationToolMaintenanceStatusResponse = {
    readonly __typename?: "GetLensAutomationToolMaintenanceStatusResponse";
    readonly status?: Maybe<LensAutomationToolMaintenanceStatus>;
};

export type GetLensCategoryListResponse = {
    readonly __typename?: "GetLensCategoryListResponse";
    readonly lensCategoryList?: Maybe<LensCategoryList>;
};

export type GetLensCreatorPayoutTosAcceptedVersionResponse = {
    readonly __typename?: "GetLensCreatorPayoutTosAcceptedVersionResponse";
    readonly version?: Maybe<Scalars["Int"]["output"]>;
};

export type GetLensDestinationsRequest = {
    readonly lensFolderId: Scalars["ID"]["input"];
    readonly lensId: Scalars["ID"]["input"];
};

export type GetLensDestinationsResponse = {
    readonly __typename?: "GetLensDestinationsResponse";
    readonly destinations: ReadonlyArray<LensDestination>;
};

export type GetLensDiscoverabilityLocationTagCandidatesRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type GetLensDiscoverabilityLocationTagCandidatesResponse = {
    readonly __typename?: "GetLensDiscoverabilityLocationTagCandidatesResponse";
    readonly locationTagsList?: Maybe<ReadonlyArray<Scalars["String"]["output"]>>;
};

export type GetLensDiscoverabilityTimeTagCandidatesRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type GetLensDiscoverabilityTimeTagCandidatesResponse = {
    readonly __typename?: "GetLensDiscoverabilityTimeTagCandidatesResponse";
    readonly timeTagsList?: Maybe<ReadonlyArray<Scalars["String"]["output"]>>;
};

export type GetLensDiscoverabilityVisualTagCandidatesRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type GetLensDiscoverabilityVisualTagCandidatesResponse = {
    readonly __typename?: "GetLensDiscoverabilityVisualTagCandidatesResponse";
    readonly visualTagsList?: Maybe<ReadonlyArray<Scalars["String"]["output"]>>;
};

export type GetLensRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type GetLensResponse = {
    readonly __typename?: "GetLensResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type GetLensStudioVersionsResponse = {
    readonly __typename?: "GetLensStudioVersionsResponse";
    readonly versions: ReadonlyArray<LensStudioVersionOption>;
};

export type GetLensesResponse = {
    readonly __typename?: "GetLensesResponse";
    readonly lensesList: ReadonlyArray<MyLensesLens>;
};

export enum GetLensesType {
    AdAccount = "AD_ACCOUNT",
    Community = "COMMUNITY",
    LensSpace = "LENS_SPACE",
    Org = "ORG",
    Profile = "PROFILE",
}

export type GetLensesWithDigitalGoodsRequest = {
    readonly owner: LensAccountIdInput;
};

export type GetLensesWithDigitalGoodsResponse = {
    readonly __typename?: "GetLensesWithDigitalGoodsResponse";
    readonly lensesList: ReadonlyArray<MyLensesLens>;
};

export type GetOrganizationAssetsRequest = {
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly order?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly organizationId: Scalars["ID"]["input"];
    readonly skip?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GetOrganizationMetadataRequest = {
    readonly organizationId: Scalars["ID"]["input"];
};

export type GetOrganizationMetadataResponse = {
    readonly __typename?: "GetOrganizationMetadataResponse";
    readonly organizationMetadata?: Maybe<OrganizationMetadata>;
};

export type GetPreSubmissionInfoRequest = {
    readonly submissionId: Scalars["ID"]["input"];
};

export type GetPreSubmissionInfoResponse = {
    readonly __typename?: "GetPreSubmissionInfoResponse";
    readonly analytics?: Maybe<LensStudioAnalytics>;
    /** @deprecated Digital goods are deprecated */
    readonly digitalGoodsList: ReadonlyArray<DigitalGood>;
    readonly hasLyrics: Scalars["Boolean"]["output"];
    readonly hasMusic: Scalars["Boolean"]["output"];
    readonly iconUrl: Scalars["String"]["output"];
    readonly isAIClip: Scalars["Boolean"]["output"];
    readonly isSameUser: Scalars["Boolean"]["output"];
    readonly name: Scalars["String"]["output"];
    readonly previewMediaRefs: ReadonlyArray<PreviewMediaReference>;
    /** @deprecated use previewMediaRefs instead */
    readonly previewUrl: Scalars["String"]["output"];
    readonly size: Scalars["Float"]["output"];
    readonly surfaceType: ReadonlyArray<SurfaceType>;
    readonly trendingTagsList: ReadonlyArray<Scalars["String"]["output"]>;
    readonly validationErrors: ReadonlyArray<MyLensesSubmissionValidationError>;
};

export type GetPriceTiersResponse = {
    readonly __typename?: "GetPriceTiersResponse";
    readonly priceTiersList: ReadonlyArray<PriceTier>;
};

export type GetRemoteApiSpecRequest = {
    readonly id: Scalars["ID"]["input"];
};

export type GetRemoteApiSpecsRequest = {
    readonly orgId: Scalars["ID"]["input"];
};

export type GetRemoteAssetRequest = {
    readonly id: Scalars["ID"]["input"];
};

export type GetRemoteAssetsQuotaRequest = {
    readonly organizationId: Scalars["ID"]["input"];
};

export type GetRemoteAssetsRequest = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId: Scalars["ID"]["input"];
    readonly query?: InputMaybe<Scalars["String"]["input"]>;
};

export type GetScanTriggersResponse = {
    readonly __typename?: "GetScanTriggersResponse";
    /** @deprecated Scan triggers feature is being removed */
    readonly allScanTriggersList: ReadonlyArray<Scalars["String"]["output"]>;
    /** @deprecated Scan triggers feature is being removed */
    readonly pretypeScanTriggersList: ReadonlyArray<Scalars["String"]["output"]>;
};

export type GetTosRequest = {
    readonly key: TosKey;
};

export type GetTosResponse = {
    readonly __typename?: "GetTosResponse";
    readonly tos: Tos;
};

export type GetUndismissedExperiencesRequest = {
    readonly experienceTypes: ReadonlyArray<ExperienceType>;
};

export type GetUndismissedExperiencesResponse = {
    readonly __typename?: "GetUndismissedExperiencesResponse";
    readonly experienceTypes: ReadonlyArray<ExperienceType>;
};

export type GetUserAssetsRequest = {
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly order?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly skip?: InputMaybe<Scalars["Int"]["input"]>;
};

export type GetUserInfoRequest = {
    readonly __typename?: "GetUserInfoRequest";
    readonly _?: Maybe<Scalars["String"]["output"]>;
};

export type GetUserProfileResponse = {
    readonly __typename?: "GetUserProfileResponse";
    readonly avatarUrl: Scalars["String"]["output"];
    readonly defaultOrganizationId: Scalars["ID"]["output"];
    readonly exclusiveLensProgramStatus: ExclusiveLensProgramStatus;
    readonly pageUrl: Scalars["String"]["output"];
    readonly useNewLayout: Scalars["Boolean"]["output"];
    readonly userDisplayName: Scalars["String"]["output"];
    readonly userId: Scalars["ID"]["output"];
};

export type GetVersionListRequest = {
    readonly __typename?: "GetVersionListRequest";
    readonly appId: Scalars["String"]["output"];
};

export type GetVersionListResponse = {
    readonly __typename?: "GetVersionListResponse";
    readonly versions: ReadonlyArray<Maybe<MyLensesAppVersion>>;
};

export type GoogleProtobufTimestamp = {
    readonly __typename?: "GoogleProtobufTimestamp";
    readonly nanos: Scalars["Int"]["output"];
    readonly seconds: Scalars["Float"]["output"];
};

export type GoogleProtobufTimestampInput = {
    readonly nanos: Scalars["Int"]["input"];
    readonly seconds: Scalars["Float"]["input"];
};

export type Group = {
    readonly __typename?: "Group";
    readonly createdAt?: Maybe<GoogleProtobufTimestamp>;
    readonly description?: Maybe<Scalars["String"]["output"]>;
    readonly id?: Maybe<Scalars["String"]["output"]>;
    readonly isPinned?: Maybe<Scalars["Boolean"]["output"]>;
    readonly lenses?: Maybe<ReadonlyArray<Maybe<LensInGroup>>>;
    readonly name?: Maybe<Scalars["String"]["output"]>;
    readonly readOnly?: Maybe<Scalars["Boolean"]["output"]>;
    readonly status?: Maybe<GroupStatus>;
    readonly totalNumLenses?: Maybe<Scalars["Int"]["output"]>;
    readonly updatedAt?: Maybe<GoogleProtobufTimestamp>;
};

export type GroupLensConnection = {
    readonly __typename?: "GroupLensConnection";
    readonly connectionId?: Maybe<Scalars["String"]["output"]>;
    readonly group?: Maybe<Group>;
    readonly lens?: Maybe<CameraKitLens>;
    readonly priority?: Maybe<Scalars["Int"]["output"]>;
    readonly schedule?: Maybe<Schedule>;
    readonly vendorData?: Maybe<ReadonlyArray<Maybe<VendorDataItem>>>;
};

export type GroupListRequest = {
    readonly __typename?: "GroupListRequest";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly lensLimit?: Maybe<Scalars["Int"]["output"]>;
    readonly limit?: Maybe<Scalars["Int"]["output"]>;
    readonly offset?: Maybe<Scalars["Int"]["output"]>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
    readonly query?: Maybe<GroupListRequestQuery>;
};

export enum GroupListRequestQuery {
    All = "ALL",
    OnlyActive = "ONLY_ACTIVE",
}

export type GroupListWithConnections = {
    readonly __typename?: "GroupListWithConnections";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly groupsWithConnections?: Maybe<ReadonlyArray<Maybe<GroupWithConnections>>>;
    readonly hasMore?: Maybe<Scalars["Boolean"]["output"]>;
    readonly total?: Maybe<Scalars["Int"]["output"]>;
};

export type GroupRequest = {
    readonly __typename?: "GroupRequest";
    readonly id?: Maybe<Scalars["String"]["output"]>;
    readonly lensLimit?: Maybe<Scalars["Int"]["output"]>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type GroupSaveRequest = {
    readonly __typename?: "GroupSaveRequest";
    readonly description?: Maybe<Scalars["String"]["output"]>;
    readonly id?: Maybe<Scalars["String"]["output"]>;
    readonly lens?: Maybe<ReadonlyArray<Maybe<LensInGroup>>>;
    readonly name?: Maybe<Scalars["String"]["output"]>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
    readonly status?: Maybe<GroupStatus>;
};

export enum GroupStatus {
    Active = "ACTIVE",
    Archived = "ARCHIVED",
}

export type GroupWithConnections = {
    readonly __typename?: "GroupWithConnections";
    readonly connections?: Maybe<ReadonlyArray<Maybe<GroupLensConnection>>>;
    readonly group?: Maybe<Group>;
};

export type HistoryViewSettingInput = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly granularity: PayoutTimeGranularity;
    readonly limit: Scalars["Int"]["input"];
};

export type HostedLens = {
    readonly __typename?: "HostedLens";
    readonly createdAt?: Maybe<GoogleProtobufTimestamp>;
    readonly createdBy: Scalars["String"]["output"];
    readonly hostedLensMetadata?: Maybe<HostedLensMetadata>;
    readonly id: Scalars["ID"]["output"];
    readonly link: Scalars["String"]["output"];
    readonly organizationId: Scalars["ID"]["output"];
    readonly reference: Scalars["ID"]["output"];
    readonly status: HostedLensStatus;
    readonly updatedAt?: Maybe<GoogleProtobufTimestamp>;
};

export type HostedLensMetadata = {
    readonly __typename?: "HostedLensMetadata";
    readonly iconUrl: Scalars["String"]["output"];
    readonly lensId: Scalars["ID"]["output"];
    readonly name: Scalars["String"]["output"];
};

export enum HostedLensStatus {
    HostedLensStatusDraft = "HOSTED_LENS_STATUS_DRAFT",
    HostedLensStatusPublished = "HOSTED_LENS_STATUS_PUBLISHED",
    HostedLensStatusUnpublished = "HOSTED_LENS_STATUS_UNPUBLISHED",
    HostedLensStatusUnset = "HOSTED_LENS_STATUS_UNSET",
}

export enum HttpRequestMethod {
    Delete = "DELETE",
    Get = "GET",
    MethodUnset = "METHOD_UNSET",
    Post = "POST",
}

export type IldgEligibilityBreakdown = {
    readonly __typename?: "IldgEligibilityBreakdown";
    readonly criterion: IldgEligibilityCriterion;
    readonly eligible: Scalars["Boolean"]["output"];
};

export enum IldgEligibilityCriterion {
    IldgEligibilityAccountAge = "ILDG_ELIGIBILITY_ACCOUNT_AGE",
    IldgEligibilityLensPerformance = "ILDG_ELIGIBILITY_LENS_PERFORMANCE",
    IldgEligibilityPublicProfile = "ILDG_ELIGIBILITY_PUBLIC_PROFILE",
    IldgEligibilityResidingCountry = "ILDG_ELIGIBILITY_RESIDING_COUNTRY",
    IldgEligibilityUnset = "ILDG_ELIGIBILITY_UNSET",
    IldgEligibilityUserAge = "ILDG_ELIGIBILITY_USER_AGE",
}

export type InputApiToken = {
    readonly createdTsMillis?: InputMaybe<Scalars["Float"]["input"]>;
    readonly stage?: InputMaybe<MyLensesStage>;
    readonly token?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputAppInfo = {
    readonly apiTokens?: InputMaybe<ReadonlyArray<InputMaybe<InputApiToken>>>;
    readonly appIconUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly appId?: InputMaybe<Scalars["String"]["input"]>;
    readonly internalAppName?: InputMaybe<Scalars["String"]["input"]>;
    readonly orgId?: InputMaybe<Scalars["String"]["input"]>;
    readonly platformType?: InputMaybe<MyLensesPlatformType>;
    readonly prodLiveVersion?: InputMaybe<Scalars["Int"]["input"]>;
    readonly stagingLiveVersion?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputAppInput = {
    readonly internalAppName?: InputMaybe<Scalars["String"]["input"]>;
    readonly platformType?: InputMaybe<MyLensesPlatformType>;
};

export type InputAppVersion = {
    readonly appDescription?: InputMaybe<Scalars["String"]["input"]>;
    readonly appId?: InputMaybe<Scalars["String"]["input"]>;
    readonly appName?: InputMaybe<Scalars["String"]["input"]>;
    readonly features?: InputMaybe<ReadonlyArray<InputMaybe<InputFeature>>>;
    readonly orgId?: InputMaybe<Scalars["String"]["input"]>;
    readonly reviewState?: InputMaybe<MyLensesReviewState>;
    readonly version?: InputMaybe<Scalars["Int"]["input"]>;
    readonly versionName?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputApplicationAuthorizedOperationsRequest = {
    readonly appId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputApplicationAuthorizedOperationsResponse = {
    readonly appAuthorizedOperations?: InputMaybe<ReadonlyArray<InputMaybe<InputAuthorizedOperation>>>;
};

export type InputAuthorizedOperation = {
    readonly authOperation?: InputMaybe<MyLensesAuthOperation>;
    readonly authOperationTypes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
};

export type InputCameraKitLens = {
    readonly compoundId?: InputMaybe<InputLensCompoundId>;
    readonly createdAt?: InputMaybe<GoogleProtobufTimestampInput>;
    readonly creatorName?: InputMaybe<Scalars["String"]["input"]>;
    readonly hasMusic?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly iconUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly labels?: InputMaybe<ReadonlyArray<InputMaybe<InputLabel>>>;
    readonly lensSourceInfo?: InputMaybe<InputLenssourceModelLensSourceInfo>;
    readonly lensStatus?: InputMaybe<MyLensesLensStatus>;
    readonly minSdkVersion?: InputMaybe<Scalars["String"]["input"]>;
    readonly minWebSdkVersion?: InputMaybe<Scalars["String"]["input"]>;
    readonly name?: InputMaybe<Scalars["String"]["input"]>;
    readonly previewUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly previewWebpUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly removed?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly reviewStatus?: InputMaybe<Scalars["String"]["input"]>;
    readonly snapcode?: InputMaybe<InputSnapcode>;
    readonly thumbnailWebpUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly updatedAt?: InputMaybe<GoogleProtobufTimestampInput>;
    readonly vendorData?: InputMaybe<ReadonlyArray<InputMaybe<InputVendorDataItem>>>;
    readonly videoUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputCameraKitOrganization = {
    readonly accountIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly appsManagementEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly id?: InputMaybe<Scalars["String"]["input"]>;
    readonly internalLabels?: InputMaybe<InputInternalLabels>;
    readonly name?: InputMaybe<Scalars["String"]["input"]>;
    readonly permissions?: InputMaybe<InputUserPermissions>;
    readonly platformType?: InputMaybe<InputOrganizationPlatformType>;
    readonly role?: InputMaybe<OrganizationUserRole>;
};

export type InputComSnapCamerakitInternalAdminV1CollectOnboardingIntakeFormRequest = {
    readonly agency?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly appStoreUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly arShoppingUseCase?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly betaFeedbackOptIn?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly businessVertical?: InputMaybe<ComSnapCamerakitInternalAdminV1BusinessVertical>;
    readonly cameraKitG?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly companyName?: InputMaybe<Scalars["String"]["input"]>;
    readonly desiredOutcomes?: InputMaybe<Scalars["String"]["input"]>;
    readonly developmentExpertiseAvailable?: InputMaybe<ComSnapCamerakitInternalAdminV1DevelopmentExpertise>;
    readonly emailAddress?: InputMaybe<Scalars["String"]["input"]>;
    readonly existingSnapKitDeveloper?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly existingSnapchatAdvertiser?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly fullName?: InputMaybe<Scalars["String"]["input"]>;
    readonly googlePlayUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly hardwareOrPhysical?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly intendedApplicationType?: InputMaybe<ComSnapCamerakitInternalAdminV1ApplicationType>;
    readonly lensCreationMethod?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly useCaseDescription?: InputMaybe<Scalars["String"]["input"]>;
    readonly websiteUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1CollectOnboardingIntakeFormResponse = {
    readonly approvalStatus?: InputMaybe<ComSnapCamerakitInternalAdminV1CameraKitApprovalStatus>;
};

export type InputComSnapCamerakitInternalAdminV1ConsumeOnboardingTokenRequest = {
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
    readonly token?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1ConsumeOnboardingTokenResponse = {
    readonly cameraKitMobileAppAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly cameraKitWebAppAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly consumeTokenStatus?: InputMaybe<ComSnapCamerakitInternalAdminV1ConsumeTokenStatus>;
};

export type InputComSnapCamerakitInternalAdminV1InternalLabels = {
    readonly firstParty?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly live?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly managed?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1ListTokenRequest = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly endDateMillis?: InputMaybe<Scalars["Long"]["input"]>;
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly startDateMillis?: InputMaybe<Scalars["Long"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1ListTokenResponse = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly tokens?: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitInternalAdminV1OnboardingToken>>>;
};

export type InputComSnapCamerakitInternalAdminV1NotifyEmailRequest = {
    readonly formIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly notifyEmails?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly platformType?: InputMaybe<ComSnapCamerakitInternalAdminV1ApplicationType>;
    readonly templateId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1NotifyEmailResponse = {
    readonly successes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type InputComSnapCamerakitInternalAdminV1OnboardingToken = {
    readonly cameraKitMobileAppAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly cameraKitWebAppAccess?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly consumedTimeMillis?: InputMaybe<Scalars["Long"]["input"]>;
    readonly consumingOrganization?: InputMaybe<Scalars["String"]["input"]>;
    readonly createdTimeMillis?: InputMaybe<Scalars["Long"]["input"]>;
    readonly firstVerifiedTimeMillis?: InputMaybe<Scalars["Long"]["input"]>;
    readonly isRevoked?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly requestingEmail?: InputMaybe<Scalars["String"]["input"]>;
    readonly tokenValue?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1Organization = {
    readonly id?: InputMaybe<Scalars["String"]["input"]>;
    readonly internalLabels?: InputMaybe<InputComSnapCamerakitInternalAdminV1InternalLabels>;
    readonly name?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1RevokeTokenRequest = {
    readonly token?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1RevokeTokenResponse = {
    readonly tokenRevoked?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1SearchOrganizationRequest = {
    readonly query?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1SearchOrganizationResponse = {
    readonly organizations?: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitInternalAdminV1Organization>>>;
};

export type InputComSnapCamerakitInternalAdminV1SearchTokenRequest = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly requestingEmail?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1SearchTokenResponse = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly tokens?: InputMaybe<ReadonlyArray<InputMaybe<InputComSnapCamerakitInternalAdminV1OnboardingToken>>>;
};

export type InputComSnapCamerakitInternalAdminV1UpdateOrganizationInternalLabelsRequest = {
    readonly internalLabels?: InputMaybe<InputComSnapCamerakitInternalAdminV1InternalLabels>;
    readonly orgId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputComSnapCamerakitInternalAdminV1UpdateOrganizationInternalLabelsResponse = {
    readonly internalLabels?: InputMaybe<InputComSnapCamerakitInternalAdminV1InternalLabels>;
};

export type InputCreateAppVersionRequest = {
    readonly appId: Scalars["String"]["input"];
    readonly appVersionName: Scalars["String"]["input"];
    readonly sourceVersion: Scalars["Int"]["input"];
};

export type InputCreateApplicationRequest = {
    readonly appInfo?: InputMaybe<InputAppInput>;
    readonly orgId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputCreateApplicationResponse = {
    readonly appInfo?: InputMaybe<InputAppInfo>;
};

export type InputCreateConnectionBulkRequest = {
    readonly createRequests?: InputMaybe<ReadonlyArray<InputMaybe<InputCreateConnectionRequest>>>;
};

export type InputCreateConnectionBulkResponse = {
    readonly connections?: InputMaybe<ReadonlyArray<InputMaybe<InputGroupLensConnection>>>;
};

export type InputCreateConnectionRequest = {
    readonly groupId?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensCompoundId?: InputMaybe<InputLensCompoundId>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
    readonly priority?: InputMaybe<Scalars["Int"]["input"]>;
    readonly schedule?: InputMaybe<InputSchedule>;
    readonly vendorData?: InputMaybe<ReadonlyArray<InputMaybe<InputVendorDataItem>>>;
};

export type InputCreateVersionRequest = {
    readonly appId: Scalars["String"]["input"];
    readonly appVersionName: Scalars["String"]["input"];
    readonly sourceVersion: Scalars["Int"]["input"];
};

export type InputCreateVersionResponse = {
    readonly appVersion?: InputMaybe<InputAppVersion>;
};

export type InputEnableCameraKitFeatureRequest = {
    readonly appId: Scalars["String"]["input"];
    readonly sourceVersion: Scalars["Int"]["input"];
};

export type InputEnableCameraKitFeatureResponse = {
    /** NOT USED */
    readonly _?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputFeature = {
    readonly enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly featureScopeName?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputGenerateApiTokenRequest = {
    readonly appId?: InputMaybe<Scalars["String"]["input"]>;
    readonly stage?: InputMaybe<MyLensesStage>;
};

export type InputGenerateApiTokenResponse = {
    readonly apiToken?: InputMaybe<InputApiToken>;
};

export type InputGetAppVendorUuidOptinFlagRequest = {
    readonly appId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputGetAppVendorUuidOptinFlagResponse = {
    readonly appVendorOptInEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputGetApplicationInfoRequest = {
    readonly appId?: InputMaybe<Scalars["String"]["input"]>;
    readonly orgId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputGetApplicationInfoResponse = {
    readonly application?: InputMaybe<InputAppInfo>;
};

export type InputGetUserInfoRequest = {
    /** NOT USED */
    readonly _?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputGetVersionListRequest = {
    readonly appId: Scalars["String"]["input"];
};

export type InputGetVersionListResponse = {
    readonly versions: ReadonlyArray<InputAppVersion>;
};

export type InputGroup = {
    readonly createdAt?: InputMaybe<GoogleProtobufTimestampInput>;
    readonly description?: InputMaybe<Scalars["String"]["input"]>;
    readonly id?: InputMaybe<Scalars["String"]["input"]>;
    readonly isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly lenses?: InputMaybe<ReadonlyArray<InputMaybe<InputLensInGroup>>>;
    readonly name?: InputMaybe<Scalars["String"]["input"]>;
    readonly readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly status?: InputMaybe<GroupStatus>;
    readonly totalNumLenses?: InputMaybe<Scalars["Int"]["input"]>;
    readonly updatedAt?: InputMaybe<GoogleProtobufTimestampInput>;
};

export type InputGroupLensConnection = {
    readonly connectionId?: InputMaybe<Scalars["String"]["input"]>;
    readonly group?: InputMaybe<InputGroup>;
    readonly lens?: InputMaybe<InputCameraKitLens>;
    readonly priority?: InputMaybe<Scalars["Int"]["input"]>;
    readonly schedule?: InputMaybe<InputSchedule>;
    readonly vendorData?: InputMaybe<ReadonlyArray<InputMaybe<InputVendorDataItem>>>;
};

export type InputGroupListRequest = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensLimit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly offset?: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
    readonly query?: InputMaybe<GroupListRequestQuery>;
};

export type InputGroupListWithConnections = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly groupsWithConnections?: InputMaybe<ReadonlyArray<InputMaybe<InputGroupWithConnections>>>;
    readonly hasMore?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly total?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputGroupRequest = {
    readonly id?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensLimit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputGroupSaveRequest = {
    readonly description?: InputMaybe<Scalars["String"]["input"]>;
    readonly id?: InputMaybe<Scalars["String"]["input"]>;
    readonly lens?: InputMaybe<ReadonlyArray<InputMaybe<InputLensInGroup>>>;
    readonly name?: InputMaybe<Scalars["String"]["input"]>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
    readonly status?: InputMaybe<GroupStatus>;
};

export type InputGroupWithConnections = {
    readonly connections?: InputMaybe<ReadonlyArray<InputMaybe<InputGroupLensConnection>>>;
    readonly group?: InputMaybe<InputGroup>;
};

export type InputInternalLabels = {
    readonly firstParty?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly live?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly managed?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputIsCameraKitEnabledOrganizationRequest = {
    readonly applicationType?: InputMaybe<MyLensesPlatformType>;
    readonly orgId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputIsCameraKitEnabledOrganizationResponse = {
    readonly isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputIsCameraKitEnabledRequest = {
    readonly applicationType?: InputMaybe<MyLensesPlatformType>;
    readonly orgId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputIsCameraKitEnabledResponse = {
    readonly isEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputLabel = {
    readonly key?: InputMaybe<Scalars["String"]["input"]>;
    readonly value?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLensCompoundId = {
    readonly id?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensSourceType?: InputMaybe<LenssourceModelLensSourceType>;
    readonly reference?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLensInGroup = {
    readonly lens?: InputMaybe<InputCameraKitLens>;
    readonly priority?: InputMaybe<Scalars["Int"]["input"]>;
    readonly vendorData?: InputMaybe<ReadonlyArray<InputMaybe<InputVendorDataItem>>>;
};

export type InputLensListWithConnections = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly hasMore?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly lensesWithConnections?: InputMaybe<ReadonlyArray<InputMaybe<InputLensWithConnections>>>;
    readonly total?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputLensRequest = {
    readonly lensCompoundId?: InputMaybe<InputLensCompoundId>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLensWithConnections = {
    readonly connections?: InputMaybe<ReadonlyArray<InputMaybe<InputGroupLensConnection>>>;
    readonly lens?: InputMaybe<InputCameraKitLens>;
};

export type InputLensesByIdsRequest = {
    readonly lensCompoundIds?: InputMaybe<ReadonlyArray<InputMaybe<InputLensCompoundId>>>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLensesRequest = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensSourceIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly offset?: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLenssourceAffectedGroupByLensSource = {
    readonly affectedNumLenses?: InputMaybe<Scalars["Int"]["input"]>;
    readonly groupId?: InputMaybe<Scalars["String"]["input"]>;
    readonly groupName?: InputMaybe<Scalars["String"]["input"]>;
    readonly lenses?: InputMaybe<ReadonlyArray<InputMaybe<InputCameraKitLens>>>;
};

export type InputLenssourceAffectedGroupCursorData = {
    readonly lastGroupId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLenssourceGetAffectedGroupsRequest = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensLimit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly lensSourceId?: InputMaybe<Scalars["String"]["input"]>;
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLenssourceGetAffectedGroupsResponse = {
    readonly affectedGroups?: InputMaybe<ReadonlyArray<InputMaybe<InputLenssourceAffectedGroupByLensSource>>>;
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly hasMore?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly total?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputLenssourceGetLensSourceListEnabledRequest = {
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLenssourceGetLensSourceListEnabledResponse = {
    readonly lensSourceMap?: InputMaybe<ReadonlyArray<InputMaybe<InputLenssourceLensSourcesMapByType>>>;
};

export type InputLenssourceGetLensSourceListRequest = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensSourceType?: InputMaybe<LenssourceModelLensSourceType>;
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
    readonly query?: InputMaybe<LenssourceGetLensSourceListRequestQuery>;
};

export type InputLenssourceGetLensSourceListResponse = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly hasMore?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly lensSourceList?: InputMaybe<ReadonlyArray<InputMaybe<InputLenssourceModelLensSource>>>;
    readonly total?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputLenssourceGetSupportedLensSourceTypesRequest = {
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLenssourceGetSupportedLensSourceTypesResponse = {
    readonly lensSourceTypes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
};

export type InputLenssourceLensSourceDisableTask = {
    readonly createdAt?: InputMaybe<GoogleProtobufTimestampInput>;
    readonly payload?: InputMaybe<InputLenssourceLensSourceDisableTaskPayload>;
    readonly taskId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLenssourceLensSourceDisableTaskPayload = {
    readonly lensSourceList?: InputMaybe<ReadonlyArray<InputMaybe<InputLenssourceModelLensSource>>>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLenssourceLensSourceListCursorData = {
    readonly externalCursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly lastValue?: InputMaybe<Scalars["String"]["input"]>;
    readonly offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type InputLenssourceLensSourceUpdate = {
    readonly enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly externalId?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensSourceId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLenssourceLensSourcesMapByType = {
    readonly lensSourceList?: InputMaybe<ReadonlyArray<InputMaybe<InputLenssourceModelLensSource>>>;
    readonly lensSourceType?: InputMaybe<LenssourceModelLensSourceType>;
};

export type InputLenssourceModelLensSource = {
    readonly alias?: InputMaybe<Scalars["String"]["input"]>;
    readonly createdAt?: InputMaybe<GoogleProtobufTimestampInput>;
    readonly enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly externalId?: InputMaybe<Scalars["String"]["input"]>;
    readonly id?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensSourceType?: InputMaybe<LenssourceModelLensSourceType>;
    readonly name?: InputMaybe<Scalars["String"]["input"]>;
    readonly owner?: InputMaybe<Scalars["String"]["input"]>;
    readonly reference?: InputMaybe<Scalars["String"]["input"]>;
    readonly updatedAt?: InputMaybe<GoogleProtobufTimestampInput>;
};

export type InputLenssourceModelLensSourceInfo = {
    readonly name?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLenssourceUpdateLensSourcesRequest = {
    readonly lensSourceUpdates?: InputMaybe<ReadonlyArray<InputMaybe<InputLenssourceLensSourceUpdate>>>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputLenssourceUpdateLensSourcesResponse = {
    readonly lensSourceList?: InputMaybe<ReadonlyArray<InputMaybe<InputLenssourceModelLensSource>>>;
    readonly taskId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputListApplicationRequest = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly orgId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputListApplicationResponse = {
    readonly applications?: InputMaybe<ReadonlyArray<InputMaybe<InputAppInfo>>>;
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputOrganicStatsProxyRequest = {
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
    readonly request?: InputMaybe<InputSnapchatReportingOrganicGetOrganicStatsRequest>;
};

export type InputOrganicStatsProxyResponse = {
    readonly lenses?: InputMaybe<ReadonlyArray<InputMaybe<InputCameraKitLens>>>;
    readonly response?: InputMaybe<InputSnapchatReportingOrganicGetOrganicStatsResponse>;
};

export type InputOrganizationAuthorizedOperationsRequest = {
    readonly orgId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputOrganizationAuthorizedOperationsResponse = {
    readonly orgAuthorizedOperations?: InputMaybe<ReadonlyArray<InputMaybe<InputAuthorizedOperation>>>;
};

export type InputOrganizationCreateRequest = {
    readonly orgName?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputOrganizationCreateResponse = {
    readonly organization?: InputMaybe<InputCameraKitOrganization>;
};

export type InputOrganizationEnableCameraKitRequest = {
    readonly orgId?: InputMaybe<Scalars["String"]["input"]>;
    readonly token?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputOrganizationEnableCameraKitResponse = {
    /** NOT USED */
    readonly _?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputOrganizationListRequest = {
    readonly includeUnenabledOrgs?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputOrganizationListResponse = {
    readonly organizations?: InputMaybe<ReadonlyArray<InputMaybe<InputCameraKitOrganization>>>;
};

export type InputOrganizationPlatformType = {
    readonly mobile?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly web?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputOrganizationSearchRequest = {
    readonly query?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputPinGroupRequest = {
    readonly groupId?: InputMaybe<Scalars["String"]["input"]>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputPinGroupResponse = {
    readonly groupId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputPortalMe = {
    readonly bitmojiUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly hasAgreedToLatestEula?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly latestEulaId?: InputMaybe<Scalars["String"]["input"]>;
    readonly latestEulaUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly snapchatUser?: InputMaybe<InputSnapchatUser>;
};

export type InputPortalMeRequest = {
    /** NOT USED */
    readonly _?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputPortalMeResponse = {
    readonly me?: InputMaybe<InputPortalMe>;
};

export type InputReleaseConnectionBulkRequest = {
    readonly releaseRequests?: InputMaybe<ReadonlyArray<InputMaybe<InputReleaseConnectionRequest>>>;
};

export type InputReleaseConnectionBulkResponse = {
    readonly releaseResponses?: InputMaybe<ReadonlyArray<InputMaybe<InputReleaseConnectionResponse>>>;
};

export type InputReleaseConnectionRequest = {
    readonly groupId?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensCompoundId?: InputMaybe<InputLensCompoundId>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputReleaseConnectionResponse = {
    readonly connectionId?: InputMaybe<Scalars["String"]["input"]>;
    readonly groupId?: InputMaybe<Scalars["String"]["input"]>;
    readonly lensCompoundId?: InputMaybe<InputLensCompoundId>;
};

export type InputRevokeCameraKitRequest = {
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
    readonly principalId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputRevokeCameraKitResponse = {
    /** NOT USED */
    readonly _?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputSaveLensRequest = {
    readonly lensCompoundId?: InputMaybe<InputLensCompoundId>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
    readonly vendorData?: InputMaybe<ReadonlyArray<InputMaybe<InputVendorDataItem>>>;
};

export type InputSchedule = {
    readonly scheduleEnd?: InputMaybe<GoogleProtobufTimestampInput>;
    readonly scheduleStart?: InputMaybe<GoogleProtobufTimestampInput>;
    readonly useClientTimezone?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputSetAppVendorUuidOptinFlagRequest = {
    readonly appId?: InputMaybe<Scalars["String"]["input"]>;
    readonly appVendorOptInEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputSetAppVendorUuidOptinFlagResponse = {
    readonly appVendorOptInEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputSnapKitOnboardRequest = {
    readonly appId?: InputMaybe<Scalars["String"]["input"]>;
    readonly cameraKitEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly organizationId?: InputMaybe<Scalars["String"]["input"]>;
    readonly principalId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputSnapKitOnboardResponse = {
    /** NOT USED */
    readonly _?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputSnapchatReportingOrganicGetOrganicStatsRequest = {
    readonly assetId?: InputMaybe<Scalars["String"]["input"]>;
    readonly assetType?: InputMaybe<SnapchatReportingOrganicAssetType>;
    readonly breakdownAssetType?: InputMaybe<SnapchatReportingOrganicAssetType>;
    readonly breakdownIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly conversionReportTime?: InputMaybe<SnapchatReportingOrganicConversionReportTime>;
    readonly conversionSourceType?: InputMaybe<SnapchatReportingOrganicConversionSourceType>;
    readonly conversionSwipeUpWindow?: InputMaybe<SnapchatReportingOrganicConversionSwipeUpWindow>;
    readonly conversionViewWindow?: InputMaybe<SnapchatReportingOrganicConversionViewWindow>;
    readonly endTime?: InputMaybe<GoogleProtobufTimestampInput>;
    readonly fields?: InputMaybe<ReadonlyArray<InputMaybe<InputSnapchatReportingOrganicOrganicStatsField>>>;
    readonly granularity?: InputMaybe<SnapchatReportingOrganicGranularity>;
    readonly isTest?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly offset?: InputMaybe<Scalars["Int"]["input"]>;
    readonly placeCollectionId?: InputMaybe<Scalars["String"]["input"]>;
    readonly profileId?: InputMaybe<Scalars["String"]["input"]>;
    readonly publisherId?: InputMaybe<Scalars["String"]["input"]>;
    readonly requestId?: InputMaybe<Scalars["String"]["input"]>;
    readonly requestType?: InputMaybe<SnapchatReportingOrganicRequestType>;
    readonly sortBy?: InputMaybe<SnapchatReportingOrganicMetricField>;
    readonly sortByDimension?: InputMaybe<SnapchatReportingOrganicUserDimension>;
    readonly sortByDimensionBreakdowns?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
    readonly sortDirection?: InputMaybe<SnapchatReportingOrganicSortDirection>;
    readonly startTime?: InputMaybe<GoogleProtobufTimestampInput>;
    readonly topDimensionLimit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly userId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputSnapchatReportingOrganicGetOrganicStatsResponse = {
    readonly responseEntry?: InputMaybe<
        ReadonlyArray<InputMaybe<InputSnapchatReportingOrganicOrganicStatsResponseEntry>>
    >;
};

export type InputSnapchatReportingOrganicOrganicStat = {
    readonly dimensionBreakdown?: InputMaybe<Scalars["String"]["input"]>;
    readonly percentageValue?: InputMaybe<Scalars["Float"]["input"]>;
    readonly value?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputSnapchatReportingOrganicOrganicStatsField = {
    readonly fieldName?: InputMaybe<SnapchatReportingOrganicMetricField>;
    readonly reportDimension?: InputMaybe<SnapchatReportingOrganicUserDimension>;
    readonly reportDimensionFilters?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type InputSnapchatReportingOrganicOrganicStatsResponseDimensionEntry = {
    readonly field?: InputMaybe<InputSnapchatReportingOrganicOrganicStatsField>;
    readonly stats?: InputMaybe<ReadonlyArray<InputMaybe<InputSnapchatReportingOrganicOrganicStat>>>;
};

export type InputSnapchatReportingOrganicOrganicStatsResponseEntry = {
    readonly assetId?: InputMaybe<Scalars["String"]["input"]>;
    readonly assetType?: InputMaybe<SnapchatReportingOrganicAssetType>;
    readonly statsResponseTimeEntry?: InputMaybe<
        ReadonlyArray<InputMaybe<InputSnapchatReportingOrganicOrganicStatsResponseTimeEntry>>
    >;
};

export type InputSnapchatReportingOrganicOrganicStatsResponseTimeEntry = {
    readonly stats?: InputMaybe<
        ReadonlyArray<InputMaybe<InputSnapchatReportingOrganicOrganicStatsResponseDimensionEntry>>
    >;
    readonly timestamp?: InputMaybe<GoogleProtobufTimestampInput>;
};

export type InputSnapchatUser = {
    readonly displayName?: InputMaybe<Scalars["String"]["input"]>;
    readonly username?: InputMaybe<Scalars["String"]["input"]>;
    readonly verifiedEmail?: InputMaybe<Scalars["String"]["input"]>;
};

export type InputSnapcode = {
    readonly deeplink?: InputMaybe<Scalars["String"]["input"]>;
    readonly expiresAt?: InputMaybe<GoogleProtobufTimestampInput>;
    readonly imageUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly isTemporary?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputUserInfo = {
    readonly iconLink?: InputMaybe<Scalars["String"]["input"]>;
    readonly id?: InputMaybe<Scalars["String"]["input"]>;
    readonly name?: InputMaybe<Scalars["String"]["input"]>;
    readonly permissions?: InputMaybe<InputUserPermissions>;
};

export type InputUserPermissions = {
    readonly readGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly readLensAnalytics?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly readLensSources?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly readLenses?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly scheduleLenses?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly updateGroups?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly updateLensSources?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly updateLenses?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InputVendorDataItem = {
    readonly key?: InputMaybe<Scalars["String"]["input"]>;
    readonly value?: InputMaybe<Scalars["String"]["input"]>;
};

export type InternalLabels = {
    readonly __typename?: "InternalLabels";
    readonly firstParty?: Maybe<Scalars["Boolean"]["output"]>;
    readonly live?: Maybe<Scalars["Boolean"]["output"]>;
    readonly managed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type IsCameraKitEnabledOrganizationRequest = {
    readonly __typename?: "IsCameraKitEnabledOrganizationRequest";
    readonly applicationType?: Maybe<MyLensesPlatformType>;
    readonly orgId?: Maybe<Scalars["String"]["output"]>;
};

export type IsCameraKitEnabledOrganizationResponse = {
    readonly __typename?: "IsCameraKitEnabledOrganizationResponse";
    readonly isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type IsCameraKitEnabledRequest = {
    readonly __typename?: "IsCameraKitEnabledRequest";
    readonly applicationType?: Maybe<MyLensesPlatformType>;
    readonly orgId?: Maybe<Scalars["String"]["output"]>;
};

export type IsCameraKitEnabledResponse = {
    readonly __typename?: "IsCameraKitEnabledResponse";
    readonly isEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Label = {
    readonly __typename?: "Label";
    readonly key?: Maybe<Scalars["String"]["output"]>;
    readonly value?: Maybe<Scalars["String"]["output"]>;
};

export type LensAccountId = {
    readonly __typename?: "LensAccountID";
    readonly lensSpaceId?: Maybe<Scalars["ID"]["output"]>;
    readonly organizationAndAdAccountId?: Maybe<OrganizationAndAdAccountId>;
    /** @deprecated use organizationAndAdAccountId */
    readonly organizationId?: Maybe<Scalars["ID"]["output"]>;
    readonly profileId?: Maybe<Scalars["ID"]["output"]>;
    readonly userId: Scalars["ID"]["output"];
};

export type LensAccountIdInput = {
    readonly lensSpaceId: Scalars["ID"]["input"];
};

/** Available history is not full lifetime activity: expired unpaid snapshots and legacy paid drivers may be unavailable. */
export type LensActivityCoverage = {
    readonly __typename?: "LensActivityCoverage";
    /** Oldest known data-through day among the current month's returned windows. */
    readonly dataThrough?: Maybe<Scalars["DateTime"]["output"]>;
    /** Earliest retained monthly snapshot window requested, UTC. */
    readonly monthlySnapshotsFrom: Scalars["DateTime"]["output"];
    /** Earliest earnings month with available paid monthly activity, if any. */
    readonly paidHistoryFrom?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Available monthly activity, including unpaid and current-month values; users are summed across months. */
export type LensActivityTotal = {
    readonly __typename?: "LensActivityTotal";
    readonly lens?: Maybe<MyLensesLens>;
    /** Recorded Lens+ payments, independent of activity availability. */
    readonly paidAmountMilliUsd: Scalars["Long"]["output"];
    /** Null when no monthly activity is available; known zero snapshots remain zero. */
    readonly totals?: Maybe<LensScoreMetrics>;
    readonly unlockableId: Scalars["String"]["output"];
};

export type LensActivityTotalsInput = {
    /** Last unlockable ID from the previous page. */
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    /** Page size (1..200). */
    readonly limit?: Scalars["Int"]["input"];
    /** Empty or omitted = the signed-in creator's available Lens+ history. Max 100 unique IDs. */
    readonly unlockableIds?: ReadonlyArray<Scalars["String"]["input"]>;
};

export type LensActivityTotalsResponse = {
    readonly __typename?: "LensActivityTotalsResponse";
    readonly coverage: LensActivityCoverage;
    /** Sums available monthly values before pagination. Null when lenses exist but all activity is unavailable. */
    readonly creatorTotals?: Maybe<LensScoreMetrics>;
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly lenses: ReadonlyArray<LensActivityTotal>;
    readonly paidAmountMilliUsd: Scalars["Long"]["output"];
    readonly totalLensCount: Scalars["Int"]["output"];
};

export enum LensAutomationToolMaintenanceStatus {
    LensAutomationToolMaintenanceStatusOff = "LENS_AUTOMATION_TOOL_MAINTENANCE_STATUS_OFF",
    LensAutomationToolMaintenanceStatusOn = "LENS_AUTOMATION_TOOL_MAINTENANCE_STATUS_ON",
    LensAutomationToolMaintenanceStatusUnset = "LENS_AUTOMATION_TOOL_MAINTENANCE_STATUS_UNSET",
}

export type LensCategoryList = {
    readonly __typename?: "LensCategoryList";
    readonly parentLensCategoriesList: ReadonlyArray<MyLensesLensCategory>;
    readonly subLensCategoriesList: ReadonlyArray<MyLensesLensCategory>;
};

export type LensCloudApp = {
    readonly __typename?: "LensCloudApp";
    readonly appId: Scalars["ID"]["output"];
};

export type LensCloudAppRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type LensCompoundId = {
    readonly __typename?: "LensCompoundId";
    readonly id?: Maybe<Scalars["String"]["output"]>;
    readonly lensSourceType?: Maybe<LenssourceModelLensSourceType>;
    readonly reference?: Maybe<Scalars["String"]["output"]>;
};

export enum LensCreatorPayoutEligibility {
    LensCreatorPayoutEligibilityEligible = "LENS_CREATOR_PAYOUT_ELIGIBILITY_ELIGIBLE",
    LensCreatorPayoutEligibilityIneligible = "LENS_CREATOR_PAYOUT_ELIGIBILITY_INELIGIBLE",
    LensCreatorPayoutEligibilityPending = "LENS_CREATOR_PAYOUT_ELIGIBILITY_PENDING",
    LensCreatorPayoutEligibilityUnset = "LENS_CREATOR_PAYOUT_ELIGIBILITY_UNSET",
}

export type LensCtaDeeplinkInput = {
    readonly androidAppUrl: Scalars["String"]["input"];
    readonly appName: Scalars["String"]["input"];
    readonly iosAppId: Scalars["Float"]["input"];
    readonly uri: Scalars["String"]["input"];
};

export type LensCtaWebsite = {
    readonly __typename?: "LensCtaWebsite";
    readonly url: Scalars["String"]["output"];
};

export type LensCtaWebsiteInput = {
    readonly url: Scalars["String"]["input"];
};

export type LensDestination = {
    readonly __typename?: "LensDestination";
    readonly destinationType: DestinationTypeBm;
    readonly id: Scalars["ID"]["output"];
    readonly lensId: Scalars["ID"]["output"];
    readonly publicProfileMetadata?: Maybe<PublicProfileMetadata>;
    readonly status: MyLensesLensStatus;
};

export type LensEngagementAgeGenderCell = {
    readonly __typename?: "LensEngagementAgeGenderCell";
    readonly actionsUuSuppressed: Scalars["Boolean"]["output"];
    readonly ageBucket: Scalars["String"]["output"];
    readonly gender: Scalars["String"]["output"];
    readonly subscribeCount: Scalars["Int"]["output"];
    readonly subscribeCountSuppressed: Scalars["Boolean"]["output"];
    readonly subscriberActionsUu: Scalars["Int"]["output"];
};

export type LensEngagementBreakdowns = {
    readonly __typename?: "LensEngagementBreakdowns";
    readonly ageBuckets: ReadonlyArray<LensEngagementCell>;
    readonly ageGenders: ReadonlyArray<LensEngagementAgeGenderCell>;
    readonly countries: ReadonlyArray<LensEngagementCell>;
    readonly genders: ReadonlyArray<LensEngagementCell>;
};

export type LensEngagementCell = {
    readonly __typename?: "LensEngagementCell";
    readonly actionsUuSuppressed: Scalars["Boolean"]["output"];
    readonly subscribeCount: Scalars["Int"]["output"];
    readonly subscribeCountSuppressed: Scalars["Boolean"]["output"];
    readonly subscriberActionsUu: Scalars["Int"]["output"];
    readonly value: Scalars["String"]["output"];
};

export type LensInGroup = {
    readonly __typename?: "LensInGroup";
    readonly lens?: Maybe<CameraKitLens>;
    readonly priority?: Maybe<Scalars["Int"]["output"]>;
    readonly vendorData?: Maybe<ReadonlyArray<Maybe<VendorDataItem>>>;
};

export type LensListViewSettingInput = {
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly limit: Scalars["Int"]["input"];
    readonly sortBy: PayoutSortBy;
    readonly sortOrder: PayoutSortOrder;
};

export type LensListWithConnections = {
    readonly __typename?: "LensListWithConnections";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly hasMore?: Maybe<Scalars["Boolean"]["output"]>;
    readonly lensesWithConnections?: Maybe<ReadonlyArray<Maybe<LensWithConnections>>>;
    readonly total?: Maybe<Scalars["Int"]["output"]>;
};

export type LensPayout = {
    readonly __typename?: "LensPayout";
    readonly amountMilliUsd: Scalars["Long"]["output"];
    readonly expectedBy?: Maybe<Scalars["DateTime"]["output"]>;
    readonly paidOn?: Maybe<Scalars["DateTime"]["output"]>;
    readonly state: LensPayoutState;
};

export type LensPayoutHistoryRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type LensPayoutHistoryResponse = {
    readonly __typename?: "LensPayoutHistoryResponse";
    readonly lastPayoutDate?: Maybe<Scalars["DateTime"]["output"]>;
    readonly totalEarningsMilliUsd: Scalars["Long"]["output"];
};

export enum LensPayoutState {
    None = "NONE",
    NotDue = "NOT_DUE",
    Paid = "PAID",
    Pending = "PENDING",
}

export type LensPlusSignupTotals = {
    readonly __typename?: "LensPlusSignupTotals";
    readonly estimated: Scalars["Int"]["output"];
    readonly paid: Scalars["Int"]["output"];
    readonly settled: Scalars["Int"]["output"];
    readonly total: Scalars["Int"]["output"];
};

export type LensRejectionErrors = {
    readonly __typename?: "LensRejectionErrors";
    readonly hasSubmissionErrors: Scalars["Boolean"]["output"];
    readonly heading: Scalars["String"]["output"];
    readonly messagesList: ReadonlyArray<Scalars["String"]["output"]>;
    readonly violatingComponentsList: ReadonlyArray<Scalars["String"]["output"]>;
};

export type LensRequest = {
    readonly __typename?: "LensRequest";
    readonly lensCompoundId?: Maybe<LensCompoundId>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type LensScoreDailyBucket = {
    readonly __typename?: "LensScoreDailyBucket";
    readonly date: Scalars["DateTime"]["output"];
    readonly metrics: LensScoreMetrics;
};

export enum LensScoreEligibility {
    BelowMinimum = "BELOW_MINIMUM",
    Eligible = "ELIGIBLE",
    NotEligible = "NOT_ELIGIBLE",
}

export enum LensScoreFinalizationStatus {
    Estimated = "ESTIMATED",
    Finalized = "FINALIZED",
}

export type LensScoreMetrics = {
    readonly __typename?: "LensScoreMetrics";
    readonly lensScore: Scalars["Int"]["output"];
    readonly subscribeCount: Scalars["Int"]["output"];
    readonly subscriberActionsUu: Scalars["Int"]["output"];
};

export type LensScoreResult = {
    readonly __typename?: "LensScoreResult";
    readonly lens?: Maybe<MyLensesLens>;
    readonly priorClosedMonth?: Maybe<LensScoreWindow>;
    readonly selectedMonth: LensScoreWindow;
    readonly unlockableId: Scalars["Float"]["output"];
};

export type LensScoreWindow = {
    readonly __typename?: "LensScoreWindow";
    readonly dailyBuckets: ReadonlyArray<LensScoreDailyBucket>;
    readonly dataThrough?: Maybe<Scalars["DateTime"]["output"]>;
    readonly eligibility?: Maybe<LensScoreEligibility>;
    readonly engagementBreakdowns?: Maybe<LensEngagementBreakdowns>;
    readonly finalizationStatus: LensScoreFinalizationStatus;
    readonly payout: LensPayout;
    readonly totals?: Maybe<LensScoreMetrics>;
    readonly windowEnd: Scalars["DateTime"]["output"];
    readonly windowStart: Scalars["DateTime"]["output"];
};

export type LensScoresInput = {
    /** First day of the month, UTC. Any day/time is normalized to day 1. */
    readonly calendarMonth: Scalars["DateTime"]["input"];
    /** Last unlockable ID from the previous page; requires limit. */
    readonly cursor?: InputMaybe<Scalars["String"]["input"]>;
    readonly includeCreatorTotal?: Scalars["Boolean"]["input"];
    readonly includeDailyBreakdown?: Scalars["Boolean"]["input"];
    /** Country + age cells; gated by MY_LENSES_LENS_PLUS_DEMOGRAPHICS. */
    readonly includeEngagementBreakdowns?: Scalars["Boolean"]["input"];
    readonly includePriorClosedMonth?: Scalars["Boolean"]["input"];
    /** Page size (1..200). Omit to return all rows in backend order. */
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    /** Empty or omitted = every Lens+ exclusive lens the creator owns. Max 100, unique. */
    readonly unlockableIds?: ReadonlyArray<Scalars["String"]["input"]>;
};

export type LensScoresResponse = {
    readonly __typename?: "LensScoresResponse";
    readonly creatorTotal?: Maybe<LensScoreResult>;
    /** Last returned unlockable ID when more rows remain, otherwise null. */
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly lensResults: ReadonlyArray<LensScoreResult>;
    /** Minimum lensScore for a payout share in the selected month. */
    readonly payoutMinimumScore: Scalars["Int"]["output"];
    readonly summary: LensScoresSummary;
};

/** Whole-month activity, counts and paid earnings, independent of pagination and metadata availability. */
export type LensScoresSummary = {
    readonly __typename?: "LensScoresSummary";
    /**
     * Count of available monthly totals with score at least payoutMinimumScore, regardless of eligibility.
     * Null when all returned lens rows lack totals; zero when no lens rows exist.
     */
    readonly availableScoredCount?: Maybe<Scalars["Int"]["output"]>;
    /**
     * Sums available per-lens monthly totals; subscribers are summed across lenses.
     * Null when all returned lens rows lack totals; zero when no lens rows exist.
     */
    readonly availableTotals?: Maybe<LensScoreMetrics>;
    /** Count of selected-month lens rows whose totals are unavailable. */
    readonly missingTotalsCount: Scalars["Int"]["output"];
    /** Sum of selected-month PAID payout amounts only, in milli-USD. */
    readonly paidAmountMilliUsd: Scalars["Long"]["output"];
    /** Count with score at least payoutMinimumScore; null if any monthly totals are unavailable. */
    readonly scoredCount?: Maybe<Scalars["Int"]["output"]>;
    readonly submittedCount: Scalars["Int"]["output"];
};

export enum LensSourceApplication {
    SourceApplicationBbgFinalizationTool = "SOURCE_APPLICATION_BBG_FINALIZATION_TOOL",
    SourceApplicationLensApplier = "SOURCE_APPLICATION_LENS_APPLIER",
    SourceApplicationLensStudio = "SOURCE_APPLICATION_LENS_STUDIO",
    SourceApplicationLensStudioMobile = "SOURCE_APPLICATION_LENS_STUDIO_MOBILE",
    SourceApplicationLensStudioWeb = "SOURCE_APPLICATION_LENS_STUDIO_WEB",
    SourceApplicationLensWebBuilder = "SOURCE_APPLICATION_LENS_WEB_BUILDER",
    SourceApplicationMyAiChatbot = "SOURCE_APPLICATION_MY_AI_CHATBOT",
    SourceApplicationSnapAi = "SOURCE_APPLICATION_SNAP_AI",
    SourceApplicationUnset = "SOURCE_APPLICATION_UNSET",
}

export type LensSpace = {
    readonly __typename?: "LensSpace";
    readonly id: Scalars["ID"]["output"];
    readonly name: Scalars["String"]["output"];
    readonly organizationId: Scalars["String"]["output"];
};

export type LensStudioAnalytics = {
    readonly __typename?: "LensStudioAnalytics";
    readonly appBuild: Scalars["String"]["output"];
    readonly appSessionId: Scalars["ID"]["output"];
    readonly appVersion: Scalars["String"]["output"];
    readonly documentId: Scalars["ID"]["output"];
    readonly gpuFamily: Scalars["String"]["output"];
    readonly gpuOpenglVersion: Scalars["String"]["output"];
    readonly gpuVendor: Scalars["String"]["output"];
    readonly installationId: Scalars["ID"]["output"];
    readonly originalDocumentId: Scalars["ID"]["output"];
    readonly osType: Scalars["String"]["output"];
    readonly osVersion: Scalars["String"]["output"];
};

export type LensStudioVersion = {
    readonly __typename?: "LensStudioVersion";
    readonly major: Scalars["Int"]["output"];
    readonly minor: Scalars["Int"]["output"];
    readonly patch: Scalars["Int"]["output"];
};

export type LensStudioVersionOption = {
    readonly __typename?: "LensStudioVersionOption";
    readonly label: Scalars["String"]["output"];
    readonly value: LensStudioVersion;
};

export type LensUsage = {
    readonly __typename?: "LensUsage";
    readonly lensId: Scalars["ID"]["output"];
    readonly lensName: Scalars["String"]["output"];
};

export type LensUsageConnection = {
    readonly __typename?: "LensUsageConnection";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly nodes: ReadonlyArray<LensUsage>;
};

export type LensWithConnections = {
    readonly __typename?: "LensWithConnections";
    readonly connections?: Maybe<ReadonlyArray<Maybe<GroupLensConnection>>>;
    readonly lens?: Maybe<CameraKitLens>;
};

export type LensesByIdsRequest = {
    readonly __typename?: "LensesByIdsRequest";
    readonly lensCompoundIds?: Maybe<ReadonlyArray<Maybe<LensCompoundId>>>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type LensesRequest = {
    readonly __typename?: "LensesRequest";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly lensSourceIds?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    readonly limit?: Maybe<Scalars["Int"]["output"]>;
    readonly offset?: Maybe<Scalars["Int"]["output"]>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type LenssourceAffectedGroupByLensSource = {
    readonly __typename?: "LenssourceAffectedGroupByLensSource";
    readonly affectedNumLenses?: Maybe<Scalars["Int"]["output"]>;
    readonly groupId?: Maybe<Scalars["String"]["output"]>;
    readonly groupName?: Maybe<Scalars["String"]["output"]>;
    readonly lenses?: Maybe<ReadonlyArray<Maybe<CameraKitLens>>>;
};

export type LenssourceAffectedGroupCursorData = {
    readonly __typename?: "LenssourceAffectedGroupCursorData";
    readonly lastGroupId?: Maybe<Scalars["String"]["output"]>;
};

export type LenssourceGetAffectedGroupsRequest = {
    readonly __typename?: "LenssourceGetAffectedGroupsRequest";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly lensLimit?: Maybe<Scalars["Int"]["output"]>;
    readonly lensSourceId?: Maybe<Scalars["String"]["output"]>;
    readonly limit?: Maybe<Scalars["Int"]["output"]>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type LenssourceGetAffectedGroupsResponse = {
    readonly __typename?: "LenssourceGetAffectedGroupsResponse";
    readonly affectedGroups?: Maybe<ReadonlyArray<Maybe<LenssourceAffectedGroupByLensSource>>>;
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly hasMore?: Maybe<Scalars["Boolean"]["output"]>;
    readonly total?: Maybe<Scalars["Int"]["output"]>;
};

export type LenssourceGetLensSourceListEnabledRequest = {
    readonly __typename?: "LenssourceGetLensSourceListEnabledRequest";
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type LenssourceGetLensSourceListEnabledResponse = {
    readonly __typename?: "LenssourceGetLensSourceListEnabledResponse";
    readonly lensSourceMap?: Maybe<ReadonlyArray<Maybe<LenssourceLensSourcesMapByType>>>;
};

export type LenssourceGetLensSourceListRequest = {
    readonly __typename?: "LenssourceGetLensSourceListRequest";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly lensSourceType?: Maybe<LenssourceModelLensSourceType>;
    readonly limit?: Maybe<Scalars["Int"]["output"]>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
    readonly query?: Maybe<LenssourceGetLensSourceListRequestQuery>;
};

export enum LenssourceGetLensSourceListRequestQuery {
    All = "ALL",
    OnlyDisabled = "ONLY_DISABLED",
    OnlyEnabledUnset = "ONLY_ENABLED_UNSET",
}

export type LenssourceGetLensSourceListResponse = {
    readonly __typename?: "LenssourceGetLensSourceListResponse";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly hasMore?: Maybe<Scalars["Boolean"]["output"]>;
    readonly lensSourceList?: Maybe<ReadonlyArray<Maybe<LenssourceModelLensSource>>>;
    readonly total?: Maybe<Scalars["Int"]["output"]>;
};

export type LenssourceGetSupportedLensSourceTypesRequest = {
    readonly __typename?: "LenssourceGetSupportedLensSourceTypesRequest";
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type LenssourceGetSupportedLensSourceTypesResponse = {
    readonly __typename?: "LenssourceGetSupportedLensSourceTypesResponse";
    readonly lensSourceTypes?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
};

export type LenssourceLensSourceDisableTask = {
    readonly __typename?: "LenssourceLensSourceDisableTask";
    readonly createdAt?: Maybe<GoogleProtobufTimestamp>;
    readonly payload?: Maybe<LenssourceLensSourceDisableTaskPayload>;
    readonly taskId?: Maybe<Scalars["String"]["output"]>;
};

export type LenssourceLensSourceDisableTaskPayload = {
    readonly __typename?: "LenssourceLensSourceDisableTaskPayload";
    readonly lensSourceList?: Maybe<ReadonlyArray<Maybe<LenssourceModelLensSource>>>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type LenssourceLensSourceListCursorData = {
    readonly __typename?: "LenssourceLensSourceListCursorData";
    readonly externalCursor?: Maybe<Scalars["String"]["output"]>;
    readonly lastValue?: Maybe<Scalars["String"]["output"]>;
    readonly offset?: Maybe<Scalars["Int"]["output"]>;
};

export type LenssourceLensSourceUpdate = {
    readonly __typename?: "LenssourceLensSourceUpdate";
    readonly enabled?: Maybe<Scalars["Boolean"]["output"]>;
    readonly externalId?: Maybe<Scalars["String"]["output"]>;
    readonly lensSourceId?: Maybe<Scalars["String"]["output"]>;
};

export type LenssourceLensSourcesMapByType = {
    readonly __typename?: "LenssourceLensSourcesMapByType";
    readonly lensSourceList?: Maybe<ReadonlyArray<Maybe<LenssourceModelLensSource>>>;
    readonly lensSourceType?: Maybe<LenssourceModelLensSourceType>;
};

export type LenssourceModelLensSource = {
    readonly __typename?: "LenssourceModelLensSource";
    readonly alias?: Maybe<Scalars["String"]["output"]>;
    readonly createdAt?: Maybe<GoogleProtobufTimestamp>;
    readonly enabled?: Maybe<Scalars["Boolean"]["output"]>;
    readonly externalId?: Maybe<Scalars["String"]["output"]>;
    readonly id?: Maybe<Scalars["String"]["output"]>;
    readonly lensSourceType?: Maybe<LenssourceModelLensSourceType>;
    readonly name?: Maybe<Scalars["String"]["output"]>;
    readonly owner?: Maybe<Scalars["String"]["output"]>;
    readonly reference?: Maybe<Scalars["String"]["output"]>;
    readonly updatedAt?: Maybe<GoogleProtobufTimestamp>;
};

export type LenssourceModelLensSourceInfo = {
    readonly __typename?: "LenssourceModelLensSourceInfo";
    readonly name?: Maybe<Scalars["String"]["output"]>;
};

export enum LenssourceModelLensSourceType {
    BusinessProfile = "BUSINESS_PROFILE",
    LensSpace = "LENS_SPACE",
    MediaLibrary = "MEDIA_LIBRARY",
    ScheduleV3 = "SCHEDULE_V3",
    SnapchatUserUnset = "SNAPCHAT_USER_UNSET",
}

export type LenssourceUpdateLensSourcesRequest = {
    readonly __typename?: "LenssourceUpdateLensSourcesRequest";
    readonly lensSourceUpdates?: Maybe<ReadonlyArray<Maybe<LenssourceLensSourceUpdate>>>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type LenssourceUpdateLensSourcesResponse = {
    readonly __typename?: "LenssourceUpdateLensSourcesResponse";
    readonly lensSourceList?: Maybe<ReadonlyArray<Maybe<LenssourceModelLensSource>>>;
    readonly taskId?: Maybe<Scalars["String"]["output"]>;
};

export type ListApplicationRequest = {
    readonly __typename?: "ListApplicationRequest";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly orgId?: Maybe<Scalars["String"]["output"]>;
};

export type ListApplicationResponse = {
    readonly __typename?: "ListApplicationResponse";
    readonly applications?: Maybe<ReadonlyArray<Maybe<AppInfo>>>;
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
};

export type MediaSourceInput = {
    readonly upload?: InputMaybe<Scalars["Upload"]["input"]>;
    readonly url?: InputMaybe<Scalars["String"]["input"]>;
};

export enum MetricField {
    AddToCart = "ADD_TO_CART",
    AdsSubscribes = "ADS_SUBSCRIBES",
    AdCompletes = "AD_COMPLETES",
    AdQuartile_1 = "AD_QUARTILE_1",
    AdQuartile_2 = "AD_QUARTILE_2",
    AdQuartile_3 = "AD_QUARTILE_3",
    AttachmentConversion = "ATTACHMENT_CONVERSION",
    AttachmentViewers = "ATTACHMENT_VIEWERS",
    AttachmentViewersInsight = "ATTACHMENT_VIEWERS_INSIGHT",
    AttachmentViews = "ATTACHMENT_VIEWS",
    AttachmentViewTimeMillis = "ATTACHMENT_VIEW_TIME_MILLIS",
    AverageInteractionTime = "AVERAGE_INTERACTION_TIME",
    AverageUserViewTime = "AVERAGE_USER_VIEW_TIME",
    AvgViewTimeMillis = "AVG_VIEW_TIME_MILLIS",
    CameraPlayTimeMillis = "CAMERA_PLAY_TIME_MILLIS",
    CaptureRate = "CAPTURE_RATE",
    ChatUniques = "CHAT_UNIQUES",
    Completes = "COMPLETES",
    CompleteSnapViewers = "COMPLETE_SNAP_VIEWERS",
    CompleteSnapViews = "COMPLETE_SNAP_VIEWS",
    ConversionAchievementUnlocked = "CONVERSION_ACHIEVEMENT_UNLOCKED",
    ConversionAchievementUnlockedSwipeUp = "CONVERSION_ACHIEVEMENT_UNLOCKED_SWIPE_UP",
    ConversionAchievementUnlockedView = "CONVERSION_ACHIEVEMENT_UNLOCKED_VIEW",
    ConversionAddBilling = "CONVERSION_ADD_BILLING",
    ConversionAddBillingSwipeUp = "CONVERSION_ADD_BILLING_SWIPE_UP",
    ConversionAddBillingView = "CONVERSION_ADD_BILLING_VIEW",
    ConversionAddCart = "CONVERSION_ADD_CART",
    ConversionAddCartSwipeUp = "CONVERSION_ADD_CART_SWIPE_UP",
    ConversionAddCartView = "CONVERSION_ADD_CART_VIEW",
    ConversionAddToWishlist = "CONVERSION_ADD_TO_WISHLIST",
    ConversionAddToWishlistSwipeUp = "CONVERSION_ADD_TO_WISHLIST_SWIPE_UP",
    ConversionAddToWishlistView = "CONVERSION_ADD_TO_WISHLIST_VIEW",
    ConversionAdClick = "CONVERSION_AD_CLICK",
    ConversionAdClickSwipeUp = "CONVERSION_AD_CLICK_SWIPE_UP",
    ConversionAdClickView = "CONVERSION_AD_CLICK_VIEW",
    ConversionAdView = "CONVERSION_AD_VIEW",
    ConversionAdViewSwipeUp = "CONVERSION_AD_VIEW_SWIPE_UP",
    ConversionAdViewView = "CONVERSION_AD_VIEW_VIEW",
    ConversionAppOpens = "CONVERSION_APP_OPENS",
    ConversionAppOpensSwipeUp = "CONVERSION_APP_OPENS_SWIPE_UP",
    ConversionAppOpensView = "CONVERSION_APP_OPENS_VIEW",
    ConversionCompleteTutorial = "CONVERSION_COMPLETE_TUTORIAL",
    ConversionCompleteTutorialSwipeUp = "CONVERSION_COMPLETE_TUTORIAL_SWIPE_UP",
    ConversionCompleteTutorialView = "CONVERSION_COMPLETE_TUTORIAL_VIEW",
    ConversionInvite = "CONVERSION_INVITE",
    ConversionInviteSwipeUp = "CONVERSION_INVITE_SWIPE_UP",
    ConversionInviteView = "CONVERSION_INVITE_VIEW",
    ConversionLevelCompletes = "CONVERSION_LEVEL_COMPLETES",
    ConversionLevelCompletesSwipeUp = "CONVERSION_LEVEL_COMPLETES_SWIPE_UP",
    ConversionLevelCompletesView = "CONVERSION_LEVEL_COMPLETES_VIEW",
    ConversionListView = "CONVERSION_LIST_VIEW",
    ConversionListViewSwipeUp = "CONVERSION_LIST_VIEW_SWIPE_UP",
    ConversionListViewView = "CONVERSION_LIST_VIEW_VIEW",
    ConversionLogin = "CONVERSION_LOGIN",
    ConversionLoginSwipeUp = "CONVERSION_LOGIN_SWIPE_UP",
    ConversionLoginView = "CONVERSION_LOGIN_VIEW",
    ConversionPageViews = "CONVERSION_PAGE_VIEWS",
    ConversionPageViewsSwipeUp = "CONVERSION_PAGE_VIEWS_SWIPE_UP",
    ConversionPageViewsView = "CONVERSION_PAGE_VIEWS_VIEW",
    ConversionPurchases = "CONVERSION_PURCHASES",
    ConversionPurchasesCurrencyValue = "CONVERSION_PURCHASES_CURRENCY_VALUE",
    ConversionPurchasesSwipeUp = "CONVERSION_PURCHASES_SWIPE_UP",
    ConversionPurchasesValueSwipeUp = "CONVERSION_PURCHASES_VALUE_SWIPE_UP",
    ConversionPurchasesValueView = "CONVERSION_PURCHASES_VALUE_VIEW",
    ConversionPurchasesView = "CONVERSION_PURCHASES_VIEW",
    ConversionRate = "CONVERSION_RATE",
    ConversionRateSwipeUp = "CONVERSION_RATE_SWIPE_UP",
    ConversionRateView = "CONVERSION_RATE_VIEW",
    ConversionReserve = "CONVERSION_RESERVE",
    ConversionReserveSwipeUp = "CONVERSION_RESERVE_SWIPE_UP",
    ConversionReserveView = "CONVERSION_RESERVE_VIEW",
    ConversionSave = "CONVERSION_SAVE",
    ConversionSaveSwipeUp = "CONVERSION_SAVE_SWIPE_UP",
    ConversionSaveView = "CONVERSION_SAVE_VIEW",
    ConversionSearches = "CONVERSION_SEARCHES",
    ConversionSearchesSwipeUp = "CONVERSION_SEARCHES_SWIPE_UP",
    ConversionSearchesView = "CONVERSION_SEARCHES_VIEW",
    ConversionShare = "CONVERSION_SHARE",
    ConversionShareSwipeUp = "CONVERSION_SHARE_SWIPE_UP",
    ConversionShareView = "CONVERSION_SHARE_VIEW",
    ConversionSignUps = "CONVERSION_SIGN_UPS",
    ConversionSignUpsSwipeUp = "CONVERSION_SIGN_UPS_SWIPE_UP",
    ConversionSignUpsView = "CONVERSION_SIGN_UPS_VIEW",
    ConversionSpendCredits = "CONVERSION_SPEND_CREDITS",
    ConversionSpendCreditsSwipeUp = "CONVERSION_SPEND_CREDITS_SWIPE_UP",
    ConversionSpendCreditsView = "CONVERSION_SPEND_CREDITS_VIEW",
    ConversionStartCheckout = "CONVERSION_START_CHECKOUT",
    ConversionStartCheckoutSwipeUp = "CONVERSION_START_CHECKOUT_SWIPE_UP",
    ConversionStartCheckoutView = "CONVERSION_START_CHECKOUT_VIEW",
    ConversionStartTrial = "CONVERSION_START_TRIAL",
    ConversionStartTrialSwipeUp = "CONVERSION_START_TRIAL_SWIPE_UP",
    ConversionStartTrialView = "CONVERSION_START_TRIAL_VIEW",
    ConversionSubscribe = "CONVERSION_SUBSCRIBE",
    ConversionSubscribeSwipeUp = "CONVERSION_SUBSCRIBE_SWIPE_UP",
    ConversionSubscribeView = "CONVERSION_SUBSCRIBE_VIEW",
    ConversionViewContent = "CONVERSION_VIEW_CONTENT",
    ConversionViewContentSwipeUp = "CONVERSION_VIEW_CONTENT_SWIPE_UP",
    ConversionViewContentView = "CONVERSION_VIEW_CONTENT_VIEW",
    ConversionVisit = "CONVERSION_VISIT",
    ConversionVisitSwipeUp = "CONVERSION_VISIT_SWIPE_UP",
    ConversionVisitView = "CONVERSION_VISIT_VIEW",
    CoreUsers = "CORE_USERS",
    Creates = "CREATES",
    DailyUniques = "DAILY_UNIQUES",
    DigitalGoodCardCancel = "DIGITAL_GOOD_CARD_CANCEL",
    DigitalGoodCardOpens = "DIGITAL_GOOD_CARD_OPENS",
    DigitalGoodPurchase = "DIGITAL_GOOD_PURCHASE",
    DigitalGoodPurchasesPerUser = "DIGITAL_GOOD_PURCHASES_PER_USER",
    DigitalGoodTokenEarned = "DIGITAL_GOOD_TOKEN_EARNED",
    DigitalGoodUniquePurchasers = "DIGITAL_GOOD_UNIQUE_PURCHASERS",
    DownloadTime = "DOWNLOAD_TIME",
    DropOffRate = "DROP_OFF_RATE",
    Ecpm = "ECPM",
    ExternalStoreClick = "EXTERNAL_STORE_CLICK",
    Favorites = "FAVORITES",
    FilledImpressions = "FILLED_IMPRESSIONS",
    FrequentUsers = "FREQUENT_USERS",
    HighlightAvgViewTimeMillis = "HIGHLIGHT_AVG_VIEW_TIME_MILLIS",
    HighlightSubscribes = "HIGHLIGHT_SUBSCRIBES",
    HighlightUniques = "HIGHLIGHT_UNIQUES",
    HighlightViews = "HIGHLIGHT_VIEWS",
    HighlightViewTimeMillis = "HIGHLIGHT_VIEW_TIME_MILLIS",
    Interactions = "INTERACTIONS",
    InteractionTime = "INTERACTION_TIME",
    LensActionSubscriberUniqueUsers = "LENS_ACTION_SUBSCRIBER_UNIQUE_USERS",
    LensAveragePlaytimeMillis = "LENS_AVERAGE_PLAYTIME_MILLIS",
    LensAvgViewTimeMillis = "LENS_AVG_VIEW_TIME_MILLIS",
    LensCommandKeywordDetected = "LENS_COMMAND_KEYWORD_DETECTED",
    LensDauOverMau = "LENS_DAU_OVER_MAU",
    LensDauOverWau = "LENS_DAU_OVER_WAU",
    LensFaceFound = "LENS_FACE_FOUND",
    LensFaceLost = "LENS_FACE_LOST",
    LensLanguageDisplayed = "LENS_LANGUAGE_DISPLAYED",
    LensLongPlays = "LENS_LONG_PLAYS",
    LensLongPlayRatio = "LENS_LONG_PLAY_RATIO",
    LensMarkerTracked = "LENS_MARKER_TRACKED",
    LensMau = "LENS_MAU",
    LensMultiuserSessionJoined = "LENS_MULTIUSER_SESSION_JOINED",
    LensMultiuserSessionShared = "LENS_MULTIUSER_SESSION_SHARED",
    LensMultiuserSessionStarted = "LENS_MULTIUSER_SESSION_STARTED",
    LensObjectTracked = "LENS_OBJECT_TRACKED",
    LensObjectTracked_3D = "LENS_OBJECT_TRACKED_3D",
    LensPlays = "LENS_PLAYS",
    LensPlaysLast_90Days = "LENS_PLAYS_LAST_90_DAYS",
    LensPosterUniques = "LENS_POSTER_UNIQUES",
    LensPosterUniquesS11 = "LENS_POSTER_UNIQUES_S11",
    LensPosterUniquesUs = "LENS_POSTER_UNIQUES_US",
    LensPosts = "LENS_POSTS",
    LensPrivateStoryPosts = "LENS_PRIVATE_STORY_POSTS",
    LensPublicStoryPosts = "LENS_PUBLIC_STORY_POSTS",
    LensShares = "LENS_SHARES",
    LensSnapcodeScans = "LENS_SNAPCODE_SCANS",
    LensSpotlightPosterUniques = "LENS_SPOTLIGHT_POSTER_UNIQUES",
    LensSpotlightPosterUniquesS11 = "LENS_SPOTLIGHT_POSTER_UNIQUES_S11",
    LensSpotlightPosterUniquesUs = "LENS_SPOTLIGHT_POSTER_UNIQUES_US",
    LensSpotlightPosts = "LENS_SPOTLIGHT_POSTS",
    LensSubscribers = "LENS_SUBSCRIBERS",
    LensSubscribersGained = "LENS_SUBSCRIBERS_GAINED",
    LensSubscribes = "LENS_SUBSCRIBES",
    LensTap = "LENS_TAP",
    LensTouchEnded = "LENS_TOUCH_ENDED",
    LensTouchMoved = "LENS_TOUCH_MOVED",
    LensTouchStart = "LENS_TOUCH_START",
    LensUniques = "LENS_UNIQUES",
    LensViewers = "LENS_VIEWERS",
    LensViews = "LENS_VIEWS",
    LensViewTimeMillis = "LENS_VIEW_TIME_MILLIS",
    LensVoiceKeywordDetected = "LENS_VOICE_KEYWORD_DETECTED",
    LensVoiceTranscribed = "LENS_VOICE_TRANSCRIBED",
    LongImpressions = "LONG_IMPRESSIONS",
    LoyalUsers = "LOYAL_USERS",
    MetricFieldUnset = "METRIC_FIELD_UNSET",
    NetRevenue = "NET_REVENUE",
    NewUsers = "NEW_USERS",
    NonSubscribeAttachmentView = "NON_SUBSCRIBE_ATTACHMENT_VIEW",
    NonSubscribeAttachmentViewer = "NON_SUBSCRIBE_ATTACHMENT_VIEWER",
    PlacesCalls = "PLACES_CALLS",
    PlacesCheckIns = "PLACES_CHECK_INS",
    PlacesDirectionRequests = "PLACES_DIRECTION_REQUESTS",
    PlacesFavorites = "PLACES_FAVORITES",
    PlacesHoursRequests = "PLACES_HOURS_REQUESTS",
    PlacesMenuVisits = "PLACES_MENU_VISITS",
    PlacesOrders = "PLACES_ORDERS",
    PlacesPhysicalVisitors = "PLACES_PHYSICAL_VISITORS",
    PlacesPhysicalVisits = "PLACES_PHYSICAL_VISITS",
    PlacesUniqueHoursRequests = "PLACES_UNIQUE_HOURS_REQUESTS",
    PlacesUniqueUserCalls = "PLACES_UNIQUE_USER_CALLS",
    PlacesUniqueUserDirectionRequests = "PLACES_UNIQUE_USER_DIRECTION_REQUESTS",
    PlacesUniqueUserMenuVisits = "PLACES_UNIQUE_USER_MENU_VISITS",
    PlacesUniqueUserOrders = "PLACES_UNIQUE_USER_ORDERS",
    PlacesViewers = "PLACES_VIEWERS",
    PlacesViews = "PLACES_VIEWS",
    PlacesVisitFrequency = "PLACES_VISIT_FREQUENCY",
    PlayTimeMillis = "PLAY_TIME_MILLIS",
    PlayTimeMillisLast_90Days = "PLAY_TIME_MILLIS_LAST_90_DAYS",
    ProductAvgPlayTimeMillis = "PRODUCT_AVG_PLAY_TIME_MILLIS",
    ProductPlays = "PRODUCT_PLAYS",
    ProductPlayTimeMillis = "PRODUCT_PLAY_TIME_MILLIS",
    ProductShares = "PRODUCT_SHARES",
    ProductSwipes = "PRODUCT_SWIPES",
    ProfilePaidViews = "PROFILE_PAID_VIEWS",
    ProfileViews = "PROFILE_VIEWS",
    QrScans = "QR_SCANS",
    Replies = "REPLIES",
    Requests = "REQUESTS",
    ReturningUsers = "RETURNING_USERS",
    Revenue = "REVENUE",
    SavedStoryAvgViewTimeMillis = "SAVED_STORY_AVG_VIEW_TIME_MILLIS",
    SavedStoryFavorites = "SAVED_STORY_FAVORITES",
    SavedStoryScreenshots = "SAVED_STORY_SCREENSHOTS",
    SavedStorySharedRecipientCount = "SAVED_STORY_SHARED_RECIPIENT_COUNT",
    SavedStoryShares = "SAVED_STORY_SHARES",
    SavedStorySnapAvgViewTimeMillis = "SAVED_STORY_SNAP_AVG_VIEW_TIME_MILLIS",
    SavedStorySnapCombinedUniques = "SAVED_STORY_SNAP_COMBINED_UNIQUES",
    SavedStorySnapCombinedVideoViews_2S = "SAVED_STORY_SNAP_COMBINED_VIDEO_VIEWS_2S",
    SavedStorySnapCombinedViews = "SAVED_STORY_SNAP_COMBINED_VIEWS",
    SavedStorySnapPaidUniques = "SAVED_STORY_SNAP_PAID_UNIQUES",
    SavedStorySnapPaidVideoViews_2S = "SAVED_STORY_SNAP_PAID_VIDEO_VIEWS_2S",
    SavedStorySnapPaidViews = "SAVED_STORY_SNAP_PAID_VIEWS",
    SavedStorySnapSharers = "SAVED_STORY_SNAP_SHARERS",
    SavedStorySnapVideoViews_2S = "SAVED_STORY_SNAP_VIDEO_VIEWS_2S",
    SavedStorySnapViewers = "SAVED_STORY_SNAP_VIEWERS",
    SavedStorySnapViewersInsight = "SAVED_STORY_SNAP_VIEWERS_INSIGHT",
    SavedStorySnapViews = "SAVED_STORY_SNAP_VIEWS",
    SavedStorySubscribes = "SAVED_STORY_SUBSCRIBES",
    SavedStoryUniques = "SAVED_STORY_UNIQUES",
    SavedStoryViewers = "SAVED_STORY_VIEWERS",
    SavedStoryViews = "SAVED_STORY_VIEWS",
    SavedStoryViewTimeMillis = "SAVED_STORY_VIEW_TIME_MILLIS",
    Scans = "SCANS",
    ScanAvgPlayTimeMillis = "SCAN_AVG_PLAY_TIME_MILLIS",
    ScanLensFavorites = "SCAN_LENS_FAVORITES",
    ScanLensLongPlays = "SCAN_LENS_LONG_PLAYS",
    ScanLensOnlyViewers = "SCAN_LENS_ONLY_VIEWERS",
    ScanLensPlays = "SCAN_LENS_PLAYS",
    ScanLensPlayTimeMillis = "SCAN_LENS_PLAY_TIME_MILLIS",
    ScanLensShares = "SCAN_LENS_SHARES",
    ScanLensSubscribes = "SCAN_LENS_SUBSCRIBES",
    ScanLensSwipeUps = "SCAN_LENS_SWIPE_UPS",
    ScanLensUniques = "SCAN_LENS_UNIQUES",
    ScanLensViews = "SCAN_LENS_VIEWS",
    ScanLensViewTimeMillis = "SCAN_LENS_VIEW_TIME_MILLIS",
    Screenshots = "SCREENSHOTS",
    Shares = "SHARES",
    SnapcodeScans = "SNAPCODE_SCANS",
    SnapCombinedUniques = "SNAP_COMBINED_UNIQUES",
    SnapCombinedVideoViews_2S = "SNAP_COMBINED_VIDEO_VIEWS_2S",
    SnapCombinedViews = "SNAP_COMBINED_VIEWS",
    SnapPaidUniques = "SNAP_PAID_UNIQUES",
    SnapPaidVideoViews_2S = "SNAP_PAID_VIDEO_VIEWS_2S",
    SnapPaidViews = "SNAP_PAID_VIEWS",
    SnapVideoViews_2S = "SNAP_VIDEO_VIEWS_2S",
    SnapViewers = "SNAP_VIEWERS",
    SnapViews = "SNAP_VIEWS",
    SnapViewTimeMillis = "SNAP_VIEW_TIME_MILLIS",
    SnapWithAttachmentView = "SNAP_WITH_ATTACHMENT_VIEW",
    SnapWithAttachmentViewer = "SNAP_WITH_ATTACHMENT_VIEWER",
    SocialUnlocks = "SOCIAL_UNLOCKS",
    SpotlightAvgViewTimeMillis = "SPOTLIGHT_AVG_VIEW_TIME_MILLIS",
    SpotlightCombinedUniques = "SPOTLIGHT_COMBINED_UNIQUES",
    SpotlightCombinedVideoViews_2S = "SPOTLIGHT_COMBINED_VIDEO_VIEWS_2S",
    SpotlightCombinedViews = "SPOTLIGHT_COMBINED_VIEWS",
    SpotlightFavorites = "SPOTLIGHT_FAVORITES",
    SpotlightPaidUniques = "SPOTLIGHT_PAID_UNIQUES",
    SpotlightPaidVideoViews_2S = "SPOTLIGHT_PAID_VIDEO_VIEWS_2S",
    SpotlightPaidViews = "SPOTLIGHT_PAID_VIEWS",
    SpotlightScreenshots = "SPOTLIGHT_SCREENSHOTS",
    SpotlightShares = "SPOTLIGHT_SHARES",
    SpotlightSubscribersGained = "SPOTLIGHT_SUBSCRIBERS_GAINED",
    SpotlightSubscribes = "SPOTLIGHT_SUBSCRIBES",
    SpotlightUniques = "SPOTLIGHT_UNIQUES",
    SpotlightVideoViews_2S = "SPOTLIGHT_VIDEO_VIEWS_2S",
    SpotlightViews = "SPOTLIGHT_VIEWS",
    SpotlightViewTimeMillis = "SPOTLIGHT_VIEW_TIME_MILLIS",
    StoreCategoryView = "STORE_CATEGORY_VIEW",
    StoreCategoryViewer = "STORE_CATEGORY_VIEWER",
    StorePageView = "STORE_PAGE_VIEW",
    StoreProductView = "STORE_PRODUCT_VIEW",
    StoreProductViewer = "STORE_PRODUCT_VIEWER",
    StoreViewTime = "STORE_VIEW_TIME",
    StoreVisitors = "STORE_VISITORS",
    StoryAvgViewTimeMillis = "STORY_AVG_VIEW_TIME_MILLIS",
    StoryFavorites = "STORY_FAVORITES",
    StorySubscribers = "STORY_SUBSCRIBERS",
    StorySubscribersGained = "STORY_SUBSCRIBERS_GAINED",
    StorySubscribes = "STORY_SUBSCRIBES",
    StoryUniques = "STORY_UNIQUES",
    StoryViewers = "STORY_VIEWERS",
    StoryViews = "STORY_VIEWS",
    StoryViewTimeMillis = "STORY_VIEW_TIME_MILLIS",
    Subscribers = "SUBSCRIBERS",
    SubscribersGained = "SUBSCRIBERS_GAINED",
    Subscribes = "SUBSCRIBES",
    SwipeDowns = "SWIPE_DOWNS",
    SwipeUps = "SWIPE_UPS",
    TapBack = "TAP_BACK",
    TapForward = "TAP_FORWARD",
    TextAttachmentViews = "TEXT_ATTACHMENT_VIEWS",
    TileAvgSnapViewed = "TILE_AVG_SNAP_VIEWED",
    TileAvgTimeViewed = "TILE_AVG_TIME_VIEWED",
    TileCtr = "TILE_CTR",
    TileIndexCtr = "TILE_INDEX_CTR",
    TileSnapViewer = "TILE_SNAP_VIEWER",
    TileTap = "TILE_TAP",
    TileView = "TILE_VIEW",
    TileViewer = "TILE_VIEWER",
    TileViewRatio = "TILE_VIEW_RATIO",
    TileViewTime = "TILE_VIEW_TIME",
    UniqueLensSnapCreates = "UNIQUE_LENS_SNAP_CREATES",
    UniqueProductsViewed = "UNIQUE_PRODUCTS_VIEWED",
    UniqueScreenshots = "UNIQUE_SCREENSHOTS",
    UniqueSessions = "UNIQUE_SESSIONS",
    UniqueSwipers = "UNIQUE_SWIPERS",
    UniqueTopsnapPerUser = "UNIQUE_TOPSNAP_PER_USER",
    UniqueTopsnapViews = "UNIQUE_TOPSNAP_VIEWS",
    UniqueTopsnapViewsInsight = "UNIQUE_TOPSNAP_VIEWS_INSIGHT",
    Unsubscribes = "UNSUBSCRIBES",
    VideoAttachmentViews = "VIDEO_ATTACHMENT_VIEWS",
    Viewers = "VIEWERS",
    ViewersInsight = "VIEWERS_INSIGHT",
    Views = "VIEWS",
    ViewTimeMillis = "VIEW_TIME_MILLIS",
}

export type Mutation = {
    readonly __typename?: "Mutation";
    readonly assignOrgToAsset: AssignOrgToAssetResponse;
    readonly assistantChat: AssistantChatResponse;
    readonly batchUpdateAbExposure?: Maybe<Scalars["Void"]["output"]>;
    readonly bulkPatchRemoteAssets: BulkPatchRemoteAssetsResponse;
    readonly createAppVersion?: Maybe<CreateAppVersionResponse>;
    readonly createApplication?: Maybe<CreateApplicationResponse>;
    readonly createConnectionBulk?: Maybe<CreateConnectionBulkResponse>;
    readonly createLensSpace: CreateLensSpaceResponse;
    readonly createMyLensesLensSpaceLens: MyLensesCreateLensResponse;
    readonly createMyLensesOrganizationAndLensSpace: MyLensesCreateOrganizationAndLensSpaceResponse;
    readonly createOrganization?: Maybe<OrganizationCreateResponse>;
    readonly createPin?: Maybe<PinGroupResponse>;
    readonly createWebLensUpload: CreateWebLensUploadResponse;
    readonly deleteHostedLens?: Maybe<Scalars["Void"]["output"]>;
    readonly deleteLens?: Maybe<Scalars["Void"]["output"]>;
    readonly deleteRemoteApiSpec: DeleteRemoteApiSpecResponse;
    readonly deleteRemoteAsset: DeleteRemoteAssetResult;
    readonly deleteRemoteAssets: DeleteRemoteAssetsResult;
    readonly enableCameraKitFeature?: Maybe<EnableCameraKitFeatureResponse>;
    readonly enableCameraKitOrganization?: Maybe<OrganizationEnableCameraKitResponse>;
    readonly forkRemoteAssets: ForkRemoteAssetsResponse;
    readonly generateApiToken?: Maybe<GenerateApiTokenResponse>;
    readonly generateHostedLens: GenerateHostedLensResponse;
    readonly isUnauthorized?: Maybe<Scalars["Boolean"]["output"]>;
    readonly onboardLensToLensCloud: OnboardLensToLensCloudResponse;
    readonly previewWebLensOnDevice: PreviewWebLensOnDeviceResponse;
    readonly processMedia: ProcessMediaResponse;
    readonly releaseConnectionBulk?: Maybe<ReleaseConnectionBulkResponse>;
    readonly removePin?: Maybe<PinGroupResponse>;
    readonly saveGroupV2?: Maybe<GroupWithConnections>;
    readonly saveLensV2?: Maybe<LensWithConnections>;
    readonly saveRemoteApiSpec: SaveRemoteApiSpecResponse;
    readonly selectedOrganization?: Maybe<CameraKitOrganization>;
    readonly setDigitalGoods: SetDigitalGoodsResponse;
    readonly setDiscoverability: SetDiscoverabilityResponse;
    readonly setExperienceDismissed?: Maybe<Scalars["Void"]["output"]>;
    readonly setLensCategory: SetLensCategoryResponse;
    readonly setLensCreatorPayoutEnrollment: SetLensCreatorPayoutEnrollmentResponse;
    readonly setLensDescription: SetLensDescriptionResponse;
    /** @deprecated use updateLens instead */
    readonly setLensPreview: SetLensPreviewResponse;
    readonly setMyLensesCtaV2: MyLensesSetCtaResponse;
    /** @deprecated Scan triggers feature is being removed */
    readonly setScanTriggers: SetScanTriggersResponse;
    readonly setTags: SetTagsResponse;
    readonly setTosLatestAcceptedVersion: GetTosResponse;
    readonly setVisibility: SetVisibilityResponse;
    readonly signEULA: SignEulaResponse;
    readonly submitAsset: SubmitAssetResponse;
    readonly submitWebLens: SubmitWebLensResponse;
    readonly updateAsset: UpdateAssetResponse;
    readonly updateHostedLensStatus: UpdateHostedLensStatusResponse;
    readonly updateLens: UpdateLensResponse;
    readonly updateLensSources?: Maybe<LenssourceUpdateLensSourcesResponse>;
    readonly updateRemoteAsset: RemoteAsset;
    readonly updateWebLens: SubmitWebLensResponse;
    readonly uploadFile: UploadFileResponse;
};

export type MutationAssignOrgToAssetArgs = {
    input: AssignOrgToAssetRequest;
};

export type MutationAssistantChatArgs = {
    input: AssistantChatInput;
};

export type MutationBatchUpdateAbExposureArgs = {
    input: AbLogExposureRequest;
};

export type MutationBulkPatchRemoteAssetsArgs = {
    input: BulkPatchRemoteAssetsInput;
};

export type MutationCreateAppVersionArgs = {
    input: InputCreateAppVersionRequest;
};

export type MutationCreateApplicationArgs = {
    input?: InputMaybe<InputCreateApplicationRequest>;
};

export type MutationCreateConnectionBulkArgs = {
    input?: InputMaybe<InputCreateConnectionBulkRequest>;
};

export type MutationCreateLensSpaceArgs = {
    input: CreateLensSpaceRequest;
};

export type MutationCreateMyLensesLensSpaceLensArgs = {
    input: MyLensesCreateLensSpaceLensRequest;
};

export type MutationCreateMyLensesOrganizationAndLensSpaceArgs = {
    input: MyLensesCreateOrganizationAndLensSpaceRequest;
};

export type MutationCreateOrganizationArgs = {
    input?: InputMaybe<InputOrganizationCreateRequest>;
};

export type MutationCreatePinArgs = {
    input?: InputMaybe<InputPinGroupRequest>;
};

export type MutationDeleteHostedLensArgs = {
    input: DeleteHostedLensRequest;
};

export type MutationDeleteLensArgs = {
    input: DeleteLensRequest;
};

export type MutationDeleteRemoteApiSpecArgs = {
    input: DeleteRemoteApiSpecRequest;
};

export type MutationDeleteRemoteAssetArgs = {
    input: DeleteRemoteAssetRequest;
};

export type MutationDeleteRemoteAssetsArgs = {
    input: DeleteRemoteAssetsRequest;
};

export type MutationEnableCameraKitFeatureArgs = {
    input: InputEnableCameraKitFeatureRequest;
};

export type MutationEnableCameraKitOrganizationArgs = {
    input?: InputMaybe<InputOrganizationEnableCameraKitRequest>;
};

export type MutationForkRemoteAssetsArgs = {
    input: ForkRemoteAssetsInput;
};

export type MutationGenerateApiTokenArgs = {
    input?: InputMaybe<InputGenerateApiTokenRequest>;
};

export type MutationGenerateHostedLensArgs = {
    input: GenerateHostedLensRequest;
};

export type MutationOnboardLensToLensCloudArgs = {
    input: OnboardLensToLensCloudRequest;
};

export type MutationPreviewWebLensOnDeviceArgs = {
    input: PreviewWebLensOnDeviceRequest;
};

export type MutationProcessMediaArgs = {
    input: ProcessMediaRequest;
};

export type MutationReleaseConnectionBulkArgs = {
    input?: InputMaybe<InputReleaseConnectionBulkRequest>;
};

export type MutationRemovePinArgs = {
    input?: InputMaybe<InputPinGroupRequest>;
};

export type MutationSaveGroupV2Args = {
    input?: InputMaybe<InputGroupSaveRequest>;
};

export type MutationSaveLensV2Args = {
    input?: InputMaybe<InputSaveLensRequest>;
};

export type MutationSaveRemoteApiSpecArgs = {
    input: SaveRemoteApiSpecRequest;
};

export type MutationSetDigitalGoodsArgs = {
    input: SetDigitalGoodsRequest;
};

export type MutationSetDiscoverabilityArgs = {
    input: SetDiscoverabilityRequest;
};

export type MutationSetExperienceDismissedArgs = {
    input: SetExperienceDismissedRequest;
};

export type MutationSetLensCategoryArgs = {
    input: SetLensCategoryRequest;
};

export type MutationSetLensCreatorPayoutEnrollmentArgs = {
    input: SetLensCreatorPayoutEnrollmentRequest;
};

export type MutationSetLensDescriptionArgs = {
    input: SetLensDescriptionRequest;
};

export type MutationSetLensPreviewArgs = {
    input: SetLensPreviewRequest;
};

export type MutationSetMyLensesCtaV2Args = {
    input: MyLensesSetLensCtaRequest;
};

export type MutationSetScanTriggersArgs = {
    input: SetScanTriggersRequest;
};

export type MutationSetTagsArgs = {
    input: SetTagsRequest;
};

export type MutationSetTosLatestAcceptedVersionArgs = {
    input: SetTosLatestAcceptedVersionRequest;
};

export type MutationSetVisibilityArgs = {
    input: SetVisibilityRequest;
};

export type MutationSignEulaArgs = {
    input: SignEulaRequest;
};

export type MutationSubmitAssetArgs = {
    input: SubmitAssetRequest;
};

export type MutationSubmitWebLensArgs = {
    input: SubmitWebLensRequest;
};

export type MutationUpdateAssetArgs = {
    input: UpdateAssetRequest;
};

export type MutationUpdateHostedLensStatusArgs = {
    input: UpdateHostedLensStatusRequest;
};

export type MutationUpdateLensArgs = {
    input: UpdateLensRequest;
};

export type MutationUpdateLensSourcesArgs = {
    input?: InputMaybe<InputLenssourceUpdateLensSourcesRequest>;
};

export type MutationUpdateRemoteAssetArgs = {
    input: UpdateRemoteAssetRequest;
};

export type MutationUpdateWebLensArgs = {
    input: UpdateWebLensRequest;
};

export type MutationUploadFileArgs = {
    input: UploadFileRequest;
};

export type MyLensesAdAccount = {
    readonly __typename?: "MyLensesAdAccount";
    readonly id?: Maybe<Scalars["ID"]["output"]>;
    readonly name?: Maybe<Scalars["String"]["output"]>;
};

export type MyLensesApiToken = {
    readonly __typename?: "MyLensesApiToken";
    readonly createdTsMillis?: Maybe<Scalars["Float"]["output"]>;
    readonly stage?: Maybe<MyLensesStage>;
    readonly token?: Maybe<Scalars["String"]["output"]>;
};

export type MyLensesAppVersion = {
    readonly __typename?: "MyLensesAppVersion";
    readonly appDescription?: Maybe<Scalars["String"]["output"]>;
    readonly appId?: Maybe<Scalars["String"]["output"]>;
    readonly appName?: Maybe<Scalars["String"]["output"]>;
    readonly features?: Maybe<ReadonlyArray<Maybe<MyLensesFeature>>>;
    readonly orgId?: Maybe<Scalars["String"]["output"]>;
    readonly reviewState?: Maybe<MyLensesReviewState>;
    readonly version?: Maybe<Scalars["Int"]["output"]>;
    readonly versionName?: Maybe<Scalars["String"]["output"]>;
};

export type MyLensesAsset = {
    readonly __typename?: "MyLensesAsset";
    /** @deprecated Renamed to FileResource.fileName per /studio/common/file_resource.proto convention */
    readonly fileName: Scalars["String"]["output"];
    /** @deprecated Renamed to FileResource.url per /studio/common/file_resource.proto convention */
    readonly url: Scalars["String"]["output"];
};

export enum MyLensesAssetCategory {
    Audio = "AUDIO",
    CustomComponents = "CUSTOM_COMPONENTS",
    Games = "GAMES",
    Materials = "MATERIALS",
    Plugin = "PLUGIN",
    Reference = "REFERENCE",
    ScriptModule = "SCRIPT_MODULE",
    Snapml = "SNAPML",
    Spectacles = "SPECTACLES",
    ThreeDimensional = "THREE_DIMENSIONAL",
    Tools = "TOOLS",
    TwoDimensional = "TWO_DIMENSIONAL",
    Ui = "UI",
    Vfx = "VFX",
}

export type MyLensesAssetCollection = {
    readonly __typename?: "MyLensesAssetCollection";
    /** @deprecated Use the previews field instead */
    readonly items: ReadonlyArray<MyLensesAsset>;
};

export enum MyLensesAssetStatus {
    InReview = "InReview",
    Processing = "Processing",
    Published = "Published",
    Rejected = "Rejected",
    UploadFailed = "UploadFailed",
}

export enum MyLensesAssetType {
    AdKitApp = "AD_KIT_APP",
    AssetTypeUnset = "ASSET_TYPE_UNSET",
    CamkitLens = "CAMKIT_LENS",
    Game = "GAME",
    Highlight = "HIGHLIGHT",
    Lens = "LENS",
    Organization = "ORGANIZATION",
    Place = "PLACE",
    PlaceCollection = "PLACE_COLLECTION",
    PlaceCountry = "PLACE_COUNTRY",
    PlaceRegion = "PLACE_REGION",
    Profile = "PROFILE",
    QrSnapcode = "QR_SNAPCODE",
    SavedStory = "SAVED_STORY",
    Snap = "SNAP",
    Snapcode = "SNAPCODE",
    Spotlight = "SPOTLIGHT",
    Store = "STORE",
    Story = "STORY",
    Tile = "TILE",
    User = "USER",
}

export enum MyLensesAuthOperation {
    AuthOperationOrganizations = "AUTH_OPERATION_ORGANIZATIONS",
    AuthOperationProjects = "AUTH_OPERATION_PROJECTS",
    AuthOperationSnapKitApps = "AUTH_OPERATION_SNAP_KIT_APPS",
    AuthOperationUnset = "AUTH_OPERATION_UNSET",
}

export type MyLensesContentTypeAssetV2 = {
    readonly __typename?: "MyLensesContentTypeAssetV2";
    readonly adHocSearchString: Scalars["String"]["output"];
    readonly categories: ReadonlyArray<Scalars["String"]["output"]>;
    readonly description: Scalars["String"]["output"];
    readonly documentationUrl: Scalars["String"]["output"];
    readonly fullDescription: Scalars["String"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly lastUpdated?: Maybe<Scalars["DateTime"]["output"]>;
    readonly maxLensStudioVersion: Scalars["String"]["output"];
    readonly minLensStudioVersion: Scalars["String"]["output"];
    readonly name: Scalars["String"]["output"];
    readonly organization: ContentfulOrganization;
    readonly previews: ReadonlyArray<FileResource>;
    /** @deprecated Use previews instead */
    readonly previewsCollection: MyLensesAssetCollection;
    readonly rejections?: Maybe<ReadonlyArray<AssetRejection>>;
    readonly resources: ReadonlyArray<FileResource>;
    /** @deprecated Use resources instead */
    readonly resourcesCollection: MyLensesAssetCollection;
    readonly status: MyLensesAssetStatus;
    readonly subcategories: ReadonlyArray<Scalars["String"]["output"]>;
    readonly type: Scalars["String"]["output"];
};

export type MyLensesCreateLensResponse = {
    readonly __typename?: "MyLensesCreateLensResponse";
    readonly lens: MyLensesLens;
};

export type MyLensesCreateLensSpaceLensRequest = {
    readonly description: Scalars["String"]["input"];
    readonly digitalGoodsList?: InputMaybe<ReadonlyArray<DigitalGoodInput>>;
    readonly discoverability?: InputMaybe<DiscoverabilityInput>;
    readonly isGameUserProvided?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly isMarkedExclusive?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly lensCreatorPayoutEnrolled: Scalars["Boolean"]["input"];
    readonly lensCta?: InputMaybe<MyLensesLensCtaInput>;
    readonly lensId?: InputMaybe<Scalars["ID"]["input"]>;
    readonly lensName: Scalars["String"]["input"];
    readonly lensPreview?: InputMaybe<Scalars["Upload"]["input"]>;
    readonly lensSpaceId: Scalars["ID"]["input"];
    readonly previewMediaResources?: InputMaybe<ReadonlyArray<PreviewMediaResource>>;
    readonly releaseNote?: InputMaybe<Scalars["String"]["input"]>;
    readonly spectaclesTags?: InputMaybe<ReadonlyArray<Scalars["String"]["input"]>>;
    readonly submissionId: Scalars["ID"]["input"];
    readonly tagsList: ReadonlyArray<Scalars["String"]["input"]>;
    readonly visibility: Visibility;
};

export type MyLensesCreateOrganizationAndLensSpaceRequest = {
    readonly lensSpaceName: Scalars["String"]["input"];
    readonly organizationName: Scalars["String"]["input"];
};

export type MyLensesCreateOrganizationAndLensSpaceResponse = {
    readonly __typename?: "MyLensesCreateOrganizationAndLensSpaceResponse";
    readonly organization?: Maybe<MyLensesOrganization>;
};

export type MyLensesFeature = {
    readonly __typename?: "MyLensesFeature";
    readonly enabled?: Maybe<Scalars["Boolean"]["output"]>;
    readonly featureScopeName?: Maybe<Scalars["String"]["output"]>;
};

export type MyLensesGetAdAccountsResponse = {
    readonly __typename?: "MyLensesGetAdAccountsResponse";
    readonly adAccounts: ReadonlyArray<MyLensesAdAccount>;
};

export type MyLensesGetAssetsResponse = {
    readonly __typename?: "MyLensesGetAssetsResponse";
    readonly items: ReadonlyArray<MyLensesContentTypeAssetV2>;
    readonly total: Scalars["Int"]["output"];
};

export type MyLensesGetLensesRequest = {
    readonly filterBy?: InputMaybe<FilterBy>;
    readonly lensSpaceId?: InputMaybe<Scalars["ID"]["input"]>;
    readonly limit: Scalars["Int"]["input"];
    readonly offset: Scalars["Int"]["input"];
    readonly sortBy: SortBy;
    readonly sortDirection: MyLensesSortDirection;
    readonly type?: InputMaybe<GetLensesType>;
};

export type MyLensesGetOrganicStatsRequest = {
    readonly assetType?: InputMaybe<MyLensesAssetType>;
    readonly breakdownAssetType?: InputMaybe<MyLensesAssetType>;
    readonly endTime?: InputMaybe<GoogleProtobufTimestampInput>;
    readonly fieldsList?: InputMaybe<ReadonlyArray<OrganicStatsFieldInput>>;
    readonly granularity?: InputMaybe<ReportingGranularity>;
    readonly lensId?: InputMaybe<Scalars["ID"]["input"]>;
    readonly limit?: InputMaybe<Scalars["Int"]["input"]>;
    readonly sortBy?: InputMaybe<MetricField>;
    readonly sortDirection?: InputMaybe<ReportingSortDirection>;
    readonly startTime?: InputMaybe<GoogleProtobufTimestampInput>;
};

export type MyLensesGetOrganicStatsResponse = {
    readonly __typename?: "MyLensesGetOrganicStatsResponse";
    readonly responseEntryList: ReadonlyArray<MyLensesOrganicStatsResponseEntry>;
};

export type MyLensesGetOrganizationsResponse = {
    readonly __typename?: "MyLensesGetOrganizationsResponse";
    readonly brandProfile?: Maybe<Scalars["Boolean"]["output"]>;
    readonly organizationsList: ReadonlyArray<MyLensesOrganization>;
};

export type MyLensesGetRolesResponse = {
    readonly __typename?: "MyLensesGetRolesResponse";
    readonly rolesList: ReadonlyArray<MyLensesRole>;
};

export type MyLensesGetSubmissionErrorsRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type MyLensesGetSubmissionErrorsResponse = {
    readonly __typename?: "MyLensesGetSubmissionErrorsResponse";
    readonly submissionErrorsList: ReadonlyArray<MyLensesSubmissionError>;
};

export type MyLensesLens = {
    readonly __typename?: "MyLensesLens";
    /** @deprecated Use lensAccountId */
    readonly adAccountId?: Maybe<Scalars["ID"]["output"]>;
    readonly createdAt?: Maybe<GoogleProtobufTimestamp>;
    readonly description: Scalars["String"]["output"];
    readonly destinations: ReadonlyArray<LensDestination>;
    /** @deprecated Digital goods are deprecated */
    readonly digitalGoodsList: ReadonlyArray<DigitalGood>;
    readonly disabledDestinationTypesList: ReadonlyArray<DestinationType>;
    readonly discoverability?: Maybe<Discoverability>;
    readonly distributionRestrictionsList: ReadonlyArray<DistributionRestriction>;
    readonly distributionsList: ReadonlyArray<Distribution>;
    readonly exclusiveLensStatus: ExclusiveLensStatus;
    readonly iconUrl: Scalars["String"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly isAIClip: Scalars["Boolean"]["output"];
    readonly isGameUserProvided: Scalars["Boolean"]["output"];
    readonly lensAccountId?: Maybe<LensAccountId>;
    readonly lensCreatorPayoutEligibility: LensCreatorPayoutEligibility;
    readonly lensCta?: Maybe<MyLensesLensCta>;
    /** Time when this Lens was marked exclusive for Lens+ reporting. */
    readonly markedAsExclusiveAt?: Maybe<GoogleProtobufTimestamp>;
    readonly name: Scalars["String"]["output"];
    readonly organizationId: Scalars["ID"]["output"];
    readonly previewMediaList?: Maybe<ReadonlyArray<MyLensesPreviewMedia>>;
    /** @deprecated Use previewMediaList */
    readonly previewUrl: Scalars["String"]["output"];
    /** @deprecated Categories are being deprecated */
    readonly primaryCategoryId: Scalars["ID"]["output"];
    readonly qrCode?: Maybe<QrCode>;
    readonly rejectionErrors?: Maybe<LensRejectionErrors>;
    /** @deprecated Scan triggers feature is being removed */
    readonly scanTriggersList: ReadonlyArray<Scalars["String"]["output"]>;
    /** @deprecated Categories are being deprecated */
    readonly secondaryCategoryId: Scalars["ID"]["output"];
    readonly snapcode?: Maybe<Snapcode>;
    readonly sourceApplication?: Maybe<LensSourceApplication>;
    readonly spectaclesTags?: Maybe<ReadonlyArray<Scalars["String"]["output"]>>;
    readonly status: MyLensesLensStatus;
    readonly surfaceType: ReadonlyArray<SurfaceType>;
    readonly tagsList: ReadonlyArray<Scalars["String"]["output"]>;
    readonly unlockableId: Scalars["Float"]["output"];
    readonly updatedAt?: Maybe<GoogleProtobufTimestamp>;
    readonly updatedBy: Scalars["String"]["output"];
    readonly visibility: Visibility;
};

export type MyLensesLensCategory = {
    readonly __typename?: "MyLensesLensCategory";
    readonly deprecated?: Maybe<Scalars["Boolean"]["output"]>;
    readonly displayName?: Maybe<Scalars["String"]["output"]>;
    readonly id?: Maybe<Scalars["ID"]["output"]>;
    readonly parentId?: Maybe<Scalars["ID"]["output"]>;
};

export type MyLensesLensCta = {
    readonly __typename?: "MyLensesLensCta";
    readonly deeplink?: Maybe<MyLensesLensCtaDeeplink>;
    readonly text: MyLensesLensCtaText;
    readonly type: MyLensesLensCtaType;
    readonly website?: Maybe<LensCtaWebsite>;
};

export type MyLensesLensCtaDeeplink = {
    readonly __typename?: "MyLensesLensCtaDeeplink";
    readonly androidAppUrl: Scalars["String"]["output"];
    readonly appName: Scalars["String"]["output"];
    readonly iosAppId: Scalars["Float"]["output"];
    readonly uri: Scalars["String"]["output"];
};

export type MyLensesLensCtaInput = {
    readonly deeplink?: InputMaybe<LensCtaDeeplinkInput>;
    readonly text: MyLensesLensCtaText;
    readonly type: MyLensesLensCtaType;
    readonly website?: InputMaybe<LensCtaWebsiteInput>;
};

export enum MyLensesLensCtaText {
    CtaTextApplyNow = "CTA_TEXT_APPLY_NOW",
    CtaTextBookNow = "CTA_TEXT_BOOK_NOW",
    CtaTextBuyTickets = "CTA_TEXT_BUY_TICKETS",
    CtaTextDonate = "CTA_TEXT_DONATE",
    CtaTextDownload = "CTA_TEXT_DOWNLOAD",
    CtaTextGetNow = "CTA_TEXT_GET_NOW",
    CtaTextInstallNow = "CTA_TEXT_INSTALL_NOW",
    CtaTextListen = "CTA_TEXT_LISTEN",
    CtaTextMore = "CTA_TEXT_MORE",
    CtaTextOpenApp = "CTA_TEXT_OPEN_APP",
    CtaTextOrderNow = "CTA_TEXT_ORDER_NOW",
    CtaTextPlay = "CTA_TEXT_PLAY",
    CtaTextPlayGame = "CTA_TEXT_PLAY_GAME",
    CtaTextPreRegister = "CTA_TEXT_PRE_REGISTER",
    CtaTextRead = "CTA_TEXT_READ",
    CtaTextShow = "CTA_TEXT_SHOW",
    CtaTextShowtimes = "CTA_TEXT_SHOWTIMES",
    CtaTextSignUp = "CTA_TEXT_SIGN_UP",
    CtaTextTry = "CTA_TEXT_TRY",
    CtaTextUnset = "CTA_TEXT_UNSET",
    CtaTextView = "CTA_TEXT_VIEW",
    CtaTextViewMenu = "CTA_TEXT_VIEW_MENU",
    CtaTextViewProfile = "CTA_TEXT_VIEW_PROFILE",
    CtaTextVote = "CTA_TEXT_VOTE",
    CtaTextWatch = "CTA_TEXT_WATCH",
}

export enum MyLensesLensCtaType {
    CtaTypeDeeplink = "CTA_TYPE_DEEPLINK",
    CtaTypeUnset = "CTA_TYPE_UNSET",
    CtaTypeWebsite = "CTA_TYPE_WEBSITE",
}

export enum MyLensesLensStatus {
    LensStatusAvailable = "LENS_STATUS_AVAILABLE",
    LensStatusAwaitingProductTagging = "LENS_STATUS_AWAITING_PRODUCT_TAGGING",
    LensStatusFinalized = "LENS_STATUS_FINALIZED",
    LensStatusFinalizing = "LENS_STATUS_FINALIZING",
    LensStatusHidden = "LENS_STATUS_HIDDEN",
    LensStatusInvalid = "LENS_STATUS_INVALID",
    LensStatusInReview = "LENS_STATUS_IN_REVIEW",
    LensStatusLive = "LENS_STATUS_LIVE",
    LensStatusNotPublishedToSnapchat = "LENS_STATUS_NOT_PUBLISHED_TO_SNAPCHAT",
    LensStatusOffline = "LENS_STATUS_OFFLINE",
    LensStatusProcessing = "LENS_STATUS_PROCESSING",
    LensStatusReady = "LENS_STATUS_READY",
    LensStatusRejected = "LENS_STATUS_REJECTED",
    LensStatusUnset = "LENS_STATUS_UNSET",
}

export type MyLensesOrganicStatsResponseEntry = {
    readonly __typename?: "MyLensesOrganicStatsResponseEntry";
    readonly assetId: Scalars["String"]["output"];
    readonly assetType: MyLensesAssetType;
    readonly statsResponseTimeEntryList: ReadonlyArray<OrganicStatsResponseTimeEntry>;
};

export type MyLensesOrganization = {
    readonly __typename?: "MyLensesOrganization";
    readonly adAccountsList?: Maybe<ReadonlyArray<MyLensesAdAccount>>;
    readonly businessProfilesList?: Maybe<ReadonlyArray<BusinessProfile>>;
    readonly cameraKitEnabled: Scalars["Boolean"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly lensSpacesList: ReadonlyArray<LensSpace>;
    readonly name: Scalars["String"]["output"];
};

export type MyLensesOrganizations = {
    readonly __typename?: "MyLensesOrganizations";
    readonly organizationList: ReadonlyArray<ResourceContainer>;
};

export type MyLensesOrganizationsRequest = {
    readonly cursor: Scalars["String"]["input"];
    readonly limit: Scalars["Int"]["input"];
};

export enum MyLensesPlatformType {
    PlatformTypeMobile = "PLATFORM_TYPE_MOBILE",
    PlatformTypeNone = "PLATFORM_TYPE_NONE",
    PlatformTypeUnset = "PLATFORM_TYPE_UNSET",
    PlatformTypeWeb = "PLATFORM_TYPE_WEB",
}

export type MyLensesPortalMe = {
    readonly __typename?: "MyLensesPortalMe";
    readonly bitmojiUrl?: Maybe<Scalars["String"]["output"]>;
    readonly hasAgreedToLatestEula?: Maybe<Scalars["Boolean"]["output"]>;
    readonly latestEulaId?: Maybe<Scalars["String"]["output"]>;
    readonly latestEulaUrl?: Maybe<Scalars["String"]["output"]>;
    readonly snapchatUser?: Maybe<MyLensesSnapchatUser>;
};

export type MyLensesPreviewMedia = {
    readonly __typename?: "MyLensesPreviewMedia";
    readonly mediaId: Scalars["ID"]["output"];
    readonly standardMediaPosterUrl: Scalars["String"]["output"];
    readonly standardMediaUrl: Scalars["String"]["output"];
    readonly thumbnailMediaPosterUrl: Scalars["String"]["output"];
    readonly thumbnailMediaUrl: Scalars["String"]["output"];
};

export enum MyLensesReviewState {
    ReviewStateApproved = "REVIEW_STATE_APPROVED",
    ReviewStateInReview = "REVIEW_STATE_IN_REVIEW",
    ReviewStatePreReview = "REVIEW_STATE_PRE_REVIEW",
    ReviewStateRejected = "REVIEW_STATE_REJECTED",
    ReviewStateUnset = "REVIEW_STATE_UNSET",
}

export type MyLensesRole = {
    readonly __typename?: "MyLensesRole";
    readonly containerId: Scalars["ID"]["output"];
    readonly containerKind: ContainerKind;
    readonly id: Scalars["ID"]["output"];
    readonly roleType: MyLensesRoleType;
};

export enum MyLensesRoleType {
    RoleTypeAdmin = "ROLE_TYPE_ADMIN",
    RoleTypeLensFolderAdmin = "ROLE_TYPE_LENS_FOLDER_ADMIN",
    RoleTypeLensFolderCreator = "ROLE_TYPE_LENS_FOLDER_CREATOR",
    RoleTypeLensFolderManager = "ROLE_TYPE_LENS_FOLDER_MANAGER",
    RoleTypeMember = "ROLE_TYPE_MEMBER",
    RoleTypeUnset = "ROLE_TYPE_UNSET",
}

export type MyLensesSetCtaResponse = {
    readonly __typename?: "MyLensesSetCtaResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type MyLensesSetLensCtaRequest = {
    readonly lensCta?: InputMaybe<MyLensesLensCtaInput>;
    readonly lensId: Scalars["ID"]["input"];
};

export type MyLensesSnapchatUser = {
    readonly __typename?: "MyLensesSnapchatUser";
    readonly displayName?: Maybe<Scalars["String"]["output"]>;
    readonly username?: Maybe<Scalars["String"]["output"]>;
    readonly verifiedEmail?: Maybe<Scalars["String"]["output"]>;
};

export enum MyLensesSortDirection {
    SortDirectionAsc = "SORT_DIRECTION_ASC",
    SortDirectionDesc = "SORT_DIRECTION_DESC",
    SortDirectionUnset = "SORT_DIRECTION_UNSET",
}

export enum MyLensesStage {
    StageNone = "STAGE_NONE",
    StageProd = "STAGE_PROD",
    StageStaging = "STAGE_STAGING",
    StageUnset = "STAGE_UNSET",
}

export type MyLensesSubmissionError = {
    readonly __typename?: "MyLensesSubmissionError";
    readonly heading: Scalars["String"]["output"];
    readonly message: Scalars["String"]["output"];
};

export type MyLensesSubmissionValidationError = {
    readonly __typename?: "MyLensesSubmissionValidationError";
    readonly message: Scalars["String"]["output"];
    readonly title: Scalars["String"]["output"];
};

export type MyLensesUserInfo = {
    readonly __typename?: "MyLensesUserInfo";
    readonly iconLink?: Maybe<Scalars["String"]["output"]>;
    /** NOT USED */
    readonly id?: Maybe<Scalars["String"]["output"]>;
    readonly name?: Maybe<Scalars["String"]["output"]>;
    readonly permissions?: Maybe<UserPermissions>;
};

export type OnboardLensToLensCloudRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type OnboardLensToLensCloudResponse = {
    readonly __typename?: "OnboardLensToLensCloudResponse";
    readonly appId: Scalars["ID"]["output"];
};

export type OrgForMigratedAssets = {
    readonly __typename?: "OrgForMigratedAssets";
    readonly assets: ReadonlyArray<Scalars["String"]["output"]>;
    readonly organizationName: Scalars["String"]["output"];
};

export type OrganicStat = {
    readonly __typename?: "OrganicStat";
    readonly dimensionBreakdown: Scalars["String"]["output"];
    readonly value: Scalars["String"]["output"];
};

export type OrganicStatsField = {
    readonly __typename?: "OrganicStatsField";
    readonly fieldName: MetricField;
    readonly reportDimension: UserDimension;
};

export type OrganicStatsFieldInput = {
    readonly fieldName?: InputMaybe<MetricField>;
    readonly reportDimension?: InputMaybe<UserDimension>;
};

export type OrganicStatsProxyRequest = {
    readonly __typename?: "OrganicStatsProxyRequest";
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
    readonly request?: Maybe<SnapchatReportingOrganicGetOrganicStatsRequest>;
};

export type OrganicStatsProxyResponse = {
    readonly __typename?: "OrganicStatsProxyResponse";
    readonly lenses?: Maybe<ReadonlyArray<Maybe<CameraKitLens>>>;
    readonly response?: Maybe<SnapchatReportingOrganicGetOrganicStatsResponse>;
};

export type OrganicStatsResponseDimensionEntry = {
    readonly __typename?: "OrganicStatsResponseDimensionEntry";
    readonly field?: Maybe<OrganicStatsField>;
    readonly statsList: ReadonlyArray<OrganicStat>;
};

export type OrganicStatsResponseTimeEntry = {
    readonly __typename?: "OrganicStatsResponseTimeEntry";
    readonly statsList: ReadonlyArray<OrganicStatsResponseDimensionEntry>;
    readonly timestamp?: Maybe<GoogleProtobufTimestamp>;
};

export type OrganizationAndAdAccountId = {
    readonly __typename?: "OrganizationAndAdAccountID";
    readonly adAccountId: Scalars["ID"]["output"];
    readonly organizationId: Scalars["ID"]["output"];
};

export type OrganizationAuthorizedOperationsRequest = {
    readonly __typename?: "OrganizationAuthorizedOperationsRequest";
    readonly orgId?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationAuthorizedOperationsResponse = {
    readonly __typename?: "OrganizationAuthorizedOperationsResponse";
    readonly orgAuthorizedOperations?: Maybe<ReadonlyArray<Maybe<AppAuthorizedOperation>>>;
};

export type OrganizationByIdRequest = {
    readonly organizationId: Scalars["String"]["input"];
};

export type OrganizationCreateRequest = {
    readonly __typename?: "OrganizationCreateRequest";
    readonly orgName?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationCreateResponse = {
    readonly __typename?: "OrganizationCreateResponse";
    readonly organization?: Maybe<CameraKitOrganization>;
};

export type OrganizationEnableCameraKitRequest = {
    readonly __typename?: "OrganizationEnableCameraKitRequest";
    readonly orgId?: Maybe<Scalars["String"]["output"]>;
    readonly token?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationEnableCameraKitResponse = {
    readonly __typename?: "OrganizationEnableCameraKitResponse";
    readonly _?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationListRequest = {
    readonly __typename?: "OrganizationListRequest";
    readonly includeUnenabledOrgs?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OrganizationListResponse = {
    readonly __typename?: "OrganizationListResponse";
    readonly organizations?: Maybe<ReadonlyArray<Maybe<CameraKitOrganization>>>;
};

export type OrganizationMetadata = {
    readonly __typename?: "OrganizationMetadata";
    readonly id: Scalars["ID"]["output"];
    readonly name: Scalars["String"]["output"];
    readonly type: Scalars["String"]["output"];
};

export type OrganizationPlatformType = {
    readonly __typename?: "OrganizationPlatformType";
    readonly mobile?: Maybe<Scalars["Boolean"]["output"]>;
    readonly web?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OrganizationSearchRequest = {
    readonly __typename?: "OrganizationSearchRequest";
    readonly query?: Maybe<Scalars["String"]["output"]>;
};

export enum OrganizationUserRole {
    Admin = "ADMIN",
    Member = "MEMBER",
    Unset = "UNSET",
}

export enum OrgnanizationType {
    Enterprise = "ENTERPRISE",
    Provisional = "PROVISIONAL",
}

export enum ParameterLocation {
    Header = "HEADER",
    LocationUnset = "LOCATION_UNSET",
    Path = "PATH",
    Query = "QUERY",
}

export type PayoutCountryBreakdown = {
    readonly __typename?: "PayoutCountryBreakdown";
    readonly amountMilliUsd: Scalars["Long"]["output"];
    readonly countryCode: Scalars["String"]["output"];
    readonly lensPlusSignups: LensPlusSignupTotals;
    readonly payoutCount: Scalars["Int"]["output"];
    readonly subscriptionCount: Scalars["Int"]["output"];
};

export type PayoutHistory = {
    readonly __typename?: "PayoutHistory";
    readonly cursor: Scalars["String"]["output"];
    readonly periods: ReadonlyArray<PayoutPeriod>;
};

export type PayoutLensList = {
    readonly __typename?: "PayoutLensList";
    readonly cursor: Scalars["String"]["output"];
    readonly lenses: ReadonlyArray<RewardedLens>;
    readonly totalLensCount: Scalars["Int"]["output"];
};

export type PayoutPeriod = {
    readonly __typename?: "PayoutPeriod";
    readonly countryBreakdown: ReadonlyArray<PayoutCountryBreakdown>;
    readonly lensPlusSignups: LensPlusSignupTotals;
    readonly payoutLensScore?: Maybe<Scalars["Int"]["output"]>;
    readonly payoutLensSubscribeCount?: Maybe<Scalars["Int"]["output"]>;
    readonly payoutSubscriberActionsUu?: Maybe<Scalars["Int"]["output"]>;
    readonly period?: Maybe<Scalars["DateTime"]["output"]>;
    readonly totalAmountMilliUsd: Scalars["Long"]["output"];
    readonly totalPayoutCount: Scalars["Int"]["output"];
    readonly totalSubscriptionCount: Scalars["Int"]["output"];
};

export enum PayoutProgram {
    All = "ALL",
    LensPlus = "LENS_PLUS",
    TopPerformer = "TOP_PERFORMER",
}

export enum PayoutSortBy {
    SortByLastPayoutAt = "SORT_BY_LAST_PAYOUT_AT",
    SortByTotalAmountMilliUsd = "SORT_BY_TOTAL_AMOUNT_MILLI_USD",
    SortByTotalPayoutCount = "SORT_BY_TOTAL_PAYOUT_COUNT",
    SortByTotalSubscriptionCount = "SORT_BY_TOTAL_SUBSCRIPTION_COUNT",
    SortByUnset = "SORT_BY_UNSET",
}

export enum PayoutSortOrder {
    SortOrderAsc = "SORT_ORDER_ASC",
    SortOrderDesc = "SORT_ORDER_DESC",
    SortOrderUnset = "SORT_ORDER_UNSET",
}

export type PayoutStatsInput = {
    readonly countryFilters?: InputMaybe<ReadonlyArray<Scalars["String"]["input"]>>;
    readonly endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    readonly history?: InputMaybe<HistoryViewSettingInput>;
    readonly lensList?: InputMaybe<LensListViewSettingInput>;
    readonly payoutProgram?: PayoutProgram;
    readonly startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
    readonly summary?: InputMaybe<SummaryViewSettingInput>;
    readonly unlockableId?: InputMaybe<Scalars["String"]["input"]>;
};

export type PayoutStatsResponse = {
    readonly __typename?: "PayoutStatsResponse";
    readonly history?: Maybe<PayoutHistory>;
    readonly lensList?: Maybe<PayoutLensList>;
    readonly summary?: Maybe<PayoutSummary>;
};

export type PayoutSummary = {
    readonly __typename?: "PayoutSummary";
    readonly countryBreakdown: ReadonlyArray<PayoutCountryBreakdown>;
    readonly firstPayoutAt?: Maybe<Scalars["DateTime"]["output"]>;
    readonly lastPayoutAt?: Maybe<Scalars["DateTime"]["output"]>;
    /** @deprecated Use payoutLensScore. */
    readonly lensPlusScore?: Maybe<Scalars["Int"]["output"]>;
    readonly lensPlusSignups: LensPlusSignupTotals;
    readonly payoutLensScore?: Maybe<Scalars["Int"]["output"]>;
    readonly payoutLensSubscribeCount?: Maybe<Scalars["Int"]["output"]>;
    readonly payoutSubscriberActionsUu?: Maybe<Scalars["Int"]["output"]>;
    readonly totalEarningsMilliUsd: Scalars["Long"]["output"];
    readonly totalPayoutCount: Scalars["Int"]["output"];
    readonly totalSubscriberUniqueUsers?: Maybe<Scalars["Int"]["output"]>;
    readonly totalSubscriptionCount: Scalars["Int"]["output"];
};

export enum PayoutTimeGranularity {
    TimeGranularityDaily = "TIME_GRANULARITY_DAILY",
    TimeGranularityMonthly = "TIME_GRANULARITY_MONTHLY",
    TimeGranularityUnset = "TIME_GRANULARITY_UNSET",
}

export type PinGroupRequest = {
    readonly __typename?: "PinGroupRequest";
    readonly groupId?: Maybe<Scalars["String"]["output"]>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type PinGroupResponse = {
    readonly __typename?: "PinGroupResponse";
    readonly groupId?: Maybe<Scalars["String"]["output"]>;
};

export type PortalMeRequest = {
    readonly __typename?: "PortalMeRequest";
    readonly _?: Maybe<Scalars["String"]["output"]>;
};

export type PreviewMediaReference = {
    readonly __typename?: "PreviewMediaReference";
    readonly signedUrl: Scalars["String"]["output"];
    readonly uploadRefId: Scalars["String"]["output"];
};

export type PreviewMediaResource = {
    readonly mediaId?: InputMaybe<Scalars["ID"]["input"]>;
    readonly uploadRefId?: InputMaybe<Scalars["ID"]["input"]>;
};

/**
 * Push an UNSUBMITTED web-app package to the creator's own Snapchat for a quick preview — the
 * web-lens analog of Lens Studio's "Preview Lens" button. Fully ephemeral: no My Lenses record
 * is created, nothing appears in any Lens Folder, and the preview never enters review. The
 * zip-to-lens conversion runs INSIDE this call (the light push-to-device build), so a rejected
 * archive fails here with the conversion's reason — unlike submission, where it surfaces later
 * on the lens. On success, the creator gets a Team Snapchat notification on the Snapchat
 * account they are signed in with, and the Lens appears in their Lens carousel.
 */
export type PreviewWebLensOnDeviceRequest = {
    /** True when an icon was also PUT to the same ticket's logo signed URL. False = the preview uses the default web-lens icon. */
    readonly logoUploaded: Scalars["Boolean"]["input"];
    /** Optional display name shown on the preview lens in Snapchat, same constraints as submission. Omitted = a default name. */
    readonly name?: InputMaybe<Scalars["String"]["input"]>;
    /** Upload ref from createWebLensUpload, after PUTting the package to its signed URL — the same ticket flow as submission. */
    readonly packageRef: Scalars["String"]["input"];
};

export type PreviewWebLensOnDeviceResponse = {
    readonly __typename?: "PreviewWebLensOnDeviceResponse";
    /** The ephemeral preview lens id; null when a check failed before the push. Informational only — the preview is not a My Lenses record and cannot be queried here. */
    readonly previewLensId?: Maybe<Scalars["ID"]["output"]>;
    /** Push-time checks in execution order. PUSH_LENS carries the conversion's creator-facing reason on failure. */
    readonly validation: ReadonlyArray<WebLensValidationCheck>;
};

export type PriceTier = {
    readonly __typename?: "PriceTier";
    readonly tier?: Maybe<Scalars["Int"]["output"]>;
    readonly tokens?: Maybe<Scalars["Int"]["output"]>;
};

export type ProcessMediaRequest = {
    readonly aspectRatioType: AspectRatioType;
    readonly height: Scalars["Int"]["input"];
    readonly mediaType: Scalars["String"]["input"];
    readonly source: MediaSourceInput;
    readonly timestamp?: InputMaybe<Scalars["Float"]["input"]>;
    readonly width: Scalars["Int"]["input"];
    readonly x: Scalars["Int"]["input"];
    readonly y: Scalars["Int"]["input"];
};

export type ProcessMediaResponse = {
    readonly __typename?: "ProcessMediaResponse";
    readonly mediaId: Scalars["String"]["output"];
    readonly mediaStatus: Scalars["String"]["output"];
    readonly mediaType: Scalars["String"]["output"];
    readonly mediaUrl: Scalars["String"]["output"];
};

export type PublicProfileMetadata = {
    readonly __typename?: "PublicProfileMetadata";
    readonly description: Scalars["String"]["output"];
    readonly displayName: Scalars["String"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly organizationId: Scalars["String"]["output"];
    readonly snapUserName: Scalars["String"]["output"];
};

export type QrCode = {
    readonly __typename?: "QrCode";
    readonly deeplink: Scalars["String"]["output"];
    readonly imagesList: ReadonlyArray<QrCodeImage>;
};

export type QrCodeImage = {
    readonly __typename?: "QrCodeImage";
    readonly format: QrCodeImageFormat;
    readonly imageUrl: Scalars["String"]["output"];
};

export enum QrCodeImageFormat {
    ImageFormatSvg = "IMAGE_FORMAT_SVG",
    ImageFormatUnset = "IMAGE_FORMAT_UNSET",
    ImageFormatWebp = "IMAGE_FORMAT_WEBP",
}

export type Query = {
    readonly __typename?: "Query";
    readonly _service: Service;
    readonly assetLibraryFileExtensions: ReadonlyArray<AssetLibraryFileExtensions>;
    readonly cameraKitMe?: Maybe<CameraKitPortalMeResponse>;
    readonly cameraKitPermissions: CameraKitPermissions;
    readonly childResources: ChildResources;
    readonly creatorRewardRecord: CreatorRewardRecord;
    readonly getAffectedGroups?: Maybe<LenssourceGetAffectedGroupsResponse>;
    readonly getAppInfo?: Maybe<GetApplicationInfoResponse>;
    readonly getAppList?: Maybe<ReadonlyArray<AppInfo>>;
    /** @deprecated Use getMyLensesUserAssets instead */
    readonly getAsset: GetAssetResponse;
    readonly getCameraKitOrganicStats?: Maybe<SnapchatReportingOrganicGetOrganicStatsResponse>;
    readonly getCameraKitOrganizations?: Maybe<OrganizationListResponse>;
    readonly getCofConfigs: GetCofConfigsResponse;
    readonly getGroupListV2?: Maybe<GroupListWithConnections>;
    readonly getGroupV2?: Maybe<GroupWithConnections>;
    readonly getHostedLens: GetHostedLensResponse;
    readonly getHostedLenses: GetHostedLensesResponse;
    readonly getIldgEligibility: GetIldgEligibilityResponse;
    readonly getLens: GetLensResponse;
    readonly getLensAutomationToolMaintenanceStatus: GetLensAutomationToolMaintenanceStatusResponse;
    readonly getLensCategoryList: GetLensCategoryListResponse;
    readonly getLensDestinations: GetLensDestinationsResponse;
    readonly getLensDiscoverabilityLocationTagCandidates: GetLensDiscoverabilityLocationTagCandidatesResponse;
    readonly getLensDiscoverabilityTimeTagCandidates: GetLensDiscoverabilityTimeTagCandidatesResponse;
    readonly getLensDiscoverabilityVisualTagCandidates: GetLensDiscoverabilityVisualTagCandidatesResponse;
    readonly getLensListV2?: Maybe<LensListWithConnections>;
    readonly getLensSourceList?: Maybe<LenssourceGetLensSourceListResponse>;
    readonly getLensSourceListEnabled?: Maybe<LenssourceGetLensSourceListEnabledResponse>;
    readonly getLensStudioVersions: GetLensStudioVersionsResponse;
    readonly getLensV2?: Maybe<LensWithConnections>;
    readonly getLensesForUpdate: GetLensesResponse;
    readonly getLensesWithDigitalGoods: GetLensesWithDigitalGoodsResponse;
    readonly getMyLensesAdAccounts: MyLensesGetAdAccountsResponse;
    readonly getMyLensesLenses: GetLensesResponse;
    readonly getMyLensesOrganicStats: MyLensesGetOrganicStatsResponse;
    readonly getMyLensesOrganizationAssets: MyLensesGetAssetsResponse;
    readonly getMyLensesOrganizations: MyLensesGetOrganizationsResponse;
    readonly getMyLensesOrganizationsAvailableForLensSpaceCreation: MyLensesGetOrganizationsResponse;
    readonly getMyLensesRoles: MyLensesGetRolesResponse;
    readonly getMyLensesSubmissionErrors: MyLensesGetSubmissionErrorsResponse;
    readonly getMyLensesUserAssets: MyLensesGetAssetsResponse;
    readonly getOrganicStatsV2?: Maybe<OrganicStatsProxyResponse>;
    readonly getOrganizationMetadata: GetOrganizationMetadataResponse;
    readonly getPreSubmissionInfo: GetPreSubmissionInfoResponse;
    readonly getPriceTiers: GetPriceTiersResponse;
    /** @deprecated Scan triggers feature is being removed */
    readonly getScanTriggers: GetScanTriggersResponse;
    readonly getSupportedLensSourceTypes?: Maybe<LenssourceGetSupportedLensSourceTypesResponse>;
    readonly getTos: GetTosResponse;
    readonly getUndismissedExperiences: GetUndismissedExperiencesResponse;
    /** @deprecated Use user instead */
    readonly getUserInfo?: Maybe<MyLensesUserInfo>;
    /** @deprecated Use user instead */
    readonly getUserProfile: GetUserProfileResponse;
    readonly isCameraKitEnabled?: Maybe<IsCameraKitEnabledOrganizationResponse>;
    readonly isUnauthorized?: Maybe<Scalars["Boolean"]["output"]>;
    readonly lensActivityTotals: LensActivityTotalsResponse;
    readonly lensCloudApp: LensCloudApp;
    readonly lensPayoutHistory: LensPayoutHistoryResponse;
    readonly lensScores: LensScoresResponse;
    readonly myLensesOrganizations: MyLensesOrganizations;
    readonly myLensesOrganizationsForLensSpaceCreation: MyLensesOrganizations;
    readonly orgForMigratedAssets: OrgForMigratedAssets;
    readonly organizationById: ResourceContainer;
    readonly payoutStats: PayoutStatsResponse;
    readonly releaseNotes: ReleaseNotesResponse;
    readonly remoteApiSpec: RemoteApiSpec;
    readonly remoteApiSpecs: ReadonlyArray<RemoteApiSpec>;
    readonly remoteAsset?: Maybe<RemoteAsset>;
    readonly remoteAssets: RemoteAssetsConnection;
    readonly remoteAssetsQuota: RemoteAssetsQuota;
    readonly searchOrganizations?: Maybe<OrganizationListResponse>;
    readonly selectedOrganization?: Maybe<CameraKitOrganization>;
    readonly spectaclesTags: ReadonlyArray<Scalars["String"]["output"]>;
    readonly spotlightStories: SpotlightStoriesResponse;
    readonly submissionQuotas?: Maybe<SubmissionQuotas>;
    readonly topPerformerLenses: TopPerformerLensesResponse;
    readonly trendingOnSpotlight: ReadonlyArray<Trend>;
    readonly trendingTags: ReadonlyArray<TrendingTag>;
    readonly user: User;
    readonly validateOnboardingToken: ValidateOnboardingTokenResponse;
};

export type QueryCameraKitMeArgs = {
    input?: InputMaybe<InputPortalMeRequest>;
};

export type QueryCameraKitPermissionsArgs = {
    input: CameraKitPermissionsRequest;
};

export type QueryChildResourcesArgs = {
    input: ChildResourcesRequest;
};

export type QueryCreatorRewardRecordArgs = {
    input: CreatorRewardRecordRequest;
};

export type QueryGetAffectedGroupsArgs = {
    input?: InputMaybe<InputLenssourceGetAffectedGroupsRequest>;
};

export type QueryGetAppInfoArgs = {
    input?: InputMaybe<InputGetApplicationInfoRequest>;
};

export type QueryGetAppListArgs = {
    input?: InputMaybe<InputListApplicationRequest>;
};

export type QueryGetAssetArgs = {
    input: GetAssetRequest;
};

export type QueryGetCameraKitOrganicStatsArgs = {
    input?: InputMaybe<InputSnapchatReportingOrganicGetOrganicStatsRequest>;
};

export type QueryGetCameraKitOrganizationsArgs = {
    input?: InputMaybe<InputOrganizationListRequest>;
};

export type QueryGetCofConfigsArgs = {
    input: GetCofConfigsRequest;
};

export type QueryGetGroupListV2Args = {
    input?: InputMaybe<InputGroupListRequest>;
};

export type QueryGetGroupV2Args = {
    input?: InputMaybe<InputGroupRequest>;
};

export type QueryGetHostedLensArgs = {
    input: GetHostedLensRequest;
};

export type QueryGetHostedLensesArgs = {
    input: GetHostedLensesRequest;
};

export type QueryGetLensArgs = {
    input: GetLensRequest;
};

export type QueryGetLensDestinationsArgs = {
    input: GetLensDestinationsRequest;
};

export type QueryGetLensDiscoverabilityLocationTagCandidatesArgs = {
    input: GetLensDiscoverabilityLocationTagCandidatesRequest;
};

export type QueryGetLensDiscoverabilityTimeTagCandidatesArgs = {
    input: GetLensDiscoverabilityTimeTagCandidatesRequest;
};

export type QueryGetLensDiscoverabilityVisualTagCandidatesArgs = {
    input: GetLensDiscoverabilityVisualTagCandidatesRequest;
};

export type QueryGetLensListV2Args = {
    input?: InputMaybe<InputLensesRequest>;
};

export type QueryGetLensSourceListArgs = {
    input?: InputMaybe<InputLenssourceGetLensSourceListRequest>;
};

export type QueryGetLensSourceListEnabledArgs = {
    input?: InputMaybe<InputLenssourceGetLensSourceListEnabledRequest>;
};

export type QueryGetLensV2Args = {
    input?: InputMaybe<InputLensRequest>;
};

export type QueryGetLensesForUpdateArgs = {
    input: MyLensesGetLensesRequest;
};

export type QueryGetLensesWithDigitalGoodsArgs = {
    input: GetLensesWithDigitalGoodsRequest;
};

export type QueryGetMyLensesAdAccountsArgs = {
    input: GetAdAccountsRequest;
};

export type QueryGetMyLensesLensesArgs = {
    input: MyLensesGetLensesRequest;
};

export type QueryGetMyLensesOrganicStatsArgs = {
    input: MyLensesGetOrganicStatsRequest;
};

export type QueryGetMyLensesOrganizationAssetsArgs = {
    input: GetOrganizationAssetsRequest;
};

export type QueryGetMyLensesSubmissionErrorsArgs = {
    input: MyLensesGetSubmissionErrorsRequest;
};

export type QueryGetMyLensesUserAssetsArgs = {
    input: GetUserAssetsRequest;
};

export type QueryGetOrganicStatsV2Args = {
    input?: InputMaybe<InputOrganicStatsProxyRequest>;
};

export type QueryGetOrganizationMetadataArgs = {
    input: GetOrganizationMetadataRequest;
};

export type QueryGetPreSubmissionInfoArgs = {
    input: GetPreSubmissionInfoRequest;
};

export type QueryGetSupportedLensSourceTypesArgs = {
    input?: InputMaybe<InputLenssourceGetSupportedLensSourceTypesRequest>;
};

export type QueryGetTosArgs = {
    input: GetTosRequest;
};

export type QueryGetUndismissedExperiencesArgs = {
    input: GetUndismissedExperiencesRequest;
};

export type QueryGetUserInfoArgs = {
    input?: InputMaybe<InputGetUserInfoRequest>;
};

export type QueryIsCameraKitEnabledArgs = {
    input?: InputMaybe<InputIsCameraKitEnabledOrganizationRequest>;
};

export type QueryLensActivityTotalsArgs = {
    input: LensActivityTotalsInput;
};

export type QueryLensCloudAppArgs = {
    input: LensCloudAppRequest;
};

export type QueryLensPayoutHistoryArgs = {
    input: LensPayoutHistoryRequest;
};

export type QueryLensScoresArgs = {
    input: LensScoresInput;
};

export type QueryMyLensesOrganizationsArgs = {
    input: MyLensesOrganizationsRequest;
};

export type QueryMyLensesOrganizationsForLensSpaceCreationArgs = {
    input: MyLensesOrganizationsRequest;
};

export type QueryOrganizationByIdArgs = {
    input: OrganizationByIdRequest;
};

export type QueryPayoutStatsArgs = {
    input: PayoutStatsInput;
};

export type QueryReleaseNotesArgs = {
    input: ReleaseNotesRequest;
};

export type QueryRemoteApiSpecArgs = {
    input: GetRemoteApiSpecRequest;
};

export type QueryRemoteApiSpecsArgs = {
    input?: InputMaybe<GetRemoteApiSpecsRequest>;
};

export type QueryRemoteAssetArgs = {
    input: GetRemoteAssetRequest;
};

export type QueryRemoteAssetsArgs = {
    input: GetRemoteAssetsRequest;
};

export type QueryRemoteAssetsQuotaArgs = {
    input: GetRemoteAssetsQuotaRequest;
};

export type QuerySearchOrganizationsArgs = {
    input?: InputMaybe<InputOrganizationSearchRequest>;
};

export type QuerySpotlightStoriesArgs = {
    input: SpotlightStoriesInput;
};

export type QueryTopPerformerLensesArgs = {
    input: TopPerformerLensesInput;
};

export type QueryValidateOnboardingTokenArgs = {
    input: ValidateOnboardingTokenRequest;
};

export type RefreshBusinessLensSnapcodeExpirationRequest = {
    readonly lensId: Scalars["ID"]["input"];
};

export type RefreshBusinessLensSnapcodeExpirationResponse = {
    readonly __typename?: "RefreshBusinessLensSnapcodeExpirationResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type ReleaseConnectionBulkRequest = {
    readonly __typename?: "ReleaseConnectionBulkRequest";
    readonly releaseRequests?: Maybe<ReadonlyArray<Maybe<ReleaseConnectionRequest>>>;
};

export type ReleaseConnectionBulkResponse = {
    readonly __typename?: "ReleaseConnectionBulkResponse";
    readonly releaseResponses?: Maybe<ReadonlyArray<Maybe<ReleaseConnectionResponse>>>;
};

export type ReleaseConnectionRequest = {
    readonly __typename?: "ReleaseConnectionRequest";
    readonly groupId?: Maybe<Scalars["String"]["output"]>;
    readonly lensCompoundId?: Maybe<LensCompoundId>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
};

export type ReleaseConnectionResponse = {
    readonly __typename?: "ReleaseConnectionResponse";
    readonly connectionId?: Maybe<Scalars["String"]["output"]>;
    readonly groupId?: Maybe<Scalars["String"]["output"]>;
    readonly lensCompoundId?: Maybe<LensCompoundId>;
};

export type ReleaseNote = {
    readonly __typename?: "ReleaseNote";
    readonly note: Scalars["String"]["output"];
    readonly releaseDate?: Maybe<GoogleProtobufTimestamp>;
};

export type ReleaseNotesRequest = {
    readonly lensId: Scalars["ID"]["input"];
    readonly limit: Scalars["Int"]["input"];
};

export type ReleaseNotesResponse = {
    readonly __typename?: "ReleaseNotesResponse";
    readonly releaseNotes: ReadonlyArray<ReleaseNote>;
};

export type RemoteApiHttpEndpoint = {
    readonly __typename?: "RemoteApiHttpEndpoint";
    readonly methods: ReadonlyArray<HttpRequestMethod>;
    readonly parameters: ReadonlyArray<RemoteApiHttpRequestParameter>;
    readonly path: Scalars["String"]["output"];
    readonly refId: Scalars["String"]["output"];
};

export type RemoteApiHttpEndpointInput = {
    readonly methods: ReadonlyArray<HttpRequestMethod>;
    readonly parameters: ReadonlyArray<RemoteApiHttpRequestParameterInput>;
    readonly path: Scalars["String"]["input"];
    readonly refId: Scalars["String"]["input"];
};

export type RemoteApiHttpRequestParameter = {
    readonly __typename?: "RemoteApiHttpRequestParameter";
    readonly constant: Scalars["Boolean"]["output"];
    readonly defaultValue: Scalars["String"]["output"];
    readonly location: ParameterLocation;
    readonly name: Scalars["String"]["output"];
    readonly optional: Scalars["Boolean"]["output"];
};

export type RemoteApiHttpRequestParameterInput = {
    readonly constant: Scalars["Boolean"]["input"];
    readonly defaultValue: Scalars["String"]["input"];
    readonly location: ParameterLocation;
    readonly name: Scalars["String"]["input"];
    readonly optional: Scalars["Boolean"]["input"];
};

export type RemoteApiSpec = {
    readonly __typename?: "RemoteApiSpec";
    readonly approvalState: SpecApprovalState;
    readonly author: Scalars["String"]["output"];
    readonly createdAt: Scalars["DateTime"]["output"];
    readonly customVisibilityUsersList?: Maybe<ReadonlyArray<Scalars["String"]["output"]>>;
    readonly description: Scalars["String"]["output"];
    readonly documentationUrl: Scalars["String"]["output"];
    readonly endpoints: ReadonlyArray<RemoteApiHttpEndpoint>;
    readonly host: Scalars["String"]["output"];
    readonly iconUrl: Scalars["String"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly lastEditor: Scalars["String"]["output"];
    readonly localOnly: Scalars["Boolean"]["output"];
    readonly maxRequestSizeBytes: Scalars["Int"]["output"];
    readonly maxResponseSizeBytes: Scalars["Int"]["output"];
    readonly maxResponseTimeMillis: Scalars["Int"]["output"];
    readonly minLensStudioVersion: Scalars["String"]["output"];
    readonly name: Scalars["String"]["output"];
    readonly orgId: Scalars["ID"]["output"];
    readonly providerName: Scalars["String"]["output"];
    readonly snapkitAppId: Scalars["String"]["output"];
    readonly targetPlatforms: ReadonlyArray<TargetPlatform>;
    readonly updatedAt: Scalars["DateTime"]["output"];
    readonly useBuiltinLocalProcessor: Scalars["Boolean"]["output"];
    readonly version: Scalars["Int"]["output"];
    readonly visibility: SpecVisibility;
};

export type RemoteAsset = {
    readonly __typename?: "RemoteAsset";
    readonly assetSize: Scalars["Long"]["output"];
    readonly createdAt: Scalars["DateTime"]["output"];
    readonly createdBy: Scalars["String"]["output"];
    readonly description?: Maybe<Scalars["String"]["output"]>;
    readonly forkingAllowed: Scalars["Boolean"]["output"];
    readonly iconUrl: Scalars["String"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly lensUsages: Scalars["Int"]["output"];
    readonly minCoreVersion?: Maybe<Scalars["Int"]["output"]>;
    readonly name: Scalars["String"]["output"];
    readonly organizationId: Scalars["ID"]["output"];
    readonly resources: ReadonlyArray<RemoteAssetResource>;
    readonly sourceAssetId?: Maybe<Scalars["ID"]["output"]>;
    readonly type: RemoteAssetType;
    readonly updatedAt: Scalars["DateTime"]["output"];
    readonly updatedBy: Scalars["String"]["output"];
    readonly usedByLensesConnection: LensUsageConnection;
};

export type RemoteAssetUsedByLensesConnectionArgs = {
    cursor?: InputMaybe<Scalars["String"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RemoteAssetError = {
    readonly __typename?: "RemoteAssetError";
    readonly code: Scalars["String"]["output"];
    readonly message: Scalars["String"]["output"];
};

export type RemoteAssetResource = {
    readonly __typename?: "RemoteAssetResource";
    readonly checksum?: Maybe<Scalars["String"]["output"]>;
    readonly type: ResourceType;
    readonly url: Scalars["String"]["output"];
};

export enum RemoteAssetType {
    Audio = "AUDIO",
    Mesh = "MESH",
    MlAsset = "ML_ASSET",
    Scene = "SCENE",
    Script = "SCRIPT",
    Texture = "TEXTURE",
}

export type RemoteAssetsConnection = {
    readonly __typename?: "RemoteAssetsConnection";
    readonly cursor?: Maybe<Scalars["String"]["output"]>;
    readonly nodes: ReadonlyArray<RemoteAsset>;
};

export type RemoteAssetsQuota = {
    readonly __typename?: "RemoteAssetsQuota";
    readonly perAssetLimitBytes: Scalars["Long"]["output"];
    readonly perLensLimitBytes: Scalars["Long"]["output"];
    readonly totalBytes: Scalars["Long"]["output"];
    readonly usedBytes: Scalars["Long"]["output"];
};

export enum ReportingGranularity {
    Day = "DAY",
    GranularityUnset = "GRANULARITY_UNSET",
    Hour = "HOUR",
    Lifetime = "LIFETIME",
    Month = "MONTH",
    Total = "TOTAL",
}

export enum ReportingSortDirection {
    SortDirectionAsc = "SORT_DIRECTION_ASC",
    SortDirectionDesc = "SORT_DIRECTION_DESC",
    SortDirectionUnset = "SORT_DIRECTION_UNSET",
}

export type ResourceContainer = {
    readonly __typename?: "ResourceContainer";
    readonly id: Scalars["String"]["output"];
    readonly kind: ResourceKind;
    readonly name: Scalars["String"]["output"];
    readonly parentName: Scalars["String"]["output"];
    readonly roles: ReadonlyArray<MyLensesRoleType>;
};

export enum ResourceKind {
    CameraKits = "CAMERA_KITS",
    LensSpaces = "LENS_SPACES",
    Organizations = "ORGANIZATIONS",
}

export enum ResourceType {
    Lns = "LNS",
    Zip = "ZIP",
}

export enum RestrictionType {
    RestrictionTypeAge = "RESTRICTION_TYPE_AGE",
    RestrictionTypeAppSurface = "RESTRICTION_TYPE_APP_SURFACE",
    RestrictionTypeCountry = "RESTRICTION_TYPE_COUNTRY",
    RestrictionTypeUnset = "RESTRICTION_TYPE_UNSET",
}

export type RevokeCameraKitRequest = {
    readonly __typename?: "RevokeCameraKitRequest";
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
    readonly principalId?: Maybe<Scalars["String"]["output"]>;
};

export type RevokeCameraKitResponse = {
    readonly __typename?: "RevokeCameraKitResponse";
    readonly _?: Maybe<Scalars["String"]["output"]>;
};

export type RewardedLens = {
    readonly __typename?: "RewardedLens";
    readonly firstPayoutAt?: Maybe<Scalars["DateTime"]["output"]>;
    readonly lastPayoutAt?: Maybe<Scalars["DateTime"]["output"]>;
    readonly lens?: Maybe<MyLensesLens>;
    /** @deprecated Use payoutLensScore. */
    readonly lensPlusScore?: Maybe<Scalars["Int"]["output"]>;
    readonly lensPlusSignups: LensPlusSignupTotals;
    readonly payoutLensScore?: Maybe<Scalars["Int"]["output"]>;
    readonly payoutLensSubscribeCount?: Maybe<Scalars["Int"]["output"]>;
    readonly payoutSubscriberActionsUu?: Maybe<Scalars["Int"]["output"]>;
    readonly totalEarningsMilliUsd: Scalars["Long"]["output"];
    readonly totalPayoutCount: Scalars["Int"]["output"];
    readonly totalSubscriberUniqueUsers?: Maybe<Scalars["Int"]["output"]>;
    readonly totalSubscriptionCount: Scalars["Int"]["output"];
    readonly unlockableId: Scalars["String"]["output"];
};

export type SaveLensRequest = {
    readonly __typename?: "SaveLensRequest";
    readonly lensCompoundId?: Maybe<LensCompoundId>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
    readonly vendorData?: Maybe<ReadonlyArray<Maybe<VendorDataItem>>>;
};

export type SaveRemoteApiSpecRequest = {
    readonly customVisibilityUsersList: ReadonlyArray<Scalars["String"]["input"]>;
    readonly description: Scalars["String"]["input"];
    readonly documentationUrl: Scalars["String"]["input"];
    readonly endpoints: ReadonlyArray<RemoteApiHttpEndpointInput>;
    readonly host: Scalars["String"]["input"];
    readonly iconUrl: Scalars["String"]["input"];
    readonly id?: InputMaybe<Scalars["ID"]["input"]>;
    readonly localOnly: Scalars["Boolean"]["input"];
    readonly maxRequestSizeBytes: Scalars["Int"]["input"];
    readonly maxResponseSizeBytes: Scalars["Int"]["input"];
    readonly maxResponseTimeMillis: Scalars["Int"]["input"];
    readonly minLensStudioVersion: Scalars["String"]["input"];
    readonly name: Scalars["String"]["input"];
    readonly orgId: Scalars["ID"]["input"];
    readonly providerName: Scalars["String"]["input"];
    readonly snapkitAppId: Scalars["String"]["input"];
    readonly targetPlatforms: ReadonlyArray<TargetPlatform>;
    readonly useBuiltinLocalProcessor: Scalars["Boolean"]["input"];
    readonly visibility: SpecVisibility;
};

export type SaveRemoteApiSpecResponse = {
    readonly __typename?: "SaveRemoteApiSpecResponse";
    readonly id: Scalars["ID"]["output"];
};

export type Schedule = {
    readonly __typename?: "Schedule";
    readonly scheduleEnd?: Maybe<GoogleProtobufTimestamp>;
    readonly scheduleStart?: Maybe<GoogleProtobufTimestamp>;
    readonly useClientTimezone?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SetAppVendorUuidOptinFlagRequest = {
    readonly __typename?: "SetAppVendorUuidOptinFlagRequest";
    readonly appId?: Maybe<Scalars["String"]["output"]>;
    readonly appVendorOptInEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SetAppVendorUuidOptinFlagResponse = {
    readonly __typename?: "SetAppVendorUuidOptinFlagResponse";
    readonly appVendorOptInEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SetDigitalGoodsRequest = {
    readonly digitalGoodsList: ReadonlyArray<DigitalGoodInput>;
    readonly lensId: Scalars["ID"]["input"];
};

export type SetDigitalGoodsResponse = {
    readonly __typename?: "SetDigitalGoodsResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type SetDiscoverabilityRequest = {
    readonly discoverability: DiscoverabilityInput;
    readonly lensId: Scalars["ID"]["input"];
};

export type SetDiscoverabilityResponse = {
    readonly __typename?: "SetDiscoverabilityResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type SetExperienceDismissedRequest = {
    readonly experienceType: ExperienceType;
};

export type SetLensCategoryRequest = {
    readonly lensId: Scalars["ID"]["input"];
    readonly primaryCategoryId: Scalars["ID"]["input"];
    readonly secondaryCategoryId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type SetLensCategoryResponse = {
    readonly __typename?: "SetLensCategoryResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type SetLensCreatorPayoutEnrollmentRequest = {
    readonly lensCreatorPayoutEnrolled: Scalars["Boolean"]["input"];
    readonly lensId: Scalars["ID"]["input"];
};

export type SetLensCreatorPayoutEnrollmentResponse = {
    readonly __typename?: "SetLensCreatorPayoutEnrollmentResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type SetLensCreatorPayoutTosAcceptedVersionRequest = {
    readonly version: Scalars["Int"]["input"];
};

export type SetLensDescriptionRequest = {
    readonly description: Scalars["String"]["input"];
    readonly lensId: Scalars["ID"]["input"];
};

export type SetLensDescriptionResponse = {
    readonly __typename?: "SetLensDescriptionResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type SetLensPreviewRequest = {
    readonly lensId: Scalars["ID"]["input"];
    readonly lensPreview?: InputMaybe<Scalars["Upload"]["input"]>;
};

export type SetLensPreviewResponse = {
    readonly __typename?: "SetLensPreviewResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type SetScanTriggersRequest = {
    readonly lensId: Scalars["ID"]["input"];
    readonly scanTriggersList: ReadonlyArray<Scalars["String"]["input"]>;
};

export type SetScanTriggersResponse = {
    readonly __typename?: "SetScanTriggersResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type SetTagsRequest = {
    readonly lensId: Scalars["ID"]["input"];
    readonly tagsList: ReadonlyArray<Scalars["String"]["input"]>;
};

export type SetTagsResponse = {
    readonly __typename?: "SetTagsResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type SetTosLatestAcceptedVersionRequest = {
    readonly key: TosKey;
};

export type SetVisibilityRequest = {
    readonly lensId: Scalars["ID"]["input"];
    readonly visibility: Visibility;
};

export type SetVisibilityResponse = {
    readonly __typename?: "SetVisibilityResponse";
    readonly lens?: Maybe<MyLensesLens>;
};

export type SignEulaRequest = {
    readonly eulaId: Scalars["String"]["input"];
};

export type SignEulaResponse = {
    readonly __typename?: "SignEULAResponse";
    readonly hasAgreedToLatestEula?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SnapKitOnboardRequest = {
    readonly __typename?: "SnapKitOnboardRequest";
    readonly appId?: Maybe<Scalars["String"]["output"]>;
    readonly cameraKitEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    readonly organizationId?: Maybe<Scalars["String"]["output"]>;
    readonly principalId?: Maybe<Scalars["String"]["output"]>;
};

export type SnapKitOnboardResponse = {
    readonly __typename?: "SnapKitOnboardResponse";
    readonly _?: Maybe<Scalars["String"]["output"]>;
};

export enum SnapchatReportingOrganicAssetType {
    AdKitApp = "AD_KIT_APP",
    AssetTypeUnset = "ASSET_TYPE_UNSET",
    CamkitLens = "CAMKIT_LENS",
    Game = "GAME",
    /** @deprecated deprecated in proto */
    Highlight = "HIGHLIGHT",
    Lens = "LENS",
    Organization = "ORGANIZATION",
    Place = "PLACE",
    PlaceCollection = "PLACE_COLLECTION",
    PlaceCountry = "PLACE_COUNTRY",
    PlaceRegion = "PLACE_REGION",
    Profile = "PROFILE",
    QrSnapcode = "QR_SNAPCODE",
    SavedStory = "SAVED_STORY",
    Snap = "SNAP",
    Snapcode = "SNAPCODE",
    Spotlight = "SPOTLIGHT",
    Store = "STORE",
    Story = "STORY",
    Tile = "TILE",
    User = "USER",
}

export enum SnapchatReportingOrganicConversionReportTime {
    Conversion = "CONVERSION",
    ConversionReportingTimeUnset = "CONVERSION_REPORTING_TIME_UNSET",
    Exposure = "EXPOSURE",
}

export enum SnapchatReportingOrganicConversionSourceType {
    App = "APP",
    ConversionSourceTypeUnset = "CONVERSION_SOURCE_TYPE_UNSET",
    Native = "NATIVE",
    Offline = "OFFLINE",
    TotalConversions = "TOTAL_CONVERSIONS",
    TotalOffPlatform = "TOTAL_OFF_PLATFORM",
    Web = "WEB",
}

export enum SnapchatReportingOrganicConversionSwipeUpWindow {
    ConversionSwipeUpWindowUnset = "CONVERSION_SWIPE_UP_WINDOW_UNSET",
    SwipeUp_1Day = "SWIPE_UP_1_DAY",
    SwipeUp_7Day = "SWIPE_UP_7_DAY",
    SwipeUp_28Day = "SWIPE_UP_28_DAY",
}

export enum SnapchatReportingOrganicConversionViewWindow {
    ConversionViewWindowUnset = "CONVERSION_VIEW_WINDOW_UNSET",
    View_1Day = "VIEW_1_DAY",
    View_1Hour = "VIEW_1_HOUR",
    View_3Hour = "VIEW_3_HOUR",
    View_6Hour = "VIEW_6_HOUR",
    View_7Day = "VIEW_7_DAY",
}

export type SnapchatReportingOrganicGetOrganicStatsRequest = {
    readonly __typename?: "SnapchatReportingOrganicGetOrganicStatsRequest";
    readonly assetId?: Maybe<Scalars["String"]["output"]>;
    readonly assetType?: Maybe<SnapchatReportingOrganicAssetType>;
    readonly breakdownAssetType?: Maybe<SnapchatReportingOrganicAssetType>;
    readonly breakdownIds?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    readonly conversionReportTime?: Maybe<SnapchatReportingOrganicConversionReportTime>;
    readonly conversionSourceType?: Maybe<SnapchatReportingOrganicConversionSourceType>;
    readonly conversionSwipeUpWindow?: Maybe<SnapchatReportingOrganicConversionSwipeUpWindow>;
    readonly conversionViewWindow?: Maybe<SnapchatReportingOrganicConversionViewWindow>;
    readonly endTime?: Maybe<GoogleProtobufTimestamp>;
    readonly fields?: Maybe<ReadonlyArray<Maybe<SnapchatReportingOrganicOrganicStatsField>>>;
    readonly granularity?: Maybe<SnapchatReportingOrganicGranularity>;
    readonly isTest?: Maybe<Scalars["Boolean"]["output"]>;
    readonly limit?: Maybe<Scalars["Int"]["output"]>;
    readonly offset?: Maybe<Scalars["Int"]["output"]>;
    readonly placeCollectionId?: Maybe<Scalars["String"]["output"]>;
    readonly profileId?: Maybe<Scalars["String"]["output"]>;
    readonly publisherId?: Maybe<Scalars["String"]["output"]>;
    readonly requestId?: Maybe<Scalars["String"]["output"]>;
    readonly requestType?: Maybe<SnapchatReportingOrganicRequestType>;
    readonly sortBy?: Maybe<SnapchatReportingOrganicMetricField>;
    readonly sortByDimension?: Maybe<SnapchatReportingOrganicUserDimension>;
    readonly sortByDimensionBreakdowns?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]["output"]>>>;
    readonly sortDirection?: Maybe<SnapchatReportingOrganicSortDirection>;
    readonly startTime?: Maybe<GoogleProtobufTimestamp>;
    readonly topDimensionLimit?: Maybe<Scalars["Int"]["output"]>;
    readonly userId?: Maybe<Scalars["String"]["output"]>;
};

export type SnapchatReportingOrganicGetOrganicStatsResponse = {
    readonly __typename?: "SnapchatReportingOrganicGetOrganicStatsResponse";
    readonly responseEntry?: Maybe<ReadonlyArray<Maybe<SnapchatReportingOrganicOrganicStatsResponseEntry>>>;
};

export enum SnapchatReportingOrganicGranularity {
    Day = "DAY",
    GranularityUnset = "GRANULARITY_UNSET",
    Hour = "HOUR",
    Lifetime = "LIFETIME",
    Month = "MONTH",
    Total = "TOTAL",
}

export enum SnapchatReportingOrganicMetricField {
    AddToCart = "ADD_TO_CART",
    AdsSubscribes = "ADS_SUBSCRIBES",
    AdCompletes = "AD_COMPLETES",
    AdQuartile_1 = "AD_QUARTILE_1",
    AdQuartile_2 = "AD_QUARTILE_2",
    AdQuartile_3 = "AD_QUARTILE_3",
    AttachmentConversion = "ATTACHMENT_CONVERSION",
    AttachmentViewers = "ATTACHMENT_VIEWERS",
    AttachmentViewersInsight = "ATTACHMENT_VIEWERS_INSIGHT",
    AttachmentViews = "ATTACHMENT_VIEWS",
    AttachmentViewTimeMillis = "ATTACHMENT_VIEW_TIME_MILLIS",
    AverageInteractionTime = "AVERAGE_INTERACTION_TIME",
    AverageUserViewTime = "AVERAGE_USER_VIEW_TIME",
    AvgViewTimeMillis = "AVG_VIEW_TIME_MILLIS",
    CameraPlayTimeMillis = "CAMERA_PLAY_TIME_MILLIS",
    CaptureRate = "CAPTURE_RATE",
    ChatUniques = "CHAT_UNIQUES",
    Completes = "COMPLETES",
    CompleteSnapViewers = "COMPLETE_SNAP_VIEWERS",
    CompleteSnapViews = "COMPLETE_SNAP_VIEWS",
    ConversionAchievementUnlocked = "CONVERSION_ACHIEVEMENT_UNLOCKED",
    ConversionAchievementUnlockedSwipeUp = "CONVERSION_ACHIEVEMENT_UNLOCKED_SWIPE_UP",
    ConversionAchievementUnlockedView = "CONVERSION_ACHIEVEMENT_UNLOCKED_VIEW",
    ConversionAddBilling = "CONVERSION_ADD_BILLING",
    ConversionAddBillingSwipeUp = "CONVERSION_ADD_BILLING_SWIPE_UP",
    ConversionAddBillingView = "CONVERSION_ADD_BILLING_VIEW",
    ConversionAddCart = "CONVERSION_ADD_CART",
    ConversionAddCartSwipeUp = "CONVERSION_ADD_CART_SWIPE_UP",
    ConversionAddCartView = "CONVERSION_ADD_CART_VIEW",
    ConversionAddToWishlist = "CONVERSION_ADD_TO_WISHLIST",
    ConversionAddToWishlistSwipeUp = "CONVERSION_ADD_TO_WISHLIST_SWIPE_UP",
    ConversionAddToWishlistView = "CONVERSION_ADD_TO_WISHLIST_VIEW",
    ConversionAdClick = "CONVERSION_AD_CLICK",
    ConversionAdClickSwipeUp = "CONVERSION_AD_CLICK_SWIPE_UP",
    ConversionAdClickView = "CONVERSION_AD_CLICK_VIEW",
    ConversionAdView = "CONVERSION_AD_VIEW",
    ConversionAdViewSwipeUp = "CONVERSION_AD_VIEW_SWIPE_UP",
    ConversionAdViewView = "CONVERSION_AD_VIEW_VIEW",
    ConversionAppOpens = "CONVERSION_APP_OPENS",
    ConversionAppOpensSwipeUp = "CONVERSION_APP_OPENS_SWIPE_UP",
    ConversionAppOpensView = "CONVERSION_APP_OPENS_VIEW",
    ConversionCompleteTutorial = "CONVERSION_COMPLETE_TUTORIAL",
    ConversionCompleteTutorialSwipeUp = "CONVERSION_COMPLETE_TUTORIAL_SWIPE_UP",
    ConversionCompleteTutorialView = "CONVERSION_COMPLETE_TUTORIAL_VIEW",
    ConversionInvite = "CONVERSION_INVITE",
    ConversionInviteSwipeUp = "CONVERSION_INVITE_SWIPE_UP",
    ConversionInviteView = "CONVERSION_INVITE_VIEW",
    ConversionLevelCompletes = "CONVERSION_LEVEL_COMPLETES",
    ConversionLevelCompletesSwipeUp = "CONVERSION_LEVEL_COMPLETES_SWIPE_UP",
    ConversionLevelCompletesView = "CONVERSION_LEVEL_COMPLETES_VIEW",
    ConversionListView = "CONVERSION_LIST_VIEW",
    ConversionListViewSwipeUp = "CONVERSION_LIST_VIEW_SWIPE_UP",
    ConversionListViewView = "CONVERSION_LIST_VIEW_VIEW",
    ConversionLogin = "CONVERSION_LOGIN",
    ConversionLoginSwipeUp = "CONVERSION_LOGIN_SWIPE_UP",
    ConversionLoginView = "CONVERSION_LOGIN_VIEW",
    ConversionPageViews = "CONVERSION_PAGE_VIEWS",
    ConversionPageViewsSwipeUp = "CONVERSION_PAGE_VIEWS_SWIPE_UP",
    ConversionPageViewsView = "CONVERSION_PAGE_VIEWS_VIEW",
    ConversionPurchases = "CONVERSION_PURCHASES",
    ConversionPurchasesCurrencyValue = "CONVERSION_PURCHASES_CURRENCY_VALUE",
    ConversionPurchasesSwipeUp = "CONVERSION_PURCHASES_SWIPE_UP",
    ConversionPurchasesValueSwipeUp = "CONVERSION_PURCHASES_VALUE_SWIPE_UP",
    ConversionPurchasesValueView = "CONVERSION_PURCHASES_VALUE_VIEW",
    ConversionPurchasesView = "CONVERSION_PURCHASES_VIEW",
    ConversionRate = "CONVERSION_RATE",
    ConversionRateSwipeUp = "CONVERSION_RATE_SWIPE_UP",
    ConversionRateView = "CONVERSION_RATE_VIEW",
    ConversionReserve = "CONVERSION_RESERVE",
    ConversionReserveSwipeUp = "CONVERSION_RESERVE_SWIPE_UP",
    ConversionReserveView = "CONVERSION_RESERVE_VIEW",
    ConversionSave = "CONVERSION_SAVE",
    ConversionSaveSwipeUp = "CONVERSION_SAVE_SWIPE_UP",
    ConversionSaveView = "CONVERSION_SAVE_VIEW",
    ConversionSearches = "CONVERSION_SEARCHES",
    ConversionSearchesSwipeUp = "CONVERSION_SEARCHES_SWIPE_UP",
    ConversionSearchesView = "CONVERSION_SEARCHES_VIEW",
    ConversionShare = "CONVERSION_SHARE",
    ConversionShareSwipeUp = "CONVERSION_SHARE_SWIPE_UP",
    ConversionShareView = "CONVERSION_SHARE_VIEW",
    ConversionSignUps = "CONVERSION_SIGN_UPS",
    ConversionSignUpsSwipeUp = "CONVERSION_SIGN_UPS_SWIPE_UP",
    ConversionSignUpsView = "CONVERSION_SIGN_UPS_VIEW",
    ConversionSpendCredits = "CONVERSION_SPEND_CREDITS",
    ConversionSpendCreditsSwipeUp = "CONVERSION_SPEND_CREDITS_SWIPE_UP",
    ConversionSpendCreditsView = "CONVERSION_SPEND_CREDITS_VIEW",
    ConversionStartCheckout = "CONVERSION_START_CHECKOUT",
    ConversionStartCheckoutSwipeUp = "CONVERSION_START_CHECKOUT_SWIPE_UP",
    ConversionStartCheckoutView = "CONVERSION_START_CHECKOUT_VIEW",
    ConversionStartTrial = "CONVERSION_START_TRIAL",
    ConversionStartTrialSwipeUp = "CONVERSION_START_TRIAL_SWIPE_UP",
    ConversionStartTrialView = "CONVERSION_START_TRIAL_VIEW",
    ConversionSubscribe = "CONVERSION_SUBSCRIBE",
    ConversionSubscribeSwipeUp = "CONVERSION_SUBSCRIBE_SWIPE_UP",
    ConversionSubscribeView = "CONVERSION_SUBSCRIBE_VIEW",
    ConversionViewContent = "CONVERSION_VIEW_CONTENT",
    ConversionViewContentSwipeUp = "CONVERSION_VIEW_CONTENT_SWIPE_UP",
    ConversionViewContentView = "CONVERSION_VIEW_CONTENT_VIEW",
    ConversionVisit = "CONVERSION_VISIT",
    ConversionVisitSwipeUp = "CONVERSION_VISIT_SWIPE_UP",
    ConversionVisitView = "CONVERSION_VISIT_VIEW",
    CoreUsers = "CORE_USERS",
    Creates = "CREATES",
    DailyUniques = "DAILY_UNIQUES",
    DigitalGoodCardCancel = "DIGITAL_GOOD_CARD_CANCEL",
    DigitalGoodCardOpens = "DIGITAL_GOOD_CARD_OPENS",
    DigitalGoodPurchase = "DIGITAL_GOOD_PURCHASE",
    DigitalGoodPurchasesPerUser = "DIGITAL_GOOD_PURCHASES_PER_USER",
    DigitalGoodTokenEarned = "DIGITAL_GOOD_TOKEN_EARNED",
    DigitalGoodUniquePurchasers = "DIGITAL_GOOD_UNIQUE_PURCHASERS",
    DownloadTime = "DOWNLOAD_TIME",
    DropOffRate = "DROP_OFF_RATE",
    Ecpm = "ECPM",
    ExternalStoreClick = "EXTERNAL_STORE_CLICK",
    Favorites = "FAVORITES",
    FilledImpressions = "FILLED_IMPRESSIONS",
    FrequentUsers = "FREQUENT_USERS",
    /** @deprecated deprecated in proto */
    HighlightAvgViewTimeMillis = "HIGHLIGHT_AVG_VIEW_TIME_MILLIS",
    /** @deprecated deprecated in proto */
    HighlightSubscribes = "HIGHLIGHT_SUBSCRIBES",
    /** @deprecated deprecated in proto */
    HighlightUniques = "HIGHLIGHT_UNIQUES",
    /** @deprecated deprecated in proto */
    HighlightViews = "HIGHLIGHT_VIEWS",
    /** @deprecated deprecated in proto */
    HighlightViewTimeMillis = "HIGHLIGHT_VIEW_TIME_MILLIS",
    Interactions = "INTERACTIONS",
    InteractionTime = "INTERACTION_TIME",
    LensAveragePlaytimeMillis = "LENS_AVERAGE_PLAYTIME_MILLIS",
    LensAvgViewTimeMillis = "LENS_AVG_VIEW_TIME_MILLIS",
    LensCommandKeywordDetected = "LENS_COMMAND_KEYWORD_DETECTED",
    LensDauOverMau = "LENS_DAU_OVER_MAU",
    LensDauOverWau = "LENS_DAU_OVER_WAU",
    LensFaceFound = "LENS_FACE_FOUND",
    LensFaceLost = "LENS_FACE_LOST",
    LensLanguageDisplayed = "LENS_LANGUAGE_DISPLAYED",
    LensLongPlays = "LENS_LONG_PLAYS",
    LensLongPlayRatio = "LENS_LONG_PLAY_RATIO",
    LensMarkerTracked = "LENS_MARKER_TRACKED",
    LensMau = "LENS_MAU",
    LensMultiuserSessionJoined = "LENS_MULTIUSER_SESSION_JOINED",
    LensMultiuserSessionShared = "LENS_MULTIUSER_SESSION_SHARED",
    LensMultiuserSessionStarted = "LENS_MULTIUSER_SESSION_STARTED",
    LensObjectTracked = "LENS_OBJECT_TRACKED",
    LensObjectTracked_3D = "LENS_OBJECT_TRACKED_3D",
    LensPlays = "LENS_PLAYS",
    LensPlaysLast_90Days = "LENS_PLAYS_LAST_90_DAYS",
    LensPosterUniques = "LENS_POSTER_UNIQUES",
    LensPosterUniquesS11 = "LENS_POSTER_UNIQUES_S11",
    LensPosterUniquesUs = "LENS_POSTER_UNIQUES_US",
    LensPosts = "LENS_POSTS",
    LensPrivateStoryPosts = "LENS_PRIVATE_STORY_POSTS",
    LensPublicStoryPosts = "LENS_PUBLIC_STORY_POSTS",
    LensShares = "LENS_SHARES",
    LensSnapcodeScans = "LENS_SNAPCODE_SCANS",
    LensSpotlightPosterUniques = "LENS_SPOTLIGHT_POSTER_UNIQUES",
    LensSpotlightPosterUniquesS11 = "LENS_SPOTLIGHT_POSTER_UNIQUES_S11",
    LensSpotlightPosterUniquesUs = "LENS_SPOTLIGHT_POSTER_UNIQUES_US",
    LensSpotlightPosts = "LENS_SPOTLIGHT_POSTS",
    LensSubscribers = "LENS_SUBSCRIBERS",
    LensSubscribersGained = "LENS_SUBSCRIBERS_GAINED",
    LensSubscribes = "LENS_SUBSCRIBES",
    LensTap = "LENS_TAP",
    LensTouchEnded = "LENS_TOUCH_ENDED",
    LensTouchMoved = "LENS_TOUCH_MOVED",
    LensTouchStart = "LENS_TOUCH_START",
    LensUniques = "LENS_UNIQUES",
    LensViewers = "LENS_VIEWERS",
    LensViews = "LENS_VIEWS",
    LensViewTimeMillis = "LENS_VIEW_TIME_MILLIS",
    LensVoiceKeywordDetected = "LENS_VOICE_KEYWORD_DETECTED",
    LensVoiceTranscribed = "LENS_VOICE_TRANSCRIBED",
    LongImpressions = "LONG_IMPRESSIONS",
    LoyalUsers = "LOYAL_USERS",
    MetricFieldUnset = "METRIC_FIELD_UNSET",
    NetRevenue = "NET_REVENUE",
    NewUsers = "NEW_USERS",
    NonSubscribeAttachmentView = "NON_SUBSCRIBE_ATTACHMENT_VIEW",
    NonSubscribeAttachmentViewer = "NON_SUBSCRIBE_ATTACHMENT_VIEWER",
    PlacesCalls = "PLACES_CALLS",
    PlacesCheckIns = "PLACES_CHECK_INS",
    PlacesDirectionRequests = "PLACES_DIRECTION_REQUESTS",
    PlacesFavorites = "PLACES_FAVORITES",
    PlacesHoursRequests = "PLACES_HOURS_REQUESTS",
    PlacesMenuVisits = "PLACES_MENU_VISITS",
    PlacesOrders = "PLACES_ORDERS",
    PlacesPhysicalVisitors = "PLACES_PHYSICAL_VISITORS",
    PlacesPhysicalVisits = "PLACES_PHYSICAL_VISITS",
    PlacesUniqueHoursRequests = "PLACES_UNIQUE_HOURS_REQUESTS",
    PlacesUniqueUserCalls = "PLACES_UNIQUE_USER_CALLS",
    PlacesUniqueUserDirectionRequests = "PLACES_UNIQUE_USER_DIRECTION_REQUESTS",
    PlacesUniqueUserMenuVisits = "PLACES_UNIQUE_USER_MENU_VISITS",
    PlacesUniqueUserOrders = "PLACES_UNIQUE_USER_ORDERS",
    PlacesViewers = "PLACES_VIEWERS",
    PlacesViews = "PLACES_VIEWS",
    PlacesVisitFrequency = "PLACES_VISIT_FREQUENCY",
    PlayTimeMillis = "PLAY_TIME_MILLIS",
    PlayTimeMillisLast_90Days = "PLAY_TIME_MILLIS_LAST_90_DAYS",
    ProductAvgPlayTimeMillis = "PRODUCT_AVG_PLAY_TIME_MILLIS",
    ProductPlays = "PRODUCT_PLAYS",
    ProductPlayTimeMillis = "PRODUCT_PLAY_TIME_MILLIS",
    ProductShares = "PRODUCT_SHARES",
    ProductSwipes = "PRODUCT_SWIPES",
    ProfilePaidViews = "PROFILE_PAID_VIEWS",
    ProfileViews = "PROFILE_VIEWS",
    QrScans = "QR_SCANS",
    Replies = "REPLIES",
    Requests = "REQUESTS",
    ReturningUsers = "RETURNING_USERS",
    Revenue = "REVENUE",
    SavedStoryAvgViewTimeMillis = "SAVED_STORY_AVG_VIEW_TIME_MILLIS",
    SavedStoryFavorites = "SAVED_STORY_FAVORITES",
    SavedStoryScreenshots = "SAVED_STORY_SCREENSHOTS",
    SavedStorySharedRecipientCount = "SAVED_STORY_SHARED_RECIPIENT_COUNT",
    SavedStoryShares = "SAVED_STORY_SHARES",
    SavedStorySnapAvgViewTimeMillis = "SAVED_STORY_SNAP_AVG_VIEW_TIME_MILLIS",
    SavedStorySnapCombinedUniques = "SAVED_STORY_SNAP_COMBINED_UNIQUES",
    SavedStorySnapCombinedViews = "SAVED_STORY_SNAP_COMBINED_VIEWS",
    SavedStorySnapPaidUniques = "SAVED_STORY_SNAP_PAID_UNIQUES",
    SavedStorySnapPaidViews = "SAVED_STORY_SNAP_PAID_VIEWS",
    SavedStorySnapSharers = "SAVED_STORY_SNAP_SHARERS",
    SavedStorySnapViewers = "SAVED_STORY_SNAP_VIEWERS",
    SavedStorySnapViewersInsight = "SAVED_STORY_SNAP_VIEWERS_INSIGHT",
    SavedStorySnapViews = "SAVED_STORY_SNAP_VIEWS",
    SavedStorySubscribes = "SAVED_STORY_SUBSCRIBES",
    SavedStoryUniques = "SAVED_STORY_UNIQUES",
    SavedStoryViewers = "SAVED_STORY_VIEWERS",
    SavedStoryViews = "SAVED_STORY_VIEWS",
    SavedStoryViewTimeMillis = "SAVED_STORY_VIEW_TIME_MILLIS",
    Scans = "SCANS",
    ScanAvgPlayTimeMillis = "SCAN_AVG_PLAY_TIME_MILLIS",
    ScanLensFavorites = "SCAN_LENS_FAVORITES",
    ScanLensLongPlays = "SCAN_LENS_LONG_PLAYS",
    ScanLensOnlyViewers = "SCAN_LENS_ONLY_VIEWERS",
    ScanLensPlays = "SCAN_LENS_PLAYS",
    ScanLensPlayTimeMillis = "SCAN_LENS_PLAY_TIME_MILLIS",
    ScanLensShares = "SCAN_LENS_SHARES",
    ScanLensSubscribes = "SCAN_LENS_SUBSCRIBES",
    ScanLensSwipeUps = "SCAN_LENS_SWIPE_UPS",
    ScanLensUniques = "SCAN_LENS_UNIQUES",
    ScanLensViews = "SCAN_LENS_VIEWS",
    ScanLensViewTimeMillis = "SCAN_LENS_VIEW_TIME_MILLIS",
    Screenshots = "SCREENSHOTS",
    Shares = "SHARES",
    SnapcodeScans = "SNAPCODE_SCANS",
    SnapCombinedUniques = "SNAP_COMBINED_UNIQUES",
    SnapCombinedViews = "SNAP_COMBINED_VIEWS",
    SnapPaidUniques = "SNAP_PAID_UNIQUES",
    SnapPaidViews = "SNAP_PAID_VIEWS",
    SnapViewers = "SNAP_VIEWERS",
    SnapViews = "SNAP_VIEWS",
    SnapViewTimeMillis = "SNAP_VIEW_TIME_MILLIS",
    SnapWithAttachmentView = "SNAP_WITH_ATTACHMENT_VIEW",
    SnapWithAttachmentViewer = "SNAP_WITH_ATTACHMENT_VIEWER",
    SocialUnlocks = "SOCIAL_UNLOCKS",
    SpotlightAvgViewTimeMillis = "SPOTLIGHT_AVG_VIEW_TIME_MILLIS",
    SpotlightCombinedUniques = "SPOTLIGHT_COMBINED_UNIQUES",
    SpotlightCombinedViews = "SPOTLIGHT_COMBINED_VIEWS",
    SpotlightFavorites = "SPOTLIGHT_FAVORITES",
    SpotlightPaidUniques = "SPOTLIGHT_PAID_UNIQUES",
    SpotlightPaidViews = "SPOTLIGHT_PAID_VIEWS",
    SpotlightScreenshots = "SPOTLIGHT_SCREENSHOTS",
    SpotlightShares = "SPOTLIGHT_SHARES",
    SpotlightSubscribersGained = "SPOTLIGHT_SUBSCRIBERS_GAINED",
    SpotlightSubscribes = "SPOTLIGHT_SUBSCRIBES",
    SpotlightUniques = "SPOTLIGHT_UNIQUES",
    SpotlightViews = "SPOTLIGHT_VIEWS",
    SpotlightViewTimeMillis = "SPOTLIGHT_VIEW_TIME_MILLIS",
    StoreCategoryView = "STORE_CATEGORY_VIEW",
    StoreCategoryViewer = "STORE_CATEGORY_VIEWER",
    StorePageView = "STORE_PAGE_VIEW",
    StoreProductView = "STORE_PRODUCT_VIEW",
    StoreProductViewer = "STORE_PRODUCT_VIEWER",
    StoreViewTime = "STORE_VIEW_TIME",
    StoreVisitors = "STORE_VISITORS",
    StoryAvgViewTimeMillis = "STORY_AVG_VIEW_TIME_MILLIS",
    StoryFavorites = "STORY_FAVORITES",
    StorySubscribers = "STORY_SUBSCRIBERS",
    StorySubscribersGained = "STORY_SUBSCRIBERS_GAINED",
    StorySubscribes = "STORY_SUBSCRIBES",
    StoryUniques = "STORY_UNIQUES",
    StoryViewers = "STORY_VIEWERS",
    StoryViews = "STORY_VIEWS",
    StoryViewTimeMillis = "STORY_VIEW_TIME_MILLIS",
    Subscribers = "SUBSCRIBERS",
    SubscribersGained = "SUBSCRIBERS_GAINED",
    Subscribes = "SUBSCRIBES",
    SwipeDowns = "SWIPE_DOWNS",
    SwipeUps = "SWIPE_UPS",
    TapBack = "TAP_BACK",
    TapForward = "TAP_FORWARD",
    TextAttachmentViews = "TEXT_ATTACHMENT_VIEWS",
    TileAvgSnapViewed = "TILE_AVG_SNAP_VIEWED",
    TileAvgTimeViewed = "TILE_AVG_TIME_VIEWED",
    TileCtr = "TILE_CTR",
    TileIndexCtr = "TILE_INDEX_CTR",
    TileSnapViewer = "TILE_SNAP_VIEWER",
    TileTap = "TILE_TAP",
    TileView = "TILE_VIEW",
    TileViewer = "TILE_VIEWER",
    TileViewRatio = "TILE_VIEW_RATIO",
    TileViewTime = "TILE_VIEW_TIME",
    UniqueLensSnapCreates = "UNIQUE_LENS_SNAP_CREATES",
    UniqueProductsViewed = "UNIQUE_PRODUCTS_VIEWED",
    UniqueScreenshots = "UNIQUE_SCREENSHOTS",
    UniqueSessions = "UNIQUE_SESSIONS",
    UniqueSwipers = "UNIQUE_SWIPERS",
    UniqueTopsnapPerUser = "UNIQUE_TOPSNAP_PER_USER",
    UniqueTopsnapViews = "UNIQUE_TOPSNAP_VIEWS",
    UniqueTopsnapViewsInsight = "UNIQUE_TOPSNAP_VIEWS_INSIGHT",
    Unsubscribes = "UNSUBSCRIBES",
    VideoAttachmentViews = "VIDEO_ATTACHMENT_VIEWS",
    Viewers = "VIEWERS",
    ViewersInsight = "VIEWERS_INSIGHT",
    Views = "VIEWS",
    ViewTimeMillis = "VIEW_TIME_MILLIS",
}

export type SnapchatReportingOrganicOrganicStat = {
    readonly __typename?: "SnapchatReportingOrganicOrganicStat";
    readonly dimensionBreakdown?: Maybe<Scalars["String"]["output"]>;
    readonly percentageValue?: Maybe<Scalars["Float"]["output"]>;
    readonly value?: Maybe<Scalars["String"]["output"]>;
};

export type SnapchatReportingOrganicOrganicStatsField = {
    readonly __typename?: "SnapchatReportingOrganicOrganicStatsField";
    readonly fieldName?: Maybe<SnapchatReportingOrganicMetricField>;
    readonly reportDimension?: Maybe<SnapchatReportingOrganicUserDimension>;
    readonly reportDimensionFilters?: Maybe<ReadonlyArray<Maybe<Scalars["Int"]["output"]>>>;
};

export type SnapchatReportingOrganicOrganicStatsResponseDimensionEntry = {
    readonly __typename?: "SnapchatReportingOrganicOrganicStatsResponseDimensionEntry";
    readonly field?: Maybe<SnapchatReportingOrganicOrganicStatsField>;
    readonly stats?: Maybe<ReadonlyArray<Maybe<SnapchatReportingOrganicOrganicStat>>>;
};

export type SnapchatReportingOrganicOrganicStatsResponseEntry = {
    readonly __typename?: "SnapchatReportingOrganicOrganicStatsResponseEntry";
    readonly assetId?: Maybe<Scalars["String"]["output"]>;
    readonly assetType?: Maybe<SnapchatReportingOrganicAssetType>;
    readonly statsResponseTimeEntry?: Maybe<
        ReadonlyArray<Maybe<SnapchatReportingOrganicOrganicStatsResponseTimeEntry>>
    >;
};

export type SnapchatReportingOrganicOrganicStatsResponseTimeEntry = {
    readonly __typename?: "SnapchatReportingOrganicOrganicStatsResponseTimeEntry";
    readonly stats?: Maybe<ReadonlyArray<Maybe<SnapchatReportingOrganicOrganicStatsResponseDimensionEntry>>>;
    readonly timestamp?: Maybe<GoogleProtobufTimestamp>;
};

export enum SnapchatReportingOrganicRequestType {
    PlaceRequest = "PLACE_REQUEST",
    PublicProfile = "PUBLIC_PROFILE",
    PublisherReport = "PUBLISHER_REPORT",
    StoreReport = "STORE_REPORT",
    Unset = "UNSET",
}

export enum SnapchatReportingOrganicSortDirection {
    SortDirectionAsc = "SORT_DIRECTION_ASC",
    SortDirectionDesc = "SORT_DIRECTION_DESC",
    SortDirectionUnset = "SORT_DIRECTION_UNSET",
}

export enum SnapchatReportingOrganicUserDimension {
    Age = "AGE",
    AgeGender = "AGE_GENDER",
    Country = "COUNTRY",
    CountryAge = "COUNTRY_AGE",
    CountryGender = "COUNTRY_GENDER",
    CountryGenderSponsorType = "COUNTRY_GENDER_SPONSOR_TYPE",
    CountrySponsorType = "COUNTRY_SPONSOR_TYPE",
    CountrySubscription = "COUNTRY_SUBSCRIPTION",
    CountrySubscriptionSponsorType = "COUNTRY_SUBSCRIPTION_SPONSOR_TYPE",
    DigitalGood = "DIGITAL_GOOD",
    FormatType = "FORMAT_TYPE",
    Gender = "GENDER",
    InterestCategoryId = "INTEREST_CATEGORY_ID",
    Os = "OS",
    Placement = "PLACEMENT",
    Platform = "PLATFORM",
    Product = "PRODUCT",
    ProductCategory = "PRODUCT_CATEGORY",
    Region = "REGION",
    RevenueType = "REVENUE_TYPE",
    RevenueTypeInternal = "REVENUE_TYPE_INTERNAL",
    SdkVersion = "SDK_VERSION",
    SponsorType = "SPONSOR_TYPE",
    Subscription = "SUBSCRIPTION",
    UserDimensionUnset = "USER_DIMENSION_UNSET",
}

export type Snapcode = {
    readonly __typename?: "Snapcode";
    readonly deeplink: Scalars["String"]["output"];
    readonly expiresAt?: Maybe<GoogleProtobufTimestamp>;
    readonly imageUrl: Scalars["String"]["output"];
    readonly isTemporary: Scalars["Boolean"]["output"];
};

export enum SortBy {
    SortByDate = "SORT_BY_DATE",
    SortByName = "SORT_BY_NAME",
    SortByStatus = "SORT_BY_STATUS",
    SortByUnset = "SORT_BY_UNSET",
}

export enum SpecApprovalState {
    ApprovalStateUnset = "APPROVAL_STATE_UNSET",
    Approved = "APPROVED",
    Blocked = "BLOCKED",
    InReview = "IN_REVIEW",
}

export enum SpecVisibility {
    Private = "PRIVATE",
    VisibilityUnset = "VISIBILITY_UNSET",
}

export enum SpotlightStoriesAssetType {
    Lens = "LENS",
    LensCreator = "LENS_CREATOR",
    LensFolder = "LENS_FOLDER",
    Organization = "ORGANIZATION",
}

export type SpotlightStoriesInput = {
    /** Currently ignored for LENS_CREATOR asset type. Reserved for future LENS, LENS_FOLDER, and ORGANIZATION support. */
    readonly assetId?: InputMaybe<Scalars["String"]["input"]>;
    readonly assetType: SpotlightStoriesAssetType;
    readonly sortBy?: InputMaybe<SpotlightStoriesMetricField>;
};

export enum SpotlightStoriesMetricField {
    Sends = "SENDS",
    Subscribes = "SUBSCRIBES",
    Views = "VIEWS",
}

export type SpotlightStoriesResponse = {
    readonly __typename?: "SpotlightStoriesResponse";
    readonly stories: ReadonlyArray<SpotlightStory>;
};

export type SpotlightStory = {
    readonly __typename?: "SpotlightStory";
    readonly folderId: Scalars["String"]["output"];
    readonly lensCreatorId: Scalars["String"]["output"];
    readonly lensId: Scalars["String"]["output"];
    readonly mediaUrl: Scalars["String"]["output"];
    readonly orgId: Scalars["String"]["output"];
    readonly spotlightPosterId: Scalars["String"]["output"];
    readonly storySnapId: Scalars["String"]["output"];
    readonly submittedAt?: Maybe<Scalars["DateTime"]["output"]>;
    readonly unlockableId: Scalars["String"]["output"];
    readonly views: Scalars["Int"]["output"];
};

export type StudyTreatmentInfo = {
    readonly studyName: Scalars["String"]["input"];
    readonly treatmentId: Scalars["Int"]["input"];
};

export type SubmissionQuotaSummary = {
    readonly __typename?: "SubmissionQuotaSummary";
    readonly limitingQuotaType: SubmissionQuotaType;
    readonly limitingWindow: SubmissionQuotaWindow;
    readonly remaining: Scalars["Long"]["output"];
    readonly remainingPercentage: Scalars["Float"]["output"];
    readonly replenishAt: Scalars["DateTime"]["output"];
};

export enum SubmissionQuotaType {
    LensPlusPayoutSubmission = "LENS_PLUS_PAYOUT_SUBMISSION",
    LensSubmission = "LENS_SUBMISSION",
}

export enum SubmissionQuotaWindow {
    CalendarDay = "CALENDAR_DAY",
    CalendarMonth = "CALENDAR_MONTH",
}

export type SubmissionQuotas = {
    readonly __typename?: "SubmissionQuotas";
    readonly lensPlus?: Maybe<SubmissionQuotaSummary>;
    readonly regular?: Maybe<SubmissionQuotaSummary>;
};

export type SubmitAssetRequest = {
    readonly asset: Scalars["Upload"]["input"];
    readonly categories: ReadonlyArray<MyLensesAssetCategory>;
    readonly creatorAlias: Scalars["String"]["input"];
    readonly description: Scalars["String"]["input"];
    readonly documentationUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly license?: InputMaybe<Scalars["Upload"]["input"]>;
    readonly maxLensStudioVersion: Scalars["String"]["input"];
    readonly minLensStudioVersion: Scalars["String"]["input"];
    readonly name: Scalars["String"]["input"];
    readonly organizationId: Scalars["ID"]["input"];
    readonly organizationName: Scalars["String"]["input"];
    readonly thumbnail: Scalars["Upload"]["input"];
    readonly type?: InputMaybe<AssetType>;
};

export type SubmitAssetResponse = {
    readonly __typename?: "SubmitAssetResponse";
    readonly assetId: Scalars["String"]["output"];
};

export type SubmitWebLensRequest = {
    /** Lens Space (lens folder) to create the lens in — an id from getMyLensesOrganizations' lensSpacesList. Lens Central authorizes the caller against the folder (LENSES_CREATE) and refuses the submission otherwise. When omitted, the lens lands in the caller's app-default folder ('Lens Studio', find-or-created) — the pre-folder-selection behavior. */
    readonly folderId?: InputMaybe<Scalars["ID"]["input"]>;
    /** Creator-declared game marking, the same toggle the lens-submission flow carries — lands on Lens Central's CreateLens.isGameUserProvided. False = not a game. Defaulted rather than plainly required so that adding it to this already-shipped input stays non-breaking for deployed callers; the resolver always sees a definite boolean. */
    readonly isGameUserProvided?: Scalars["Boolean"]["input"];
    /** Enroll the lens in the Lens+ (exclusive lens) program — mirrors createLens' isMarkedExclusive. Creation is the only moment Lens Central accepts enrollment, and it requires PUBLIC visibility. The exclusive mark itself lands ~2 days after a Discover-enabling review approval, not at submit. Omitted/false = not enrolled. */
    readonly isMarkedExclusive?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Enroll the Lens in Top Performer Payouts (Lens Creator Rewards). */
    readonly lensCreatorPayoutEnrolled?: Scalars["Boolean"]["input"];
    /** True when a logo was also PUT to the same ticket's logo signed URL */
    readonly logoUploaded: Scalars["Boolean"]["input"];
    /** Lens display name, carried to Lens Central on CreateLens.name */
    readonly name: Scalars["String"]["input"];
    /** Upload ref from createWebLensUpload, after PUTting the package to its signed URL — the signed-URL direct upload is the only upload path. */
    readonly packageRef: Scalars["String"]["input"];
    /** Preview media uploadFile refs (FILE_TYPE_PREVIEW_MEDIA), attached at CreateLens time — the lens is locked against updates while processing, so post-create attachment is not possible. At least one preview is required. */
    readonly previewMediaUploadRefIds: ReadonlyArray<Scalars["ID"]["input"]>;
    readonly visibility: Visibility;
};

export type SubmitWebLensResponse = {
    readonly __typename?: "SubmitWebLensResponse";
    /** Created lens id; null when a submit-time check failed before creation */
    readonly lensId?: Maybe<Scalars["ID"]["output"]>;
    readonly status?: Maybe<MyLensesLensStatus>;
    /** Submit-time checks only, in execution order. The zip-to-lens conversion runs asynchronously after this call returns: archive validation failures (unbuilt project, unresolvable references, size limits) surface on the lens as an Invalid status with a creator-facing reason, not here. */
    readonly validation: ReadonlyArray<WebLensValidationCheck>;
};

export type SummaryViewSettingInput = {
    readonly _unused?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum SurfaceType {
    SurfaceTypeSnapchat = "SURFACE_TYPE_SNAPCHAT",
    SurfaceTypeSpectacles = "SURFACE_TYPE_SPECTACLES",
    SurfaceTypeUnset = "SURFACE_TYPE_UNSET",
}

export enum TargetPlatform {
    CameraKit = "CAMERA_KIT",
    Snapchat = "SNAPCHAT",
    Spectacles = "SPECTACLES",
    SpectaclesMobileApp = "SPECTACLES_MOBILE_APP",
    TargetPlatformUnset = "TARGET_PLATFORM_UNSET",
}

export type TopPerformerAward = {
    readonly __typename?: "TopPerformerAward";
    readonly amountMilliUsd: Scalars["Long"]["output"];
    readonly awardedMonth: Scalars["DateTime"]["output"];
    readonly paidOn?: Maybe<Scalars["DateTime"]["output"]>;
};

export type TopPerformerLens = {
    readonly __typename?: "TopPerformerLens";
    readonly award?: Maybe<TopPerformerAward>;
    readonly lens: MyLensesLens;
    readonly postersThreshold: Scalars["Int"]["output"];
    readonly qualifiedPosters?: Maybe<Scalars["Int"]["output"]>;
    readonly status: TopPerformerLensStatus;
    readonly windowEndsAt: Scalars["DateTime"]["output"];
};

export enum TopPerformerLensStatus {
    Awarded = "AWARDED",
    DidNotQualify = "DID_NOT_QUALIFY",
    InWindow = "IN_WINDOW",
    UnderReview = "UNDER_REVIEW",
}

export type TopPerformerLensesInput = {
    readonly lensSpaceId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type TopPerformerLensesResponse = {
    readonly __typename?: "TopPerformerLensesResponse";
    readonly awardedCount: Scalars["Int"]["output"];
    readonly enrolledCount: Scalars["Int"]["output"];
    readonly lenses: ReadonlyArray<TopPerformerLens>;
    readonly totalEarnedMilliUsd: Scalars["Long"]["output"];
};

export type Tos = {
    readonly __typename?: "Tos";
    readonly acceptedVersion?: Maybe<Scalars["Int"]["output"]>;
    readonly key: TosKey;
    readonly metadata?: Maybe<TosMetadata>;
};

export enum TosKey {
    IldgTos = "ILDG_TOS",
    LensCreatorPayoutTos = "LENS_CREATOR_PAYOUT_TOS",
}

export type TosMetadata = {
    readonly __typename?: "TosMetadata";
    /** @deprecated Use 'effectiveDate' field in individual 'terms' instead. This field will be removed in a future version. */
    readonly effectiveDate?: Maybe<Scalars["String"]["output"]>;
    readonly latestVersion: Scalars["Int"]["output"];
    /** @deprecated Use 'sourceUrl' field in individual 'terms' instead. This field will be removed in a future version. */
    readonly sourceUrl?: Maybe<Scalars["String"]["output"]>;
    readonly terms: ReadonlyArray<TosTerm>;
    /** @deprecated Use 'terms' field instead. This field will be removed in a future version. */
    readonly tosString?: Maybe<Scalars["String"]["output"]>;
};

export type TosTerm = {
    readonly __typename?: "TosTerm";
    readonly content: Scalars["String"]["output"];
    readonly effectiveDate: Scalars["String"]["output"];
    readonly key: Scalars["String"]["output"];
    readonly sourceUrl: Scalars["String"]["output"];
};

export type Trend = {
    readonly __typename?: "Trend";
    readonly name: Scalars["String"]["output"];
};

export type TrendingTag = {
    readonly __typename?: "TrendingTag";
    readonly event: Scalars["String"]["output"];
    readonly expiresAt: Scalars["DateTime"]["output"];
    readonly id: Scalars["ID"]["output"];
    readonly location: TrendingTagLocation;
    readonly tag: Scalars["String"]["output"];
};

export type TrendingTagLocation = {
    readonly __typename?: "TrendingTagLocation";
    readonly graphicUnicode: Scalars["String"]["output"];
    readonly name: Scalars["String"]["output"];
};

export type UpdateAssetRequest = {
    readonly asset: UrlOrUpload;
    readonly assetId: Scalars["ID"]["input"];
    readonly categories: ReadonlyArray<MyLensesAssetCategory>;
    readonly description: Scalars["String"]["input"];
    readonly documentationUrl?: InputMaybe<Scalars["String"]["input"]>;
    readonly license?: InputMaybe<UrlOrUpload>;
    readonly maxLensStudioVersion: Scalars["String"]["input"];
    readonly minLensStudioVersion: Scalars["String"]["input"];
    readonly name: Scalars["String"]["input"];
    readonly organizationId: Scalars["ID"]["input"];
    readonly thumbnail: UrlOrUpload;
};

export type UpdateAssetResponse = {
    readonly __typename?: "UpdateAssetResponse";
    readonly assetId: Scalars["String"]["output"];
};

export type UpdateHostedLensStatusRequest = {
    readonly id: Scalars["ID"]["input"];
    readonly status: HostedLensStatus;
};

export type UpdateHostedLensStatusResponse = {
    readonly __typename?: "UpdateHostedLensStatusResponse";
    readonly lens?: Maybe<HostedLens>;
};

export type UpdateLensRequest = {
    readonly creatorRewardProgramEnrolled?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly description?: InputMaybe<Scalars["String"]["input"]>;
    readonly isGameUserProvided?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly lensCta?: InputMaybe<MyLensesLensCtaInput>;
    readonly lensId: Scalars["ID"]["input"];
    readonly lensName?: InputMaybe<Scalars["String"]["input"]>;
    readonly previewMediaResources?: InputMaybe<ReadonlyArray<PreviewMediaResource>>;
    readonly profileVisibility?: InputMaybe<Visibility>;
    readonly releaseNote?: InputMaybe<Scalars["String"]["input"]>;
    readonly spectaclesTags?: InputMaybe<ReadonlyArray<Scalars["String"]["input"]>>;
    readonly submissionId?: InputMaybe<Scalars["ID"]["input"]>;
    readonly tags?: InputMaybe<ReadonlyArray<Scalars["String"]["input"]>>;
};

export type UpdateLensResponse = {
    readonly __typename?: "UpdateLensResponse";
    readonly lens: MyLensesLens;
};

export type UpdateRemoteAssetRequest = {
    readonly description: Scalars["String"]["input"];
    readonly forkingAllowed?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly id: Scalars["ID"]["input"];
    readonly name: Scalars["String"]["input"];
};

/** Update an existing lens with a freshly uploaded web-app package — any lens accepts one: the new LensVersion (same lens id, same snapcode) becomes a web lens and re-runs conversion, QA and (for a published lens) review. Refused while any version is processing. */
export type UpdateWebLensRequest = {
    /** Mark the lens as a game with this update — the same creator toggle as submission, landing on the new version. Marking only: the update call is maskless, where Lens Central honors true but cannot see an explicit false, so unmarking is not supported on this path. False = keep the current marking. Defaulted rather than plainly required so that adding it to this already-shipped input stays non-breaking for deployed callers. */
    readonly isGameUserProvided?: Scalars["Boolean"]["input"];
    /** Optional Top Performer Payouts (Lens Creator Rewards) enrollment change. Omitted or null keeps the current enrollment; true enrolls and false unenrolls. */
    readonly lensCreatorPayoutEnrolled?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** The lens to update — for web lenses, the id submitWebLens returned. */
    readonly lensId: Scalars["ID"]["input"];
    /** True when a replacement icon was also PUT to the same ticket's logo signed URL. False = keep: the previous version's icon is inherited when it has one (web-lens predecessors); a .lens-built predecessor's icon lives inside its package, so those updates fall back to the default icon. */
    readonly logoUploaded: Scalars["Boolean"]["input"];
    /** Optional rename, same constraints as submission. Omitted = keep the current name. */
    readonly name?: InputMaybe<Scalars["String"]["input"]>;
    /** Upload ref from createWebLensUpload, after PUTting the new package to its signed URL — same ticket flow as submission. */
    readonly packageRef: Scalars["String"]["input"];
    /** Replacement preview media for the lens, in display order — the same shape updateLens takes, so kept previews travel by mediaId alongside any newly uploaded uploadRefId. A non-empty list replaces the lens' previews; empty keeps them, since the maskless update path cannot clear previews (the same asymmetry as isGameUserProvided). The default preserves that keep behavior for callers that omit this newly added field while keeping the list non-null. Needed because marking a lens as a game requires a gameplay video, and previews are otherwise editable only on the lens page. */
    readonly previewMediaResources?: ReadonlyArray<PreviewMediaResource>;
    /** Optional visibility change. Omitted = keep the current visibility. Public, Hidden and Offline are valid published states. Do Not Publish to Snapchat is accepted only when the Lens has never been published. Lens+ Lenses must remain Public. */
    readonly visibility?: InputMaybe<Visibility>;
};

export type UploadFileRequest = {
    readonly file: Scalars["Upload"]["input"];
    readonly fileType: FileMetadataFileType;
};

export type UploadFileResponse = {
    readonly __typename?: "UploadFileResponse";
    readonly uploadRefId: Scalars["ID"]["output"];
};

/**
 * UrlOrUpload is a union type that can be either a URL or an upload.
 * Used to update an asset:
 *     - if URL is provided, means that the asset is already uploaded, no update needed
 *     - if Upload is provided, means that the new file needs to be uploaded
 *     - if both are provided, the Upload will be used
 *     - if neither are provided, and original Upload is optional, the field will be unset
 *     - if neither are provided, and original Upload is required, the field will be unchanged
 */
export type UrlOrUpload = {
    readonly upload?: InputMaybe<Scalars["Upload"]["input"]>;
    readonly url?: InputMaybe<Scalars["String"]["input"]>;
};

export type User = {
    readonly __typename?: "User";
    readonly avatarUrl: Scalars["String"]["output"];
    readonly creatorVerificationStatus?: Maybe<CreatorVerificationStatus>;
    readonly defaultOrganizationId: Scalars["ID"]["output"];
    readonly eulaData?: Maybe<EulaData>;
    readonly iconLink: Scalars["String"]["output"];
    readonly pageUrl: Scalars["String"]["output"];
    /** @deprecated NOT USED */
    readonly useNewLayout: Scalars["Boolean"]["output"];
    readonly userDisplayName: Scalars["String"]["output"];
    readonly userId: Scalars["ID"]["output"];
    readonly userPermissions?: Maybe<UserPermissions>;
};

export enum UserDimension {
    Age = "AGE",
    AgeGender = "AGE_GENDER",
    Country = "COUNTRY",
    CountryAge = "COUNTRY_AGE",
    CountryGender = "COUNTRY_GENDER",
    CountryGenderSponsorType = "COUNTRY_GENDER_SPONSOR_TYPE",
    CountrySponsorType = "COUNTRY_SPONSOR_TYPE",
    CountrySubscription = "COUNTRY_SUBSCRIPTION",
    CountrySubscriptionSponsorType = "COUNTRY_SUBSCRIPTION_SPONSOR_TYPE",
    DigitalGood = "DIGITAL_GOOD",
    FormatType = "FORMAT_TYPE",
    Gender = "GENDER",
    InterestCategoryId = "INTEREST_CATEGORY_ID",
    Os = "OS",
    Placement = "PLACEMENT",
    Platform = "PLATFORM",
    Product = "PRODUCT",
    ProductCategory = "PRODUCT_CATEGORY",
    Region = "REGION",
    RevenueType = "REVENUE_TYPE",
    RevenueTypeInternal = "REVENUE_TYPE_INTERNAL",
    SdkVersion = "SDK_VERSION",
    SponsorType = "SPONSOR_TYPE",
    Subscription = "SUBSCRIPTION",
    UserDimensionUnset = "USER_DIMENSION_UNSET",
}

export type UserPermissions = {
    readonly __typename?: "UserPermissions";
    readonly readGroups: Scalars["Boolean"]["output"];
    readonly readLensAnalytics: Scalars["Boolean"]["output"];
    readonly readLensSources: Scalars["Boolean"]["output"];
    readonly readLenses: Scalars["Boolean"]["output"];
    readonly scheduleLenses: Scalars["Boolean"]["output"];
    readonly updateGroups: Scalars["Boolean"]["output"];
    readonly updateLensSources: Scalars["Boolean"]["output"];
    readonly updateLenses: Scalars["Boolean"]["output"];
};

export type ValidateOnboardingTokenRequest = {
    readonly token?: InputMaybe<Scalars["String"]["input"]>;
};

export type ValidateOnboardingTokenResponse = {
    readonly __typename?: "ValidateOnboardingTokenResponse";
    readonly onboardingTokenStatus?: Maybe<ValidateTokenStatus>;
};

export enum ValidateTokenStatus {
    ValidateTokenStatusAvailable = "VALIDATE_TOKEN_STATUS_AVAILABLE",
    ValidateTokenStatusConsumed = "VALIDATE_TOKEN_STATUS_CONSUMED",
    ValidateTokenStatusRevoked = "VALIDATE_TOKEN_STATUS_REVOKED",
    ValidateTokenStatusUnset = "VALIDATE_TOKEN_STATUS_UNSET",
}

export type Value = {
    readonly __typename?: "Value";
    readonly boolValue: Scalars["Boolean"]["output"];
    readonly floatValue: Scalars["Float"]["output"];
    readonly intPairValue: Scalars["Int"]["output"];
    readonly intValue: Scalars["Int"]["output"];
    readonly longValue: Scalars["Float"]["output"];
    readonly stringValue: Scalars["String"]["output"];
};

export type VendorDataItem = {
    readonly __typename?: "VendorDataItem";
    readonly key?: Maybe<Scalars["String"]["output"]>;
    readonly value?: Maybe<Scalars["String"]["output"]>;
};

export enum Visibility {
    VisibilityDontPublishToSnapchat = "VISIBILITY_DONT_PUBLISH_TO_SNAPCHAT",
    VisibilityHidden = "VISIBILITY_HIDDEN",
    VisibilityOffline = "VISIBILITY_OFFLINE",
    VisibilityPublic = "VISIBILITY_PUBLIC",
    VisibilityUnset = "VISIBILITY_UNSET",
}

export enum WebLensCheckName {
    CreateLens = "CREATE_LENS",
    LogoReadable = "LOGO_READABLE",
    PackageReadable = "PACKAGE_READABLE",
    PushLens = "PUSH_LENS",
    UpdateLens = "UPDATE_LENS",
}

/**
 * A web-app conversion rejection — lens-bundle's status reason plus the machine key naming which
 * check refused the archive. The keys are the ones Lens Central turns into creator wording for
 * submitted lenses (web_app_dev_entry, web_app_missing_refs, web_app_security_review_failure, ...),
 * so the preview page can show the same text a submission would.
 */
export type WebLensConversionRejection = {
    readonly __typename?: "WebLensConversionRejection";
    /** The key's data fragment when it has one (a size limit, a file count, a list of missing references). Null for security findings, which are structured in findings. */
    readonly data?: Maybe<Scalars["String"]["output"]>;
    /** HIGH/CRITICAL security findings grouped by rule, when key is web_app_security_review_failure; empty otherwise. */
    readonly findings: ReadonlyArray<WebLensSecurityFinding>;
    /** Which check refused the archive, e.g. web_app_dev_entry. Null when the conversion reported no key. */
    readonly key?: Maybe<Scalars["String"]["output"]>;
    /** Findings beyond those listed, after the scanner's per-report cap. */
    readonly omittedCount: Scalars["Int"]["output"];
    /** lens-bundle's build status reason, e.g. WEB_APP_CONVERSION_FAILURE */
    readonly reason: Scalars["String"]["output"];
};

export type WebLensSecurityFinding = {
    readonly __typename?: "WebLensSecurityFinding";
    readonly column: Scalars["Int"]["output"];
    /** Archive path of one example occurrence */
    readonly file: Scalars["String"]["output"];
    readonly line: Scalars["Int"]["output"];
    /** How many places this rule fired across the archive */
    readonly occurrences: Scalars["Int"]["output"];
    /** Scanner rule id, e.g. WL-DEV-001 */
    readonly ruleId: Scalars["String"]["output"];
    readonly severity: WebLensSecuritySeverity;
};

export enum WebLensSecuritySeverity {
    Critical = "CRITICAL",
    High = "HIGH",
}

export type WebLensValidationCheck = {
    readonly __typename?: "WebLensValidationCheck";
    /** Curated, creator-facing detail, e.g. the uploaded size or an actionable failure reason */
    readonly detail?: Maybe<Scalars["String"]["output"]>;
    readonly name: WebLensCheckName;
    readonly passed: Scalars["Boolean"]["output"];
    /** Why the conversion refused a web-app archive, parsed from a failed PUSH_LENS row. Null for passes, pre-push failures, and push errors that are not conversion rejections. The portal maps it to localized copy; detail stays the verbatim fallback. */
    readonly rejection?: Maybe<WebLensConversionRejection>;
};

export type Service = {
    readonly __typename?: "_Service";
    readonly sdl?: Maybe<Scalars["String"]["output"]>;
};
